(function() {
  var fonts = [
    'Lato:wght@400;700',
    'Montserrat:wght@400;700',
    'Playfair+Display:ital,wght@0,400;0,700;1,400',
    'GFS+Didot',
    'Noto+Serif:wght@400;700',
    'EB+Garamond:ital,wght@0,400;0,700;1,400',
    'Pacifico',
    'Dancing+Script:wght@400;700',
    'Cormorant+Garamond:ital,wght@0,400;0,600;1,400',
    'Cinzel:wght@400;700',
    'Philosopher:wght@400;700',
    'Crimson+Pro:wght@400;700',
    'Ubuntu:wght@400;700',
    'Raleway:wght@400;700',
    'Roboto:wght@400;700',
    'Open+Sans:wght@400;700',
  ];
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=' + fonts.join('&family=') + '&display=swap';
  document.head.appendChild(link);
})();

﻿(function () {
  "use strict";

  var BACKEND_URL = "https://picture2magnet-backend-production.up.railway.app";

  setInterval(function () {
    fetch(BACKEND_URL + "/health", { method: "GET" }).catch(function () {});
  }, 5 * 60 * 1000);

  var TEMPLATE_SHAPES = {
    square_50x50:   { shape:"square", w:634,  h:634,  slotsPerSheet:6,  cols:2, rows:3, bleed:true,  landscape:false, hasText:false },
    rect_54x78: { shape:"rect", w:668, h:965, slotsPerSheet:6, cols:2, rows:3, bleed:true, landscape:false, hasText:false },
    photo_70x70:    { shape:"square", w:726,  h:726,  slotsPerSheet:12, cols:4, rows:3, bleed:false, landscape:false, hasText:false },
    photo_70x90:    { shape:"rect",   w:761,  h:1005, slotsPerSheet:8,  cols:4, rows:2, bleed:false, landscape:false, hasText:false },
    photo_80x100:   { shape:"rect",   w:886,  h:1121, slotsPerSheet:6,  cols:3, rows:2, bleed:false, landscape:false, hasText:false },
    std_70x90: { shape:"rect", w:761, h:650, textZoneH:323, slotsPerSheet:8, cols:4, rows:2, bleed:false, landscape:false, hasText:true,
  textLineY: { title:0.06, names:0.28, date:0.52, location:0.74 },
  textFields:[
        { key:"title",    label:"Save the Date", type:"font-select", required:true,
          fonts:["Pacifico","Playfair Display","Montserrat","Dancing Script","Lato","Cormorant Garamond"], allowCustom:true },
        { key:"names",    label:"Names",    type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"date",     label:"Date",     type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"location", label:"Location", type:"text", required:false, hasFont:true, hasSize:true, hasBold:true }
      ]
    },
    std_80x100: { shape:"rect", w:886, h:780, textZoneH:323, slotsPerSheet:6, cols:3, rows:2, bleed:false, landscape:false, hasText:true,
  textLineY: { title:0.06, names:0.28, date:0.52, location:0.74 },
  textFields:[
        { key:"title",    label:"Save the Date", type:"font-select", required:true,
          fonts:["Pacifico","Playfair Display","Montserrat","Dancing Script","Lato","Cormorant Garamond"], allowCustom:true },
        { key:"names",    label:"Names",    type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"date",     label:"Date",     type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"location", label:"Location", type:"text", required:false, hasFont:true, hasSize:true, hasBold:true }
      ]
    },
    std_100x130: { shape:"rect", w:1123, h:1040, textZoneH:408, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, hasText:true,
  textLineY: { title:0.06, names:0.28, date:0.52, location:0.74 },
  textFields:[
        { key:"title",    label:"Save the Date", type:"font-select", required:true,
          fonts:["Pacifico","Playfair Display","Montserrat","Dancing Script","Lato","Cormorant Garamond"], allowCustom:true },
        { key:"names",    label:"Names",    type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"date",     label:"Date",     type:"text", required:true,  hasFont:true, hasSize:true, hasBold:true },
        { key:"location", label:"Location", type:"text", required:false, hasFont:true, hasSize:true, hasBold:true }
      ]
    },
    polaroid_70x90: { shape:"square", w:761, h:761, textZoneH:233, slotsPerSheet:8, cols:4, rows:2, bleed:false, landscape:false, hasText:true, perSlotCaption:true,
      textFields:[
        { key:"line1", label:"Line 1", type:"text", required:false, hasFont:true, hasSize:true, hasBold:true },
        { key:"line2", label:"Line 2", type:"text", required:false, hasFont:true, hasSize:true, hasBold:true }
      ]
    },

    calendar_en_1: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"en", part:1 },
    calendar_en_2: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"en", part:2 },
    calendar_en_3: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"en", part:3 },
    calendar_gr_1: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"gr", part:1 },
    calendar_gr_2: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"gr", part:2 },
    calendar_gr_3: { shape:"square", w:1123, h:1123, slotsPerSheet:4, cols:2, rows:2, bleed:false, landscape:false, calendar:true, lang:"gr", part:3 },
    puzzle_4: { shape:"square", w:633, h:633, puzzle:true, puzzleCols:2, puzzleRows:2, bleed:false, landscape:false, hasText:false },
    puzzle_9: { shape:"square", w:633, h:633, puzzle:true, puzzleCols:3, puzzleRows:3, bleed:false, landscape:false, hasText:false }
  };

var i18n = {};

    function loadI18n(container) {
    var d = container.dataset;
    i18n = {
      title:            d.i18nTitle             || "Customize Your Magnet",
      addPhoto:         d.i18nAddPhoto          || "+ Add photo",
      uploading:        d.i18nUploading         || "Uploading...",
      added:            d.i18nAdded             || "Added!",
      saved:            d.i18nSaved             || "Your photos have been saved.",
      portrait:         d.i18nPortrait          || "↕ Portrait",
      landscape:        d.i18nLandscape         || "↔ Landscape",
      slotLabel:        d.i18nSlotLabel         || "Photo",
      complete:         d.i18nComplete          || "Complete!",
      remaining:        d.i18nRemaining         || "remaining",
      errUpload:        d.i18nErrUpload         || "Upload failed",
      errFileType:      d.i18nErrFileType       || "❌ Only JPG, PNG or HEIC files are allowed.",
      uploadPhotoFirst: d.i18nUploadPhotoFirst || '📸 Upload your photo first, then customize the text below.',
      errFileSize:      d.i18nErrFileSize       || "❌ File too large. Max 20MB.",
      errCart:          d.i18nErrCart           || "Cart error",
      customText:       d.i18nCustomText        || "Custom text...",
      uploadBtn:        d.i18nUploadBtn         || "📷 Upload Your Photos",
      uploadBtnSingle:  d.i18nUploadBtnSingle   || "📷 Upload Your Photo",
      selectAll:        d.i18nSelectAll         || "📷 Select All Photos at Once",
      done:             d.i18nDone              || "✅ Done",
      addToCartHint:    d.i18nAddToCartHint     || "👇 Now Add to Cart",
      uploadHint:       d.i18nUploadHint        || "Upload your photos to customize your magnet",
      uploadHintSingle: d.i18nUploadHintSingle  || "Upload your photo to customize your magnet",
      squareLabel:      d.i18nSquareLabel       || "Square magnet (50×50mm)",
      rectLabel:        d.i18nRectLabel         || "Rectangle magnet (54×78mm)",
      customPlaceholder:d.i18nCustomPlaceholder || "Write your own text...",
      atcWarning:       d.i18nAtcWarning        || "📷 Please upload your photo(s) first!",
      piecesLabel:      d.i18nPiecesLabel       || "pcs",
      lowResWarning:    d.i18nLowResWarning     || "Low resolution photo — print quality may be reduced.",
      line1Label:         d.i18nLine1Label        || "Line 1",
      line2Label:         d.i18nLine2Label        || "Line 2",
      resetLink:        d.i18nResetLink         || "× Start over",
      resetConfirm:     d.i18nResetConfirm      || "Remove all uploaded photos and text?",
      uploadPhotoFirst: d.i18nUploadPhotoFirst  || "📸 Upload your photo first, then customize the text below.",
      allUploaded:      d.i18nAllUploaded       || "All photos uploaded",
      warnShapeQty:     d.i18nWarnShapeQty      || "⚠️ Changing shape or quantity will reset your photo selection.",
      warnShape:        d.i18nWarnShape          || "⚠️ Changing shape will reset your photo selection.",
      warnQty:          d.i18nWarnQty            || "⚠️ Changing quantity will reset your photo selection.",
      warnLang:         d.i18nWarnLang           || "⚠️ Changing language will reset your photo selection.",
      warnPieces:       d.i18nWarnPieces         || "⚠️ Changing pieces will reset your photo selection.",
      warnSizeQty:      d.i18nWarnSizeQty        || "⚠️ Changing size or quantity will reset your photo selection.",
      squareMagnetLabel:  d.i18nSquareMagnetLabel  || "📐 Square magnet (50×50mm)",
      rectMagnetLabel:    d.i18nRectMagnetLabel    || "📐 Rectangular magnet (54×78mm)",
      squareMagnetsLabel: d.i18nSquareMagnetsLabel || "📐 Square magnets (50×50mm)",
      rectMagnetsLabel:   d.i18nRectMagnetsLabel   || "📐 Rectangle magnets (54×78mm)",
      warnSizeQty:      d.i18nWarnSizeQty        || "⚠️ Changing size or quantity will reset your photo selection.",
      squareMagnetLabel:  d.i18nSquareMagnetLabel  || "📐 Square magnet (50×50mm)",
      rectMagnetLabel:    d.i18nRectMagnetLabel    || "📐 Rectangular magnet (54×78mm)",
      squareMagnetsLabel: d.i18nSquareMagnetsLabel || "📐 Square magnets (50×50mm)",
      rectMagnetsLabel:   d.i18nRectMagnetsLabel   || "📐 Rectangle magnets (54×78mm)",
      uploadTextHint:   d.i18nUploadTextHint    || "📸 Upload your photo first, then customize the text below.",
      uploadPhotoFirst: d.i18nUploadTextHint || "📸 Upload your photo first, then customize the text below.",
      cropTitle:        d.i18nCropTitle          || "✂️ Crop & Edit Photo",
      cropSize:         d.i18nCropSize           || "📐 Crop size",
      filterBw:         d.i18nFilterBw           || "▨ B&W",
      filterWarm:       d.i18nFilterWarm         || "☀️ Warm",
      filterCool:       d.i18nFilterCool         || "❄️ Cool",
      filterBright:     d.i18nFilterBright       || "☀ Bright",
      filterContrast:   d.i18nFilterContrast     || "◑ Contrast",
      filterSaturation: d.i18nFilterSaturation   || "🎨 Sat",
      cropApply:        d.i18nCropApply          || "✅ Apply",
      cropCancel:       d.i18nCropCancel         || "✕ Cancel",
      pcsLabel:         d.i18nPcsLabel           || "pcs",
      applyOnePhoto:    d.i18nApplyOnePhoto      || "📷 Apply one photo to all",
      bulkSlotsWarning: d.i18nBulkSlotsWarning   || "⚠️ {available} slots available. {ignored} photos ignored.",
      bleedLabel:       d.i18nBleedLabel         || "--- περιθώριο κοπής 2mm",
      rotateL:          d.i18nRotateL            || "↺ Rotate L",
      rotateR:          d.i18nRotateR            || "↻ Rotate R",
      flipH:            d.i18nFlipH              || "⇄ Flip H",
      flipV:            d.i18nFlipV              || "⇅ Flip V",
      textOverlapWarning: d.i18nTextOverlapWarning || "⚠️ Text may overlap the photo area.",
      customText:    d.i18nCustomText    || "✏️ Custom text...",
      fieldNames:    d.i18nFieldNames    || "Names",
      fieldDate:     d.i18nFieldDate     || "Date",
      fieldLocation: d.i18nFieldLocation || "Location",
      orient_landscape: d.i18nOrientLandscape || "🖼️ Landscape",
      orient_portrait:  d.i18nOrientPortrait  || "🧍 Portrait",
    };
  }

  window._dbg_i18n = i18n;

  // ── Product type flags ───────────────────────────────────────────
  var productFlags = {
    singleSlot:    false,  // NFC, save-the-date, puzzle, polaroid
    showQtyBtns:   true,
    showSelectAll: true,
    magnetPackMode: false, // step=10
    magnetPackStep: 10
  };

  var state = {
    slots:          [],
    textValues:     {},
    textStyles:     {},
    selectedFont:   "Pacifico",
    useCustomTitle: false,
    totalSlots:     1,
    sections:       null,
    templateId:     "square_50x50",
    calendarLang:   "en",
    i18nMonths:     "",
    cartProps:      null,
    isComplete:     false,
    slotCaptions:   {}
  };

function usedQty() {
  if (productFlags.magnetPackMode) {
    return state.slots.reduce(function(s, slot) {
      return s + (slot && slot.uploadedUrl ? slot.qty : 0);
    }, 0);
  }
  return state.slots.reduce(function(s, slot) {
    return s + (slot && slot.uploadedUrl ? 1 : 0);
  }, 0);
}

function adjustSlotsForQtyChange(changedIdx, delta) {
  if (productFlags.magnetPackMode) {
    var step = productFlags.magnetPackStep;
    var slot = state.slots[changedIdx];
    if (!slot) return;
    var newQty = (slot.qty || step) + delta;

    if (delta > 0) {
      if (newQty > state.totalSlots) return;
      var removeIdx = -1;
      for (var i = state.slots.length - 1; i >= 0; i--) {
        if (i !== changedIdx && state.slots[i] && !state.slots[i].uploadedUrl) {
          removeIdx = i; break;
        }
      }
      if (removeIdx === -1) return;
      var removed = state.slots.splice(removeIdx, 1)[0];
      if (removed && removed.previewUrl) URL.revokeObjectURL(removed.previewUrl);
      slot.qty = newQty;
    } else {
      if (newQty < step) {
        var rem = state.slots.splice(changedIdx, 1)[0];
        if (rem && rem.previewUrl) URL.revokeObjectURL(rem.previewUrl);
      } else {
        var def = TEMPLATE_SHAPES[state.templateId] || {};
        state.slots.push({ qty: step, orientation: def.landscape ? "landscape" : "portrait", file:null, previewUrl:null, uploadedUrl:null });
        slot.qty = newQty;
      }
    }
    return;
  }

    // non-magnetPack (showQtyBtns)
  var slot = state.slots[changedIdx];
  if (!slot) return;

  var currentQty = slot.qty || 1;
  var newQty = currentQty + delta;
  if (newQty < 1) return;

  if (delta > 0) {
    var mySection = (slot.sectionIdx !== undefined) ? slot.sectionIdx : -1;

    var removeIdx = -1;
    if (mySection >= 0 && state.sections) {
      var hasEmptyInSection = state.slots.some(function(s, i) { return i !== changedIdx && s && s.sectionIdx === mySection && !s.uploadedUrl; });
if (!hasEmptyInSection) return;
      for (var ri = state.slots.length - 1; ri >= 0; ri--) {
        if (ri !== changedIdx &&
            state.slots[ri] &&
            state.slots[ri].sectionIdx === mySection &&
            !state.slots[ri].uploadedUrl) {
          removeIdx = ri; break;
        }
      }
    } else {
      if (state.slots.length <= 1) return;
      for (var i = state.slots.length - 1; i >= 0; i--) {
        if (i !== changedIdx && state.slots[i] && !state.slots[i].uploadedUrl) {
          removeIdx = i; break;
        }
      }
    }
    if (removeIdx === -1) return;
    var removed2 = state.slots.splice(removeIdx, 1)[0];
    if (removed2 && removed2.previewUrl) URL.revokeObjectURL(removed2.previewUrl);
    slot.qty = newQty;
  } else {
    var def2 = TEMPLATE_SHAPES[getSectionTemplateForSlot ? getSectionTemplateForSlot(changedIdx) : state.templateId] || TEMPLATE_SHAPES[state.templateId] || {};
    var mySecIdx = (slot.sectionIdx !== undefined) ? slot.sectionIdx : -1;
    if (mySecIdx >= 0 && state.sections) {
      var lastInSection = changedIdx;
      for (var li = 0; li < state.slots.length; li++) {
        if (state.slots[li] && state.slots[li].sectionIdx === mySecIdx) lastInSection = li;
      }
      state.slots.splice(lastInSection + 1, 0, {
        qty: 1,
        orientation: def2.landscape ? "landscape" : "portrait",
        sectionIdx: mySecIdx,
        file: null, previewUrl: null, uploadedUrl: null
      });
    } else {
      state.slots.push({ qty: 1, orientation: def2.landscape ? "landscape" : "portrait", file:null, previewUrl:null, uploadedUrl:null });
    }
    slot.qty = newQty;
  }
}

var BLEED_PX = 8;

  function compressImage(file, maxPx) {
    maxPx = maxPx || 2000;

    var isHeic = file.type === "image/heic" || file.type === "image/heif" ||
                 file.name.toLowerCase().endsWith(".heic") ||
                 file.name.toLowerCase().endsWith(".heif");

    var toJpeg = (isHeic && window.heic2any)
      ? heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 })
          .then(function (blob) {
            return new File([blob], file.name.replace(/\.hei[cf]$/i, ".jpg"), { type: "image/jpeg" });
          })
      : Promise.resolve(file);

    return toJpeg.then(function (converted) {
      return new Promise(function (resolve) {
        var url = URL.createObjectURL(converted);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          var w = img.width, h = img.height;
          if (w <= maxPx && h <= maxPx) { resolve(converted); return; }
          var scale = Math.min(maxPx / w, maxPx / h);
          var canvas = document.createElement("canvas");
          canvas.width  = Math.round(w * scale);
          canvas.height = Math.round(h * scale);
          canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(function (blob) {
            resolve(new File([blob], converted.name, { type: "image/jpeg" }));
          }, "image/jpeg", 0.92);
        };
        img.src = url;
      });
    });
  }
// v2
  function uploadFile(file, _retries) {
    var retries = (_retries === undefined) ? 3 : _retries;
    return compressImage(file).then(function (compressed) {
      var fd = new FormData();
      fd.append("file", compressed);
      return fetch(BACKEND_URL + "/upload", { method: "POST", body: fd })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { return d.signedUrl; })
        .catch(function (err) {
          if (retries > 0) {
            return new Promise(function (resolve) { setTimeout(resolve, 1000); })
              .then(function () { return uploadFile(file, retries - 1); });
          }
          throw err;
        });
        });
  }

function isRect(val) {
  var v = (val || "").toLowerCase();
  return v.indexOf("rect") !== -1 || v.indexOf("ορθ") !== -1;
}

function resolveConfig(config) {
    var handle    = config.productHandle || "";
    var opt1      = (config.option1 || "").trim();
    var opt2      = (config.option2 || "").trim();
    var metaTpl   = config.metaTemplate   || null;
    var metaSlots = parseInt(config.metaTotalSlots, 10) || 0;
    var metaSecs  = config.metaSections   || null;

    var qty = parseInt(opt2, 10) || parseInt(opt1, 10) || 1;

    // Reset flags
    productFlags.singleSlot     = false;
    productFlags.showQtyBtns    = true;
    productFlags.showSelectAll  = true;
    productFlags.magnetPackMode = false;
    productFlags.nfcMode        = false;

    if (handle.indexOf("save-the-date") !== -1) {
      var std = { "70mm x 90mm":"std_70x90", "80mm x 100mm":"std_80x100", "100mm x 130mm":"std_100x130" };
      productFlags.singleSlot = true;
      productFlags.showQtyBtns = false;
      productFlags.showSelectAll = false;
      return { templateId: std[opt1] || "std_70x90", totalSlots: 1, orderQty: qty, sections: null };
    }

    if (handle.indexOf("polaroid") !== -1) {
      productFlags.singleSlot = true;
      productFlags.showQtyBtns = false;
      productFlags.showSelectAll = false;
      return { templateId: "polaroid_70x90", totalSlots: 1, orderQty: qty, sections: null };
    }

    if (handle.indexOf("nfc") !== -1) {
      productFlags.singleSlot = true;
      productFlags.nfcMode = true;
      productFlags.showQtyBtns = false;
      productFlags.showSelectAll = false;
      return { templateId: isRect(opt1) ? "rect_54x78" : "square_50x50", totalSlots: 1, orderQty: qty, sections: null };
    }

    if (handle.indexOf("puzzle") !== -1) {
  productFlags.singleSlot = true;
  productFlags.showQtyBtns = false;
  productFlags.showSelectAll = false;
  var pieces = 4;
  var m = (opt1 || "").match(/(\d+)/);
  if (m) pieces = parseInt(m[1]);
  return { templateId: "puzzle_" + pieces, totalSlots: 1, orderQty: qty, sections: null };
}

    if (handle.indexOf("magnet-pack") !== -1) {
      productFlags.magnetPackMode = true;
      productFlags.showSelectAll = true;
      var tpl = isRect(opt1) ? "rect_54x78" : "square_50x50";
      var step = productFlags.magnetPackStep;
      var numSlots = Math.max(1, Math.round(qty / step));
      var secs = [];
      for (var p = 0; p < numSlots; p++) {
        secs.push({ templateId: tpl, qty: step, label: null, slotQtyLabel: step + " pcs" });
      }
      return { templateId: tpl, totalSlots: qty, sections: secs };
    }

    if (handle.indexOf("mini") !== -1) {
  productFlags.showQtyBtns = false;
  productFlags.showSelectAll = false;
  productFlags.singleSlot = true;
  return {
    templateId: "mini_mixed_set", totalSlots: 2,
    sections: null
  };
}

    if (handle.indexOf("rectangle") !== -1 && handle.indexOf("mixed") === -1) {
      return { templateId: "rect_54x78", totalSlots: qty, sections: null };
    }

    if (handle.indexOf("mixed") !== -1) {
      productFlags.singleSlot = false;
      if (metaSecs) return { templateId: "square_50x50", totalSlots: metaSlots, sections: metaSecs };
      var sq = qty === 20 ? 12 : 6, rc = qty === 20 ? 8 : 4;
            return {
        templateId: "square_50x50", totalSlots: qty,
        sections: [
          { templateId: "square_50x50", qty: sq, label: i18n.squareMagnetsLabel || "Square magnets (50×50mm)" },
          { templateId: "rect_54x78",   qty: rc, label: i18n.rectMagnetsLabel || "Rectangle magnets (54×78mm)" }
        ]
      };
    }

    if (metaTpl && metaSlots) {
      return { templateId: metaTpl, totalSlots: metaSlots, sections: metaSecs };
    }

    if (handle.indexOf("photo-magnets") !== -1 && opt1.indexOf("mm") !== -1) {
      var pm = { "70mm x 70mm":"photo_70x70", "70mm x 90mm":"photo_70x90", "80mm x 100mm":"photo_80x100" };
      return { templateId: pm[opt1] || "photo_70x70", totalSlots: qty, sections: null };
    }

    if (handle.indexOf("calendar") !== -1) {
      productFlags.showQtyBtns = false;
      var lang = (handle.indexOf("-gr") !== -1 || opt1.toLowerCase().indexOf("gr") !== -1) ? "gr" : "en";
      return {
        templateId: "calendar_" + lang + "_1", totalSlots: 12, calendarLang: lang,
        sections: [
          { templateId: "calendar_" + lang + "_1", qty: 4, label: null },
          { templateId: "calendar_" + lang + "_2", qty: 4, label: null },
          { templateId: "calendar_" + lang + "_3", qty: 4, label: null }
        ]
      };
    }

    return { templateId: metaTpl || "square_50x50", totalSlots: metaSlots || 1, sections: null };
  }

function renderProgress(container) {
  var el = container.querySelector("#p2m-progress");
  if (!el) return;

  if (productFlags.showSelectAll && !productFlags.magnetPackMode) {
    var bulkBtnEl = container.querySelector("#p2m-bulk-btn") || document.querySelector("#p2m-bulk-btn");
    if (bulkBtnEl) {
      var emptyCount = state.slots.filter(function (s) { return !s || !s.uploadedUrl; }).length;
      bulkBtnEl.textContent = emptyCount > 0 ? (i18n.selectAll || "📷 Select up to " + emptyCount + " photo" + (emptyCount > 1 ? "s" : "")) : (i18n.allUploaded || "📷 All photos uploaded");
    }
  }

  var used = usedQty();
  var total = productFlags.magnetPackMode ? state.totalSlots : state.slots.length;
  var pct  = total ? Math.round((used / total) * 100) : 0;
  var color = used === total ? "#2a7a2a" : used > 0 ? "#e08800" : "#ccc";
  el.innerHTML =
    "<div style='display:flex;align-items:center;gap:8px;margin-bottom:8px;'>" +
    "<span style='font-size:13px;color:#555;'>" + i18n.slotLabel + ":</span>" +
    "<span style='font-weight:bold;font-size:14px;color:" + color + ";'>" + used + "/" + total + "</span>" +
    (used === total
      ? "<span style='color:#2a7a2a;font-size:13px;'>✅ " + i18n.complete + "</span>"
      : "<span style='font-size:12px;color:#999;'>" + (total - used) + " " + i18n.remaining + "</span>") +
    "</div>" +
    "<div style='background:#eee;border-radius:4px;height:6px;overflow:hidden;'>" +
    "<div style='background:" + color + ";height:6px;width:" + pct + "%;transition:width .3s;border-radius:4px;'></div>" +
    "</div>";
}

// Share font-loading work between slot previews. A rejected load can be retried.
var p2mPreviewFontLoads = Object.create(null);
function p2mLoadPreviewFonts(fontNames) {
  return Promise.all(fontNames.map(function(fontName) {
    if (!p2mPreviewFontLoads[fontName]) {
      p2mPreviewFontLoads[fontName] = document.fonts.load(
        "400 16px '" + fontName + "'", "αβγδεζ"
      ).catch(function(error) {
        delete p2mPreviewFontLoads[fontName];
        throw error;
      });
    }
    return p2mPreviewFontLoads[fontName];
  }));
}

function drawCanvas(canvas, previewUrl, templateId, orientation, captions, textStyles, monthIndex) {
    var def = TEMPLATE_SHAPES[templateId] || TEMPLATE_SHAPES["square_50x50"];
    var isStd = templateId && templateId.indexOf("std_") === 0;
    var stdPhotoRatios = { std_70x90: 0.7778, std_80x100: 0.80, std_100x130: 0.7692 };
    var isLandscape = orientation === "landscape";
    var rawW = def.w || (def.shape === "rect" ? 780 : 633);
    var rawH = def.h || (def.shape === "rect" ? 1040 : 633);
    if (def.shape === "circle") { rawW = 633; rawH = 633; }
    if (isLandscape && rawW < rawH) { var t1 = rawW; rawW = rawH; rawH = t1; }
    if (!isLandscape && rawW > rawH && def.shape !== "circle" && !isStd) { var t2 = rawW; rawW = rawH; rawH = t2; }
    var maxW = Math.min(320, (canvas.parentElement ? canvas.parentElement.offsetWidth - 16 : 300));
    var pr = isStd ? (stdPhotoRatios[templateId] || 0.50) : 1;
    var totalPrintH = isStd ? Math.round(rawH / pr) : rawH;
    var sc = Math.min(maxW / rawW, maxW / totalPrintH);
    var W      = Math.round(rawW * sc);
    var photoH = Math.round(rawH * sc);
    var textH  = isStd
      ? (def.textZoneH ? Math.round(def.textZoneH * sc) : Math.round(photoH * (1 - pr) / pr))
      : (def.textZoneH ? Math.round(def.textZoneH * sc) : 0);
    var polaroidCapH = 0;
    var calPngH = def.calendar ? Math.round(384 * sc) : 0;
    var totalH = photoH + textH + polaroidCapH + calPngH;

    canvas.width = W; canvas.height = totalH;
    canvas.style.width = W + "px"; canvas.style.height = totalH + "px";
    var ctx = canvas.getContext("2d");

    function _drawText() {
      if (!isStd || textH <= 0) return;
      var font = state.selectedFont || "Pacifico";
      var titleText = state.useCustomTitle
        ? (state.textValues["title_custom"] || "Save the Date")
        : "Save the Date";
      var names    = state.textValues["names"]    || "";
      var date     = state.textValues["date"]     || "";
      var location = state.textValues["location"] || "";

      var styNames    = state.textStyles["names"]    || {};
      var styDate     = state.textStyles["date"]     || {};
      var styLocation = state.textStyles["location"] || {};

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, photoH, W, textH);

      ctx.strokeStyle = "#eee"; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(0, photoH); ctx.lineTo(W, photoH); ctx.stroke();

      var lh = Math.round(textH * 0.22);
var tly = def.textLineY || { title:0.12, names:0.34, date:0.56, location:0.78 };
var titleY    = photoH + Math.round(textH * tly.title);
var namesY    = photoH + Math.round(textH * tly.names);
var dateY     = photoH + Math.round(textH * tly.date);
var locationY = photoH + Math.round(textH * tly.location);
ctx.textBaseline = "top";
var bleed = Math.round(W * 0.06);

      // Title
      var tSty2 = state.textStyles["title"] || {};
      var titlePx = tSty2.size ? Math.round(tSty2.size * (W / 320)) : Math.round(lh * 0.9);
      var titleAlign = tSty2.align || "center";
      var titleX = titleAlign === "left" ? bleed : titleAlign === "right" ? W - bleed : W/2;
      ctx.textAlign = titleAlign;
      ctx.font = (tSty2.bold ? "bold " : "") + titlePx + "px '" + (tSty2.font || font) + "', serif";
      ctx.fillStyle = tSty2.color || "#222";
      ctx.fillText(titleText, titleX, titleY);

      // Names
      var namesPx = styNames.size ? Math.round(styNames.size * (W / 320)) : Math.round(lh * 0.75);
      var namesAlign = styNames.align || "center";
      var namesX = namesAlign === "left" ? bleed : namesAlign === "right" ? W - bleed : W/2;
      ctx.textAlign = namesAlign;
      ctx.font = (styNames.bold ? "bold " : "") + namesPx + "px '" + (styNames.font || "Lato") + "', sans-serif";
      ctx.fillStyle = styNames.color || "#444";
      ctx.fillText(names, namesX, namesY);

      // Date
      var datePx = styDate.size ? Math.round(styDate.size * (W / 320)) : Math.round(lh * 0.65);
      var dateAlign = styDate.align || "center";
      var dateX = dateAlign === "left" ? bleed : dateAlign === "right" ? W - bleed : W/2;
      ctx.textAlign = dateAlign;
      ctx.font = (styDate.bold ? "bold " : "") + datePx + "px '" + (styDate.font || "Lato") + "', sans-serif";
      ctx.fillStyle = styDate.color || "#666";
      ctx.fillText(date, dateX, dateY);

      // Location
      var locPx = styLocation.size ? Math.round(styLocation.size * (W / 320)) : Math.round(lh * 0.6);
      var locAlign = styLocation.align || "center";
      var locX = locAlign === "left" ? bleed : locAlign === "right" ? W - bleed : W/2;
      ctx.textAlign = locAlign;
      ctx.font = (styLocation.bold ? "bold " : "") + locPx + "px '" + (styLocation.font || "Lato") + "', sans-serif";
      ctx.fillStyle = styLocation.color || "#888";
      ctx.fillText(location, locX, locationY);

      ctx.textAlign = "left";
      ctx.textBaseline = "alphabetic";
    }

    var img = new Image();
    img.onload = function () {
      ctx.clearRect(0, 0, W, totalH);

      // ── Φωτογραφία ──
      ctx.save(); ctx.beginPath();
      if (def.shape === "circle") {
        ctx.arc(W/2, photoH/2, Math.min(W,photoH)/2 - 2, 0, Math.PI * 2);
      } else {
        var r = 10;
        ctx.moveTo(r,0); ctx.lineTo(W-r,0); ctx.quadraticCurveTo(W,0,W,r);
        ctx.lineTo(W,photoH-r); ctx.quadraticCurveTo(W,photoH,W-r,photoH);
        ctx.lineTo(r,photoH); ctx.quadraticCurveTo(0,photoH,0,photoH-r);
        ctx.lineTo(0,r); ctx.quadraticCurveTo(0,0,r,0); ctx.closePath();
      }
      ctx.clip();
var s = Math.max(W / img.width, photoH / img.height);
ctx.drawImage(img, (W - img.width*s)/2, (photoH - img.height*s)/2, img.width*s, img.height*s);
ctx.restore();

      // ── Border φωτογραφίας ──
      ctx.beginPath();
      if (def.shape === "circle") {
        ctx.arc(W/2, photoH/2, Math.min(W,photoH)/2 - 2, 0, Math.PI * 2);
      } else {
        var r2 = 10;
        ctx.moveTo(r2,0); ctx.lineTo(W-r2,0); ctx.quadraticCurveTo(W,0,W,r2);
        ctx.lineTo(W,photoH-r2); ctx.quadraticCurveTo(W,photoH,W-r2,photoH);
        ctx.lineTo(r2,photoH); ctx.quadraticCurveTo(0,photoH,0,photoH-r2);
        ctx.lineTo(0,r2); ctx.quadraticCurveTo(0,0,r2,0); ctx.closePath();
      }
      ctx.strokeStyle = "#ccc"; ctx.lineWidth = 2; ctx.stroke();

      // ── Text zone ──
      _drawText();

      // ── Polaroid caption (2 lines, full style engine) ──
      if (!isStd && def.perSlotCaption) {
        var capH = textH || Math.round(photoH * 0.28);
        var capY = photoH;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, capY, W, capH);
        ctx.save();
        ctx.beginPath();
        ctx.rect(0, capY, W, capH);
        ctx.clip();
        var lines = [
          { key:"line1", y: capY + capH * 0.28 },
          { key:"line2", y: capY + capH * 0.70 }
        ];
        lines.forEach(function(ln) {
          var txt = (captions && captions[ln.key]) ? captions[ln.key].trim() : "";
          if (!txt) return;
          var styles = (textStyles && (textStyles[ln.key + '_style'] || textStyles[ln.key])) || {};
          var fontFamily = styles.font || "Lato";
          var bold = styles.bold ? "bold " : "";
          var color = styles.color || "#333333";
          var align = styles.align || "center";
          var rotation = styles.rotation || 0;
          var maxSize = parseInt(styles.size) || 28;
          var padding = W * 0.05;
          var maxW = W - padding * 2;
          // shrink-to-fit
          var fontSize = maxSize;
          ctx.font = bold + fontSize + "px '" + fontFamily + "', 'Noto Sans', sans-serif";
          while (ctx.measureText(txt).width > maxW && fontSize > 8) {
                    fontSize--;
            ctx.font = bold + fontSize + "px '" + fontFamily + "', 'Noto Sans', sans-serif";
          }
          ctx.save();
          ctx.translate(W / 2, ln.y);
          ctx.rotate(rotation * Math.PI / 180);
          ctx.fillStyle = color;
          ctx.textBaseline = "middle";
          ctx.textAlign = "left";
          var textX = align === "left"  ? -(W / 2) + padding
                    : align === "right" ? (W / 2) - padding - ctx.measureText(txt).width
                    : -(ctx.measureText(txt).width / 2);
          ctx.fillText(txt, textX, 0);
          ctx.restore();
        });
        // ── Text overlap warning ──
        var hasOverlap = false;
        lines.forEach(function(ln) {
          var styles = (textStyles && (textStyles[ln.key + '_style'] || textStyles[ln.key])) || {};
          var rotation = styles.rotation || 0;
          if (Math.abs(rotation) > 15) hasOverlap = true;
        });
        if (hasOverlap) {
          var warnEl = canvas.parentElement && canvas.parentElement.querySelector(".p2m-text-overlap-warn");
          if (!warnEl) {
            warnEl = document.createElement("div");
            warnEl.className = "p2m-text-overlap-warn";
            warnEl.style.cssText = "font-size:11px;color:#b45309;background:#fef9c3;border:1px solid #fde68a;border-radius:4px;padding:4px 8px;margin-top:4px;";
            canvas.parentElement && canvas.parentElement.appendChild(warnEl);
          }
          warnEl.textContent = i18n.textOverlapWarning;
        } else {
          var warnEl2 = canvas.parentElement && canvas.parentElement.querySelector(".p2m-text-overlap-warn");
          if (warnEl2) warnEl2.remove();
        }
        ctx.restore();
        ctx.textAlign = "left";
        ctx.textBaseline = "alphabetic";
      }

      // ── Calendar PNG ──
      if (def.calendar && monthIndex && calPngH > 0) {
        var calLang = def.lang || "en";
        var calIdx = String(monthIndex).padStart(2, "0");
        var calImg = new Image();
        calImg.crossOrigin = "anonymous";
        calImg.onload = function() {
          ctx.drawImage(calImg, 0, photoH, W, calPngH);
        };
        calImg.src = window.P2M_ASSET_BASE + "cal_" + calLang + "_" + calIdx + ".png";
      }

      // ── Bleed ──
      if (def.bleed) {
        ctx.setLineDash([4,3]);
        ctx.strokeStyle = "rgba(180,0,0,0.5)"; ctx.lineWidth = 1;
        ctx.beginPath();
        var b = BLEED_PX;
        if (def.shape === "circle") {
          ctx.arc(W/2, photoH/2, Math.min(W,photoH)/2 - 2 - b, 0, Math.PI * 2);
        } else {
          var r3 = 6;
          ctx.moveTo(b+r3,b); ctx.lineTo(W-b-r3,b); ctx.quadraticCurveTo(W-b,b,W-b,b+r3);
          ctx.lineTo(W-b,photoH-b-r3); ctx.quadraticCurveTo(W-b,photoH-b,W-b-r3,photoH-b);
          ctx.lineTo(b+r3,photoH-b); ctx.quadraticCurveTo(b,photoH-b,b,photoH-b-r3);
          ctx.lineTo(b,b+r3); ctx.quadraticCurveTo(b,b,b+r3,b); ctx.closePath();
        }
        ctx.stroke(); ctx.setLineDash([]);
      }

            // ── Puzzle grid overlay ──
      if (def.puzzle) {
        var cols = def.puzzleCols || 2;
        var rows = def.puzzleRows || 2;
        ctx.strokeStyle = "rgba(255,255,255,0.88)";
        ctx.lineWidth = Math.max(2, Math.round(W * 0.012));
        ctx.setLineDash([]);
        for (var pc = 1; pc < cols; pc++) {
          ctx.beginPath();
          ctx.moveTo(Math.round(W / cols * pc), 0);
          ctx.lineTo(Math.round(W / cols * pc), photoH);
          ctx.stroke();
        }
        for (var pr2 = 1; pr2 < rows; pr2++) {
          ctx.beginPath();
          ctx.moveTo(0, Math.round(photoH / rows * pr2));
          ctx.lineTo(W, Math.round(photoH / rows * pr2));
          ctx.stroke();
        }
            }       
    };

            var _fontsToLoad = ["Lato","Noto Serif","GFS Didot","Philosopher","Crimson Pro","Ubuntu"];
    p2mLoadPreviewFonts(_fontsToLoad).then(function() {
      img.src = previewUrl;
      if (img.complete) { img.onload(); }
    });
  }

  function renderTextFields(container, def) {
  var el = container.querySelector("#p2m-text-fields");
  var fieldLabels = {
    names:    i18n.fieldNames    || "Names",
    date:     i18n.fieldDate     || "Date",
    location: i18n.fieldLocation || "Location"
  };
  if (!el) return;
  if (!def || !def.hasText || !def.textFields) { el.innerHTML = ""; return; }
  if (def.perSlotCaption) { el.innerHTML = ""; return; }


    var hasPhoto = state.slots && state.slots[0] && state.slots[0].previewUrl;
    if (!hasPhoto) {
      el.innerHTML = "<p style='font-size:12px;color:#999;text-align:center;padding:10px 0 4px;margin:0;'>" + i18n.uploadPhotoFirst + "</p>";
      return;
    }

    var titleFonts = ["Pacifico","Playfair Display","Dancing Script","Cormorant Garamond","Montserrat","Lato"];
    var textFonts = ["Lato","Noto Serif","EB Garamond","GFS Didot","Cormorant Garamond","Montserrat"];

    function alignBtns(key, currentAlign) {
      return ["left","center","right"].map(function(a) {
        var icon = a === "left" ? "⬅" : a === "center" ? "☰" : "➡";
        var active = (currentAlign || "center") === a;
        return "<button class='p2m-line-align' data-key='" + key + "' data-align='" + a + "' style='padding:4px 7px;border:1px solid #ddd;border-radius:6px;font-size:11px;background:" + (active?"#333":"#fff") + ";color:" + (active?"#fff":"#333") + ";cursor:pointer;'>" + icon + "</button>";
      }).join("");
    }

    el.innerHTML = def.textFields.map(function (field) {
  var val = state.textValues[field.key] || "";
  if (!state.textStyles[field.key]) state.textStyles[field.key] = {};
var sty = state.textStyles[field.key];

      if (field.type === "font-select") {
        var fontOpts = field.fonts.map(function (f) {
          return "<option value='" + f + "'" + (state.selectedFont === f ? " selected" : "") + " style='font-family:" + f + ";'>" + f + "</option>";
        }).join("");
        if (field.allowCustom) {
          fontOpts += "<option value='__custom__'" + (state.useCustomTitle ? " selected" : "") + ">✏️ " + i18n.customText + "</option>";
        }
        var tSty = state.textStyles["title"] || {};
        var tSizes = [10,12,14,16,18,20,24,28,32];
        var tSizeOpts = tSizes.map(function(s) {
          return "<option value='" + s + "'" + ((tSty.size || 20) === s ? " selected" : "") + ">" + s + "px</option>";
        }).join("");
        var tBoldBg  = tSty.bold ? "#333" : "#fff";
        var tBoldCol = tSty.bold ? "#fff" : "#333";
        return "<div style='margin-bottom:10px;'>" +
          "<label style='font-size:13px;font-weight:bold;display:block;margin-bottom:4px;'>" + (fieldLabels[field.key] || field.label) + "</label>" +
          "<div style='display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-bottom:6px;'>" +
          "<select class='p2m-font-select' data-key='" + field.key + "' style='flex:1;padding:6px;border:1px solid #ddd;border-radius:6px;font-size:13px;'>" + fontOpts + "</select>" +
          "<select class='p2m-line-size' data-key='title' style='width:70px;padding:4px 6px;border:1px solid #ddd;border-radius:6px;font-size:11px;'>" + tSizeOpts + "</select>" +
          "<button class='p2m-line-bold' data-key='title' style='padding:4px 8px;border:1px solid #ddd;border-radius:6px;font-size:11px;font-weight:bold;background:" + tBoldBg + ";color:" + tBoldCol + ";cursor:pointer;'>B</button>" +
          "<input type='color' class='p2m-line-color' data-key='title' value='" + (tSty.color || "#222222") + "' style='width:32px;height:28px;padding:2px;border:1px solid #ddd;border-radius:6px;cursor:pointer;'>" +
          "<div style='display:flex;gap:2px;'>" + alignBtns("title", tSty.align) + "</div>" +
          "</div>" +
          "<div id='p2m-custom-title-wrap' style='display:" + (state.useCustomTitle ? "block" : "none") + ";'>" +
          "<input type='text' class='p2m-text-input' data-key='" + field.key + "_custom' placeholder='" + i18n.customPlaceholder + "' value='" + (state.textValues[field.key + "_custom"] || "") + "' style='width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;font-size:13px;box-sizing:border-box;'/>" +
          "</div></div>";
      }

      // ── Text field με font/size/bold/color/align controls ──
      var fontSel = "";
      var sizeSel = "";
      var boldBtn = "";
      var colorPicker = "";
      var alignGroup = "";

      if (field.hasFont) {
        var fOpts = textFonts.map(function(f) {
          return "<option value='" + f + "'" + ((sty.font || "Lato") === f ? " selected" : "") + " style='font-family:" + f + ";'>" + f + "</option>";
        }).join("");
        fontSel = "<select class='p2m-line-font' data-key='" + field.key + "' style='flex:1;padding:4px 6px;border:1px solid #ddd;border-radius:6px;font-size:11px;'>" + fOpts + "</select>";
      }
      if (field.hasSize) {
        var sizes = [10,12,14,16,18,20,24,28,32];
        var sOpts = sizes.map(function(s) {
          return "<option value='" + s + "'" + ((sty.size || 14) === s ? " selected" : "") + ">" + s + "px</option>";
        }).join("");
        sizeSel = "<select class='p2m-line-size' data-key='" + field.key + "' style='width:70px;padding:4px 6px;border:1px solid #ddd;border-radius:6px;font-size:11px;'>" + sOpts + "</select>";
      }
      if (field.hasBold) {
        boldBtn = "<button class='p2m-line-bold' data-key='" + field.key + "' style='padding:4px 8px;border:1px solid #ddd;border-radius:6px;font-size:11px;font-weight:bold;background:" + (sty.bold ? "#333" : "#fff") + ";color:" + (sty.bold ? "#fff" : "#333") + ";cursor:pointer;'>B</button>";
      }
      if (field.hasFont || field.hasSize || field.hasBold) {
        colorPicker = "<input type='color' class='p2m-line-color' data-key='" + field.key + "' value='" + (sty.color || "#444444") + "' style='width:32px;height:28px;padding:2px;border:1px solid #ddd;border-radius:6px;cursor:pointer;'>";
        alignGroup = "<div style='display:flex;gap:2px;'>" + alignBtns(field.key, sty.align) + "</div>";
      }

      var controls = (field.hasFont || field.hasSize || field.hasBold)
        ? "<div style='display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-bottom:4px;'>" + fontSel + sizeSel + boldBtn + colorPicker + alignGroup + "</div>"
        : "";

      return "<div style='margin-bottom:10px;'>" +
        "<label style='font-size:13px;font-weight:bold;display:block;margin-bottom:4px;'>" + (fieldLabels[field.key] || field.label) +
        (field.required ? " <span style='color:#e44;'>*</span>" : "") + "</label>" +
        controls +
        "<input type='text' class='p2m-text-input' data-key='" + field.key + "' value='" + val + "' " +
        "placeholder='" + (fieldLabels[field.key] || field.label) + "...' " +
        "style='width:100%;padding:8px;border:1px solid #ddd;border-radius:6px;font-size:13px;box-sizing:border-box;'/>" +
        "</div>";
    }).join("");

    // ── Font select (title) ──
    el.querySelectorAll(".p2m-font-select").forEach(function (sel) {
      sel.addEventListener("change", function () {
        if (sel.value === "__custom__") {
          state.useCustomTitle = true; state.selectedFont = null;
        } else {
          state.useCustomTitle = false; state.selectedFont = sel.value;
          state.textValues[sel.dataset.key] = sel.value;
        }
        var wrap = el.querySelector("#p2m-custom-title-wrap");
        if (wrap) wrap.style.display = state.useCustomTitle ? "block" : "none";
        renderDoneBtn(container);
        _redrawAllCanvases(container);
      });
    });

    el.querySelectorAll(".p2m-line-font").forEach(function (sel) {
  sel.addEventListener("change", function () {
    if (!state.textStyles[sel.dataset.key]) state.textStyles[sel.dataset.key] = {};
    state.textStyles[sel.dataset.key].font = sel.value;
    _redrawAllCanvases(container);
  });
});

    // ── Line size ──
    el.querySelectorAll(".p2m-line-size").forEach(function (sel) {
      sel.addEventListener("change", function () {
        if (!state.textStyles[sel.dataset.key]) state.textStyles[sel.dataset.key] = {};
        state.textStyles[sel.dataset.key].size = parseInt(sel.value, 10);
        _redrawAllCanvases(container);
      });
    });

    // ── Bold toggle ──
    el.querySelectorAll(".p2m-line-bold").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!state.textStyles[btn.dataset.key]) state.textStyles[btn.dataset.key] = {};
        state.textStyles[btn.dataset.key].bold = !state.textStyles[btn.dataset.key].bold;
        btn.style.background = state.textStyles[btn.dataset.key].bold ? "#333" : "#fff";
        btn.style.color      = state.textStyles[btn.dataset.key].bold ? "#fff" : "#333";
        _redrawAllCanvases(container);
      });
    });

    // ── Line color ──
    el.querySelectorAll(".p2m-line-color").forEach(function (inp) {
      inp.addEventListener("input", function () {
        if (!state.textStyles[inp.dataset.key]) state.textStyles[inp.dataset.key] = {};
        state.textStyles[inp.dataset.key].color = inp.value;
        _redrawAllCanvases(container);
      });
    });

    // ── Line align ──
    el.querySelectorAll(".p2m-line-align").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!state.textStyles[btn.dataset.key]) state.textStyles[btn.dataset.key] = {};
        state.textStyles[btn.dataset.key].align = btn.dataset.align;
        el.querySelectorAll(".p2m-line-align[data-key='" + btn.dataset.key + "']").forEach(function(b) {
          b.style.background = b.dataset.align === btn.dataset.align ? "#333" : "#fff";
          b.style.color      = b.dataset.align === btn.dataset.align ? "#fff" : "#333";
        });
        _redrawAllCanvases(container);
      });
    });

    // ── Text input ──
    el.querySelectorAll(".p2m-text-input").forEach(function (inp) {
      inp.addEventListener("input", function () {
        state.textValues[inp.dataset.key] = inp.value;
        renderDoneBtn(container);
        _redrawAllCanvases(container);
      });
    });
  }

  function _redrawAllCanvases(container) {
  container.querySelectorAll(".p2m-slot-canvas").forEach(function (canvas) {
    var idx = parseInt(canvas.dataset.idx, 10);
    var slot = state.slots[idx];
    if (slot && slot.previewUrl) {
       drawCanvas(canvas, slot.croppedDataUrl || slot.previewUrl, getSectionTemplateForSlot(idx), slot.orientation, state.slotCaptions[idx], state.textStyles || {}, null);
    }
  });
}

// ── Crop Editor (E.1 + E.2 + E.3) ───────────────────────────────
var cropEditor = (function() {
  var _canvas, _ctx, _img;
  var _cropX, _cropY, _cropW, _cropH;
  var _dragging = false, _resizing = false;
  var _dragStartX, _dragStartY, _dragOriginX, _dragOriginY;
  var _resizeStartX, _resizeStartY, _resizeOriginW, _resizeOriginH, _resizeOriginX, _resizeOriginY;
  var _rotation = 0, _flipH = false, _flipV = false;
  var _displayW, _displayH, _scaleX, _scaleY;
  var _targetRatio, _onDone;
  var _lastPinchDist = null;
  var _lastTapTime = 0;
  var _touchStartTime = 0;
  var _templateKey = "";
  var _textState = null;
  var _bw = false;
  var _colorTemp = 0;
  var _brightness = 0;
  var _contrast = 0;
  var _saturation = 0;
  var MIN_CROP = 40;
  var HANDLE_SIZE = 14;

  // ── Print correction (Mylar) — αόρατο στον πελάτη ──
  var PRINT_CORRECTION = {
    brightness: 10,  // +10%
    contrast:    0,
    saturation:  0
  };

  function _nearCorner(x, y) {
    var corners = [
      { x: _cropX,          y: _cropY,          cx: "nw" },
      { x: _cropX + _cropW, y: _cropY,          cx: "ne" },
      { x: _cropX,          y: _cropY + _cropH, cx: "sw" },
      { x: _cropX + _cropW, y: _cropY + _cropH, cx: "se" }
    ];
    for (var i = 0; i < corners.length; i++) {
      if (Math.abs(x - corners[i].x) <= HANDLE_SIZE && Math.abs(y - corners[i].y) <= HANDLE_SIZE) return corners[i].cx;
    }
    return null;
  }

  function _syncZoomSlider(zoomSlider) {
    if (!zoomSlider) return;
    var maxByW = _displayW;
    var maxByH = Math.round(_displayH * _targetRatio);
    var maxSide = Math.min(maxByW, maxByH);
    zoomSlider.value = Math.round((_cropW / maxSide) * 100);
  }

    function open(file, targetRatio, onDone, templateKey, textState) {
    _rotation = 0; _flipH = false; _flipV = false;
    _bw = false; _colorTemp = 0; _brightness = 0; _contrast = 0; _saturation = 0;
    _targetRatio = targetRatio || 1;
    _onDone = onDone;
    _templateKey = templateKey || "";
    _textState = textState || null;

    var overlay = document.createElement("div");
    overlay.id = "p2m-crop-overlay";
    overlay.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.82);z-index:99999;display:flex;align-items:center;justify-content:center;";

    var box = document.createElement("div");
    box.style.cssText = "background:#fff;border-radius:14px;padding:16px;max-width:400px;width:95%;box-sizing:border-box;overflow-y:auto;max-height:95vh;";

    var title = document.createElement("div");
    title.style.cssText = "font-weight:bold;font-size:15px;margin-bottom:10px;text-align:center;";
    title.textContent = i18n.cropTitle || "✂️ Crop & Edit Photo";

    _canvas = document.createElement("canvas");
    _canvas.style.cssText = "display:block;margin:0 auto;border-radius:8px;border:1px solid #ddd;touch-action:none;cursor:crosshair;";

    var zoomRow = document.createElement("div");
    zoomRow.style.cssText = "display:flex;align-items:center;gap:8px;margin-top:10px;";
    var zoomLbl = document.createElement("span");
    zoomLbl.style.cssText = "font-size:12px;color:#666;white-space:nowrap;";
    zoomLbl.textContent = i18n.cropSize || "📐 Crop size";
    var zoomSlider = document.createElement("input");
    zoomSlider.type = "range"; zoomSlider.min = "20"; zoomSlider.max = "100"; zoomSlider.value = "90";
    zoomSlider.style.cssText = "flex:1;";
    zoomRow.appendChild(zoomLbl); zoomRow.appendChild(zoomSlider);

        var btnRow = document.createElement("div");
    btnRow.style.cssText = "display:grid;grid-template-columns:1fr 1fr 1fr;gap:6px;margin-top:10px;";
        function mkBtn(label, fn) {
      var b = document.createElement("button");
      b.textContent = label;
      b.style.cssText = "padding:7px 12px;border:1px solid #ccc;border-radius:8px;background:#f5f5f5;cursor:pointer;font-size:13px;white-space:nowrap;";
      b.addEventListener("click", fn);
      return b;
    }

    var rotLBtn = mkBtn(i18n.rotateL || "↺ Rotate L", function() {
      _rotation = (_rotation - 90 + 360) % 360;
      _loadImage(zoomSlider);
    });
    var rotRBtn = mkBtn(i18n.rotateR || "↻ Rotate R", function() {
      _rotation = (_rotation + 90) % 360;
      _loadImage(zoomSlider);
    });
    var flipHBtn = mkBtn(i18n.flipH || "⇄ Flip H", function() { _flipH = !_flipH; _render(); });
    var flipVBtn = mkBtn(i18n.flipV || "⇅ Flip V", function() { _flipV = !_flipV; _render(); });
    var orientLBtn = mkBtn(i18n.orient_landscape || "🖼️ Landscape", function() {
      if (_targetRatio < 1) { _targetRatio = 1 / _targetRatio; _loadImage(zoomSlider); }
    });
    var orientPBtn = mkBtn(i18n.orient_portrait || "🧍 Portrait", function() {
      if (_targetRatio > 1) { _targetRatio = 1 / _targetRatio; _loadImage(zoomSlider); }
    });
    
    // Row 1 & 2: buttons ανάλογα με template
    if (_templateKey === "rect_54x78") {
      btnRow.style.gridTemplateColumns = "1fr 1fr 1fr";
      btnRow.appendChild(rotLBtn);
      btnRow.appendChild(flipHBtn);
      btnRow.appendChild(orientLBtn);
      btnRow.appendChild(rotRBtn);
      btnRow.appendChild(flipVBtn);
      btnRow.appendChild(orientPBtn);
    } else {
      btnRow.style.gridTemplateColumns = "1fr 1fr";
      btnRow.appendChild(rotLBtn);
      btnRow.appendChild(flipHBtn);
      btnRow.appendChild(rotRBtn);
      btnRow.appendChild(flipVBtn);
    }

    // ── Filters row ──────────────────────────────────────────────
    var filterRow = document.createElement("div");
    filterRow.style.cssText = "display:flex;gap:6px;margin-top:8px;justify-content:center;flex-wrap:wrap;align-items:center;";

    // B&W toggle
    var bwBtn = document.createElement("button");
    bwBtn.textContent = i18n.filterBw || "▨ B&W";
    bwBtn.style.cssText = "padding:7px 12px;border:1px solid #ccc;border-radius:8px;background:#f5f5f5;cursor:pointer;font-size:13px;";
    bwBtn.addEventListener("click", function() {
      _bw = !_bw;
      bwBtn.style.background = _bw ? "#222" : "#f5f5f5";
      bwBtn.style.color = _bw ? "#fff" : "#000";
      _render();
    });
    filterRow.appendChild(bwBtn);

    // Warm / Cool toggles (αμοιβαία αποκλειόμενα)
    var warmBtn = document.createElement("button");
    warmBtn.textContent = i18n.filterWarm || "☀️ Warm";
    warmBtn.style.cssText = "padding:7px 12px;border:1px solid #ccc;border-radius:8px;background:#f5f5f5;cursor:pointer;font-size:13px;";
    var coolBtn = document.createElement("button");
    coolBtn.textContent = i18n.filterCool || "❄️ Cool";
    coolBtn.style.cssText = "padding:7px 12px;border:1px solid #ccc;border-radius:8px;background:#f5f5f5;cursor:pointer;font-size:13px;";
    function updateTempBtns() {
      warmBtn.style.background = _colorTemp === 1 ? "#f90" : "#f5f5f5";
      warmBtn.style.color = _colorTemp === 1 ? "#fff" : "#000";
      coolBtn.style.background = _colorTemp === -1 ? "#4af" : "#f5f5f5";
      coolBtn.style.color = _colorTemp === -1 ? "#fff" : "#000";
    }
    warmBtn.addEventListener("click", function() { _colorTemp = _colorTemp === 1 ? 0 : 1; updateTempBtns(); _render(); });
    coolBtn.addEventListener("click", function() { _colorTemp = _colorTemp === -1 ? 0 : -1; updateTempBtns(); _render(); });
    filterRow.appendChild(warmBtn);
    filterRow.appendChild(coolBtn);

    // Brightness slider
    var brRow = document.createElement("div");
    brRow.style.cssText = "display:flex;align-items:center;gap:6px;margin-top:8px;width:100%;";
    var brLbl = document.createElement("span");
    brLbl.style.cssText = "font-size:12px;color:#666;white-space:nowrap;width:90px;";
    brLbl.textContent = (i18n.filterBright || "☀ Bright") + ": 0";
    var brSlider = document.createElement("input");
    brSlider.type = "range"; brSlider.min = "-50"; brSlider.max = "50"; brSlider.value = "0";
    brSlider.style.cssText = "flex:1;";
    brSlider.addEventListener("input", function() {
      _brightness = parseInt(this.value);
      brLbl.textContent = (i18n.filterBright || "☀ Bright") + ": " + _brightness;
      _render();
    });
    brRow.appendChild(brLbl); brRow.appendChild(brSlider);

    // Contrast slider
    var conRow = document.createElement("div");
    conRow.style.cssText = "display:flex;align-items:center;gap:6px;margin-top:6px;width:100%;";
    var conLbl = document.createElement("span");
    conLbl.style.cssText = "font-size:12px;color:#666;white-space:nowrap;width:90px;";
    conLbl.textContent = (i18n.filterContrast || "◑ Contrast") + ": 0";
    var conSlider = document.createElement("input");
    conSlider.type = "range"; conSlider.min = "-50"; conSlider.max = "50"; conSlider.value = "0";
    conSlider.style.cssText = "flex:1;";
    conSlider.addEventListener("input", function() {
      _contrast = parseInt(this.value);
      conLbl.textContent = (i18n.filterContrast || "◑ Contrast") + ": " + _contrast;
      _render();
    });
    conRow.appendChild(conLbl); conRow.appendChild(conSlider);

    // Saturation slider
    var satRow = document.createElement("div");
    satRow.style.cssText = "display:flex;align-items:center;gap:6px;margin-top:6px;width:100%;";
    var satLbl = document.createElement("span");
    satLbl.style.cssText = "font-size:12px;color:#666;white-space:nowrap;width:90px;";
    satLbl.textContent = (i18n.filterSaturation || "🎨 Sat") + ": 0";
    var satSlider = document.createElement("input");
    satSlider.type = "range"; satSlider.min = "-50"; satSlider.max = "50"; satSlider.value = "0";
    satSlider.style.cssText = "flex:1;";
    satSlider.addEventListener("input", function() {
      _saturation = parseInt(this.value);
      satLbl.textContent = (i18n.filterSaturation || "🎨 Sat") + ": " + _saturation;
      _render();
    });
    satRow.appendChild(satLbl); satRow.appendChild(satSlider);

// Mobile only: reserve space for filter labels and numeric values.
if (window.matchMedia("(max-width: 767px)").matches) {
  [brLbl, conLbl, satLbl].forEach(function(label) {
    label.style.width = "125px";
    label.style.flex = "0 0 125px";
  });

  [brSlider, conSlider, satSlider].forEach(function(slider) {
    slider.style.flex = "1 1 0";
    slider.style.width = "0";
    slider.style.minWidth = "0";
  });
}

    var actRow = document.createElement("div");
    actRow.style.cssText = "display:flex;gap:8px;margin-top:14px;";
    var applyBtn = document.createElement("button");
    applyBtn.textContent = i18n.cropApply || "✅ Apply";
    applyBtn.style.cssText = "flex:1;padding:11px;background:#222;color:#fff;border:none;border-radius:8px;font-size:15px;font-weight:bold;cursor:pointer;";
    var cancelBtn = document.createElement("button");
    cancelBtn.textContent = i18n.cropCancel || "✕ Cancel";
    cancelBtn.style.cssText = "padding:11px 16px;background:#f5f5f5;border:1px solid #ccc;border-radius:8px;font-size:14px;cursor:pointer;";
    actRow.appendChild(applyBtn); actRow.appendChild(cancelBtn);

        box.appendChild(title); box.appendChild(_canvas);
    box.appendChild(zoomRow); box.appendChild(btnRow);
    box.appendChild(filterRow);
    box.appendChild(brRow); box.appendChild(conRow); box.appendChild(satRow);
        box.appendChild(actRow);

    overlay.appendChild(box);
    document.body.appendChild(overlay);

    applyBtn.addEventListener("click", function() {
  var dataUrl = _export();
  var finalOrientation = _targetRatio > 1 ? "landscape" : "portrait";
  _cleanup();
  _onDone(dataUrl, finalOrientation);
});

    cancelBtn.addEventListener("click", function() {
      _cleanup();
      _onDone(null);
    });

    _canvas.addEventListener("mousedown", function(e) {
      var p = _getPos(e.clientX, e.clientY);
      var corner = _nearCorner(p.x, p.y);
      if (corner) {
        _resizing = true;
        _resizeStartX = p.x; _resizeStartY = p.y;
        _resizeOriginW = _cropW; _resizeOriginH = _cropH;
        _resizeOriginX = _cropX; _resizeOriginY = _cropY;
        _canvas.style.cursor = "nwse-resize";
      } else if (_inCrop(p.x, p.y)) {
        _dragging = true;
        _dragStartX = p.x; _dragStartY = p.y;
        _dragOriginX = _cropX; _dragOriginY = _cropY;
        _canvas.style.cursor = "move";
      }
    });

            _canvas.addEventListener("mousemove", function(e) {
      var p = _getPos(e.clientX, e.clientY);
      if (_resizing) {
        var dx = p.x - _resizeStartX;
        var dy = p.y - _resizeStartY;
        var delta = (Math.abs(dx) > Math.abs(dy)) ? dx : dy;
        var newW = Math.max(MIN_CROP, _resizeOriginW + delta);
        var newH = Math.round(newW / _targetRatio);
        _cropW = newW; _cropH = newH;
        _cropX = _resizeOriginX; _cropY = _resizeOriginY;
            _clampCrop();
    _syncZoomSlider(zoomSlider);
    _render();
  } else if (_dragging) {
    _cropX = _dragOriginX + (p.x - _dragStartX);
    _cropY = _dragOriginY + (p.y - _dragStartY);
    _clampCrop(); _render();
  } else {
    var corner = _nearCorner(p.x, p.y);
    _canvas.style.cursor = corner ? "nwse-resize" : (_inCrop(p.x, p.y) ? "move" : "crosshair");
  }
});

    _canvas.addEventListener("mouseup", function() {
      _dragging = false; _resizing = false;
      _canvas.style.cursor = "crosshair";
    });
    _canvas.addEventListener("mouseleave", function() {
      _dragging = false; _resizing = false;
      _canvas.style.cursor = "crosshair";
    });

        _canvas.addEventListener("touchstart", function(e) {
      if (e.touches.length === 2) { _lastPinchDist = _pinchDist(e); return; }
      var t = e.touches[0]; var p = _getPos(t.clientX, t.clientY);
      _touchStartTime = Date.now();
      if (_inCrop(p.x, p.y)) { _dragging = true; _dragStartX = p.x; _dragStartY = p.y; _dragOriginX = _cropX; _dragOriginY = _cropY; }
    }, { passive: true });

        _canvas.addEventListener("touchmove", function(e) {
      e.preventDefault();
      if (e.touches.length === 2) {
        var d = _pinchDist(e);
        if (_lastPinchDist) {
          var scale = d / _lastPinchDist;
          var newW = Math.round(_cropW * scale);
          var newH = Math.round(newW / _targetRatio);
          _cropX = Math.round(_cropX + (_cropW - newW) / 2);
          _cropY = Math.round(_cropY + (_cropH - newH) / 2);
          _cropW = newW; _cropH = newH;
          _clampCrop();
                          _syncZoomSlider(zoomSlider);
        _render();
      }
      _lastPinchDist = d; return;

      }
      if (!_dragging) return;
      var t = e.touches[0]; var p = _getPos(t.clientX, t.clientY);
      _cropX = _dragOriginX + (p.x - _dragStartX);
          _cropY = _dragOriginY + (p.y - _dragStartY);
    _clampCrop(); _render();
  }, { passive: false });

    _canvas.addEventListener("touchend", function(e) {
      _dragging = false; _lastPinchDist = null;
      if (e.changedTouches.length === 1) {
        var now = Date.now();
        var tapDuration = now - _touchStartTime;
        if (tapDuration < 200 && now - _lastTapTime < 300) {
          var maxByW = _displayW;
          var maxByH = Math.round(_displayH * _targetRatio);
          var maxSide = Math.min(maxByW, maxByH) * 0.9;
          _cropW = Math.round(maxSide);
          _cropH = Math.round(_cropW / _targetRatio);
          _cropX = Math.round((_displayW - _cropW) / 2);
          _cropY = Math.round((_displayH - _cropH) / 2);
          _clampCrop(); _render();
          if (zoomSlider) zoomSlider.value = 90;
        }
        _lastTapTime = now;
      }
    });

    zoomSlider.addEventListener("input", function() {
      var pct = parseFloat(this.value) / 100;
      var maxByW = _displayW;
      var maxByH = Math.round(_displayH * _targetRatio);
      var maxSide = Math.min(maxByW, maxByH) * pct;
      _cropW = Math.round(maxSide);
      _cropH = Math.round(_cropW / _targetRatio);
              _clampCrop();
    _render();
  });

  _img = new Image();
    _img.onload = function() { _loadImage(zoomSlider); };
    var reader = new FileReader();
    reader.onload = function(e) { _img.src = e.target.result; };
    reader.readAsDataURL(file);
  }

    function _loadImage(zoomSlider) {
    var maxW = Math.min(340, window.innerWidth - 60);
    var maxH = maxW;
    var iW = _img.naturalWidth, iH = _img.naturalHeight;
    var rotated = (_rotation === 90 || _rotation === 270);
    var srcW = rotated ? iH : iW;
    var srcH = rotated ? iW : iH;
    var sc = Math.min(maxW / srcW, maxH / srcH);
    _displayW = Math.round(srcW * sc);
    _displayH = Math.round(srcH * sc);
    _scaleX = srcW / _displayW;
    _scaleY = srcH / _displayH;

    _canvas.width  = _displayW;
    _canvas.height = _displayH;
    _canvas.style.width  = _displayW + "px";
    _canvas.style.height = _displayH + "px";
    _ctx = _canvas.getContext("2d");

    if (zoomSlider) zoomSlider.value = 90;
    var pct = 0.9;
    var maxByW = _displayW;
    var maxByH = Math.round(_displayH * _targetRatio);
    var maxSide = Math.min(maxByW, maxByH) * pct;
    _cropW = Math.round(maxSide);
    _cropH = Math.round(_cropW / _targetRatio);
    _cropX = Math.round((_displayW - _cropW) / 2);
    _cropY = Math.round((_displayH - _cropH) / 2);
        _clampCrop();
   
    _render();
  }

  function _getPos(clientX, clientY) {
    var rect = _canvas.getBoundingClientRect();
    var scaleX = _canvas.width / rect.width;
    var scaleY = _canvas.height / rect.height;
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY
    };
  }

  function _inCrop(x, y) {
    var margin = 20;
    return x >= _cropX - margin && x <= _cropX + _cropW + margin &&
           y >= _cropY - margin && y <= _cropY + _cropH + margin;
  }

  function _clampCrop() {
    if (_cropX === undefined) { _cropX = Math.round((_displayW - _cropW) / 2); _cropY = Math.round((_displayH - _cropH) / 2); return; }
    if (_cropW > _displayW) { _cropW = _displayW; _cropH = Math.round(_cropW / _targetRatio); }
    if (_cropH > _displayH) { _cropH = _displayH; _cropW = Math.round(_cropH * _targetRatio); }
    if (_cropW < MIN_CROP) { _cropW = MIN_CROP; _cropH = Math.round(_cropW / _targetRatio); }
    if (_cropH < MIN_CROP) { _cropH = MIN_CROP; _cropW = Math.round(_cropH * _targetRatio); }
    if (_cropX < 0) _cropX = 0;
    if (_cropY < 0) _cropY = 0;
    if (_cropX + _cropW > _displayW) _cropX = _displayW - _cropW;
    if (_cropY + _cropH > _displayH) _cropY = _displayH - _cropH;
    if (_cropX < 0) _cropX = 0;
    if (_cropY < 0) _cropY = 0;
  }

  function _render() {
    if (!_ctx || !_img) return;
    _ctx.clearRect(0, 0, _displayW, _displayH);

    // Build CSS filter string
    var filters = [];
    if (_bw) filters.push("grayscale(100%)");
    if (_colorTemp === 1)  filters.push("sepia(40%)");
    if (_colorTemp === -1) filters.push("hue-rotate(200deg) saturate(120%)");
    filters.push("brightness(" + (100 + _brightness) + "%)");
    filters.push("contrast(" + (100 + _contrast) + "%)");
    filters.push("saturate(" + (100 + _saturation) + "%)");
    _ctx.filter = filters.join(" ");

    _ctx.save();
    _ctx.translate(_displayW / 2, _displayH / 2);
    _ctx.rotate(_rotation * Math.PI / 180);
    _ctx.scale(_flipH ? -1 : 1, _flipV ? -1 : 1);
    var rotated = (_rotation === 90 || _rotation === 270);
    var dW = rotated ? _displayH : _displayW;
    var dH = rotated ? _displayW : _displayH;
    _ctx.drawImage(_img, -dW / 2, -dH / 2, dW, dH);
    _ctx.restore();

    // Reset filter για overlay elements
    _ctx.filter = "none";

    _ctx.fillStyle = "rgba(0,0,0,0.45)";
    _ctx.fillRect(0, 0, _displayW, _cropY);
    _ctx.fillRect(0, _cropY + _cropH, _displayW, _displayH - _cropY - _cropH);
    _ctx.fillRect(0, _cropY, _cropX, _cropH);
    _ctx.fillRect(_cropX + _cropW, _cropY, _displayW - _cropX - _cropW, _cropH);

    var hasBleed = (_templateKey === "square_50x50" || _templateKey === "rect_54x78");
    if (hasBleed) {
      var bleed = Math.round(_cropW * 0.04);
      _ctx.strokeStyle = "rgba(255,80,80,0.85)";
      _ctx.lineWidth = 1.5;
      _ctx.setLineDash([5, 4]);
      _ctx.strokeRect(
        _cropX + bleed, _cropY + bleed,
        _cropW - bleed * 2, _cropH - bleed * 2
      );
      _ctx.setLineDash([]);
    }

    _ctx.strokeStyle = "#fff";
    _ctx.lineWidth = 2;
    _ctx.setLineDash([]);
    _ctx.strokeRect(_cropX, _cropY, _cropW, _cropH);

    _ctx.strokeStyle = "rgba(255,255,255,0.35)";
    _ctx.lineWidth = 1;
    for (var i = 1; i < 3; i++) {
      _ctx.beginPath();
      _ctx.moveTo(_cropX + _cropW * i / 3, _cropY);
      _ctx.lineTo(_cropX + _cropW * i / 3, _cropY + _cropH);
      _ctx.stroke();
      _ctx.beginPath();
      _ctx.moveTo(_cropX, _cropY + _cropH * i / 3);
      _ctx.lineTo(_cropX + _cropW, _cropY + _cropH * i / 3);
      _ctx.stroke();
    }

    _ctx.fillStyle = "#fff";
    var hs = 8;
        [[_cropX,_cropY],[_cropX+_cropW-hs,_cropY],[_cropX,_cropY+_cropH-hs],[_cropX+_cropW-hs,_cropY+_cropH-hs]].forEach(function(c) {
      _ctx.fillRect(c[0], c[1], hs, hs);
        });
            // E.14 — Έλεγχος ανάλυσης του τρέχοντος crop για το template
    var tpl = TEMPLATE_SHAPES && TEMPLATE_SHAPES[_templateKey];
    if (tpl) {
      var requiredW = tpl.w;
      var requiredH = tpl.h;

      if (_targetRatio > 1 && requiredW < requiredH) {
        var tmp = requiredW; requiredW = requiredH; requiredH = tmp;
      }
      if (_targetRatio < 1 && requiredW > requiredH) {
        var tmp = requiredW; requiredW = requiredH; requiredH = tmp;
      }

      var srcCropW = Math.round(_cropW * _scaleX);
      var srcCropH = Math.round(_cropH * _scaleY);
      var warn = document.getElementById("p2m-lowres-warn");

      if (!warn) {
        warn = document.createElement("div");
        warn.id = "p2m-lowres-warn";
        warn.style.cssText = "display:none;background:#fff3cd;color:#856404;border:1px solid #ffc107;border-radius:6px;padding:6px 10px;font-size:12px;margin-top:6px;text-align:center;";
        _canvas.parentNode.insertBefore(warn, _canvas.nextSibling);
      }

      if (srcCropW < requiredW || srcCropH < requiredH) {
        warn.textContent = "⚠️ " + (i18n.lowResWarning ||
          "Low resolution photo — print quality may be reduced.");
        warn.style.display = "block";
      } else {
        warn.style.display = "none";
      }
    }
          }

   function _export() {
    var tpl = TEMPLATE_SHAPES && TEMPLATE_SHAPES[_templateKey];
    var printW = tpl ? tpl.w : _cropW;
    var printH = tpl ? tpl.h : _cropH;
if (_targetRatio > 1 && printW < printH) { var _t = printW; printW = printH; printH = _t; }
if (_targetRatio < 1 && printW > printH) { var _t = printW; printW = printH; printH = _t; }

    var scaleX = printW / _cropW;
    var scaleY = printH / _cropH;

    var filters = [];
    if (_bw) filters.push("grayscale(100%)");
    if (_colorTemp === 1)  filters.push("sepia(40%)");
    if (_colorTemp === -1) filters.push("hue-rotate(200deg) saturate(120%)");
    filters.push("brightness(" + (100 + _brightness + PRINT_CORRECTION.brightness) + "%)");
    filters.push("contrast("   + (100 + _contrast   + PRINT_CORRECTION.contrast)   + "%)");
    filters.push("saturate("   + (100 + _saturation  + PRINT_CORRECTION.saturation) + "%)");

    // Render σε high-res canvas
    var hiCanvas = document.createElement("canvas");
    hiCanvas.width  = Math.round(_displayW * scaleX);
    hiCanvas.height = Math.round(_displayH * scaleY);
    var hc = hiCanvas.getContext("2d");
    hc.filter = filters.join(" ");
    hc.save();
    hc.translate(hiCanvas.width / 2, hiCanvas.height / 2);
    hc.rotate(_rotation * Math.PI / 180);
    hc.scale(_flipH ? -1 : 1, _flipV ? -1 : 1);
    var rotated = (_rotation === 90 || _rotation === 270);
    var dW = rotated ? hiCanvas.height : hiCanvas.width;
    var dH = rotated ? hiCanvas.width  : hiCanvas.height;
    hc.drawImage(_img, -dW / 2, -dH / 2, dW, dH);
    hc.restore();
    hc.filter = "none";

    // Crop από high-res canvas
    var expCanvas = document.createElement("canvas");
    expCanvas.width  = printW;
    expCanvas.height = printH;
    var ec = expCanvas.getContext("2d");
        ec.drawImage(hiCanvas,
      Math.round(_cropX * scaleX), Math.round(_cropY * scaleY),
      printW, printH,
      0, 0, printW, printH
    );

    _render();

    return expCanvas.toDataURL("image/jpeg", 0.92);
  }

  function _pinchDist(e) {
    var dx = e.touches[0].clientX - e.touches[1].clientX;
    var dy = e.touches[0].clientY - e.touches[1].clientY;
    return Math.sqrt(dx*dx + dy*dy);
  }

    function _renderOverlay() {
    if (!_ctx || !_textState) return;
    var tpl = TEMPLATE_SHAPES && TEMPLATE_SHAPES[_templateKey];
    if (!tpl || !tpl.hasText) return;
    if (_templateKey.indexOf("std_") !== 0) return;

    var font = _textState.selectedFont || "Pacifico";
    var titleText = _textState.useCustomTitle
      ? (_textState.textValues["title_custom"] || "")
      : "Save the Date";
    var names    = _textState.textValues["names"]    || "";
    var date     = _textState.textValues["date"]     || "";
    var location = _textState.textValues["location"] || "";

    var styT = _textState.textStyles["title"]    || {};
    var styN = _textState.textStyles["names"]     || {};
    var styD = _textState.textStyles["date"]      || {};
    var styL = _textState.textStyles["location"]  || {};

    var cx = _cropX + _cropW / 2;
    var lineH = Math.round(_cropH * 0.13);
    var startY = _cropY + Math.round(_cropH * 0.25);

    _ctx.textBaseline = "middle";
    _ctx.shadowColor = "rgba(0,0,0,0.6)";
    _ctx.shadowBlur = 4;

    // Title
    var tAlign = styT.align || "center";
    var tX = tAlign === "left" ? _cropX + 8 : tAlign === "right" ? _cropX + _cropW - 8 : cx;
    _ctx.textAlign = tAlign;
    _ctx.font = (styT.bold === false ? "" : "bold ") + lineH + "px '" + (styT.font || font) + "', serif";
    _ctx.fillStyle = styT.color || "#fff";
    _ctx.fillText(titleText, tX, startY);

    // Names
    var nAlign = styN.align || "center";
    var nX = nAlign === "left" ? _cropX + 8 : nAlign === "right" ? _cropX + _cropW - 8 : cx;
    _ctx.textAlign = nAlign;
    _ctx.font = (styN.bold ? "bold " : "") + Math.round(lineH * 0.75) + "px '" + (styN.font || "Lato") + "', sans-serif";
    _ctx.fillStyle = styN.color || "#fff";
    _ctx.fillText(names, nX, startY + lineH * 1.2);

    // Date
    var dAlign = styD.align || "center";
    var dX = dAlign === "left" ? _cropX + 8 : dAlign === "right" ? _cropX + _cropW - 8 : cx;
    _ctx.textAlign = dAlign;
    _ctx.font = (styD.bold ? "bold " : "") + Math.round(lineH * 0.65) + "px '" + (styD.font || "Lato") + "', sans-serif";
    _ctx.fillStyle = styD.color || "#fff";
    _ctx.fillText(date, dX, startY + lineH * 2.2);

    // Location
    var lAlign = styL.align || "center";
    var lX = lAlign === "left" ? _cropX + 8 : lAlign === "right" ? _cropX + _cropW - 8 : cx;
    _ctx.textAlign = lAlign;
    _ctx.font = (styL.bold ? "bold " : "") + Math.round(lineH * 0.6) + "px '" + (styL.font || "Lato") + "', sans-serif";
    _ctx.fillStyle = styL.color || "#fff";
    _ctx.fillText(location, lX, startY + lineH * 3.1);

    _ctx.shadowBlur = 0;
    _ctx.textAlign = "left";
    _ctx.textBaseline = "alphabetic";
  }

  function _renderOverlayOnExport(ec, printW, printH) {
    if (!_textState) return;
    var tpl = TEMPLATE_SHAPES && TEMPLATE_SHAPES[_templateKey];
    if (!tpl || !tpl.hasText) return;
    if (_templateKey.indexOf("std_") !== 0) return;

    var font = _textState.selectedFont || "Pacifico";
    var titleText = _textState.useCustomTitle
      ? (_textState.textValues["title_custom"] || "")
      : "Save the Date";
    var names    = _textState.textValues["names"]    || "";
    var date     = _textState.textValues["date"]     || "";
    var location = _textState.textValues["location"] || "";

    var cx = printW / 2;
    var lineH = Math.round(printH * 0.13);
    var startY = Math.round(printH * 0.25);

    ec.textAlign = "center";
    ec.textBaseline = "middle";
    ec.shadowColor = "rgba(0,0,0,0.6)";
    ec.shadowBlur = 8;

    ec.font = "bold " + lineH + "px '" + font + "', serif";
    ec.fillStyle = "#fff";
    ec.fillText(titleText, cx, startY);

    ec.font = Math.round(lineH * 0.75) + "px 'Lato', sans-serif";
    ec.fillText(names, cx, startY + lineH * 1.2);

    ec.font = Math.round(lineH * 0.65) + "px 'Lato', sans-serif";
    ec.fillText(date, cx, startY + lineH * 2.2);

    ec.font = Math.round(lineH * 0.6) + "px 'Lato', sans-serif";
    ec.fillText(location, cx, startY + lineH * 3.1);

    ec.shadowBlur = 0;
    ec.textAlign = "left";
    ec.textBaseline = "alphabetic";
  }

  function _cleanup() {
    _dragging = false; _resizing = false; _lastPinchDist = null;
    var el = document.getElementById("p2m-crop-overlay");
    if (el) el.parentNode.removeChild(el);
    _canvas = null; _ctx = null; _img = null;
  }

  return { open: open };
})();

function buildSlotEl(container, slotIdx, templateId, monthLabel, slotQtyLabel) {
    var slot = state.slots[slotIdx];
    var def  = TEMPLATE_SHAPES[templateId] || TEMPLATE_SHAPES["square_50x50"];
    var canToggle = false;
    var orientation = slot ? (slot.orientation || (def.landscape ? "landscape" : "portrait")) : (def.landscape ? "landscape" : "portrait");
    var qty = slot ? (slot.qty || 1) : 1;
    var labelText = monthLabel || (i18n.slotLabel + " " + (slotIdx + 1));
    var showQty = productFlags.showQtyBtns && !monthLabel;

    var wrap = document.createElement("div");
    wrap.style.cssText = "border:1px solid #e0e0e0;border-radius:10px;padding:12px;margin-bottom:10px;background:#fff;";

    var qtyDisplay = "";
    var isMobile = window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);
    var qBtnSz = isMobile ? "30px" : "26px";
var qBtnLh = isMobile ? "30px" : "24px";
var qBtnFs = isMobile ? "17px" : "16px";

    if (productFlags.magnetPackMode) {
      qtyDisplay =
        "<button class='p2m-qty-btn' data-idx='" + slotIdx + "' data-delta='-10' style='width:" + qBtnSz + ";height:" + qBtnSz + ";border-radius:50%;border:1px solid #ccc;cursor:pointer;font-size:" + qBtnFs + ";background:#f5f5f5;line-height:" + qBtnLh + ";text-align:center;padding:0;" + (state.slots.length >= Math.round(state.totalSlots / productFlags.magnetPackStep) ? " opacity:0.4;pointer-events:none;" : "") + "'>−</button>" +
                "<span style='font-size:13px;font-weight:bold;min-width:60px;text-align:center;'>" + qty +
        (/^el(?:-|$)/i.test(document.documentElement.lang || "") ? " τμχ" : " pcs") + "</span>" +
        "<button class='p2m-qty-btn' data-idx='" + slotIdx + "' data-delta='10' style='width:" + qBtnSz + ";height:" + qBtnSz + ";border-radius:50%;border:1px solid #ccc;cursor:pointer;font-size:" + qBtnFs + ";background:#f5f5f5;line-height:" + qBtnLh + ";text-align:center;padding:0;" + (slot.qty >= state.totalSlots ? " opacity:0.4;pointer-events:none;" : "") + "'>+</button>";
    } else if (showQty) {
      var sectionFull = true;
      if (state.sections && slot && slot.sectionIdx >= 0) {
        for (var bk = 0; bk < state.slots.length; bk++) {
          if (bk !== slotIdx && state.slots[bk] && state.slots[bk].sectionIdx === slot.sectionIdx && !state.slots[bk].uploadedUrl) {
            sectionFull = false; break;
          }
        }
      } else {
        sectionFull = usedQty() >= state.totalSlots;
      }
      qtyDisplay =
        "<button class='p2m-qty-btn' data-idx='" + slotIdx + "' data-delta='-1' style='width:" + qBtnSz + ";height:" + qBtnSz + ";border-radius:50%;border:1px solid #ccc;cursor:pointer;font-size:" + qBtnFs + ";background:#f5f5f5;line-height:" + qBtnLh + ";text-align:center;padding:0;" + (qty<=1?" opacity:0.4;pointer-events:none;":"") + "'>−</button>" +
        "<span style='font-size:14px;font-weight:bold;min-width:20px;text-align:center;'>" + qty + "</span>" +
        "<button class='p2m-qty-btn' data-idx='" + slotIdx + "' data-delta='1' style='width:" + qBtnSz + ";height:" + qBtnSz + ";border-radius:50%;border:1px solid #ccc;cursor:pointer;font-size:" + qBtnFs + ";background:#f5f5f5;line-height:" + qBtnLh + ";text-align:center;padding:0;" + (sectionFull ? " opacity:0.4;pointer-events:none;" : "") + "'>+</button>";
    }

    wrap.innerHTML =
      "<div style='display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;'>" +
        "<span style='font-weight:bold;font-size:13px;color:#333;'>" + labelText + "</span>" +
        "<div style='display:flex;align-items:center;gap:6px;'>" +
          (canToggle
            ? "<button class='p2m-orient-btn' data-idx='" + slotIdx + "' data-orient='portrait' style='font-size:" + (isMobile?"13px":"11px") + ";padding:" + (isMobile?"8px 12px":"3px 7px") + ";border-radius:4px;border:1px solid #ccc;cursor:pointer;background:" + (orientation==="portrait"?"#222":"#fff") + ";color:" + (orientation==="portrait"?"#fff":"#333") + ";'>" + i18n.portrait + "</button>" +
              "<button class='p2m-orient-btn' data-idx='" + slotIdx + "' data-orient='landscape' style='font-size:" + (isMobile?"13px":"11px") + ";padding:" + (isMobile?"8px 12px":"3px 7px") + ";border-radius:4px;border:1px solid #ccc;cursor:pointer;background:" + (orientation==="landscape"?"#222":"#fff") + ";color:" + (orientation==="landscape"?"#fff":"#333") + ";'>" + i18n.landscape + "</button>"
            : "") +
          qtyDisplay +
          (productFlags.singleSlot
            ? (slot && slot.uploadedUrl
                ? "<button class='p2m-remove-btn' data-idx='" + slotIdx + "' style='background:#888;color:#fff;border:none;border-radius:12px;padding:" + (isMobile?"8px 12px":"2px 8px") + ";cursor:pointer;font-size:" + (isMobile?"13px":"11px") + ";'>🔄</button>"
                : "")
            : "<button class='p2m-remove-btn' data-idx='" + slotIdx + "' style='background:#e44;color:#fff;border:none;border-radius:50%;width:" + (isMobile?"30px":"22px") + ";height:" + (isMobile?"30px":"22px") + ";cursor:pointer;font-size:" + (isMobile?"17px":"12px") + ";line-height:" + (isMobile?"30px":"22px") + ";text-align:center;padding:0;'>×</button>") +
        "</div>" +
      "</div>" +
            "<div style='display:flex;gap:10px;align-items:flex-start;" +
        (isMobile ? "flex-direction:column;" : "") + "'>" +
        (slot && slot.previewUrl
          ? "<canvas class='p2m-slot-canvas' data-idx='" + slotIdx +
            "' style='border-radius:6px;border:1px solid #eee;flex-shrink:0;" +
            (isMobile ? "max-width:100%;height:auto;box-sizing:border-box;" : "") +
            "'></canvas>"
          : "<div class='p2m-slot-dropzone' data-idx='" + slotIdx +
            "' data-template='" + templateId +
            "' style='width:80px;height:80px;border:2px dashed #ccc;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;background:#fafafa;flex-shrink:0;font-size:22px;color:#bbb;'>📷" +
            "<input type='file' class='p2m-slot-file' data-idx='" + slotIdx +
            "' accept='image/*' multiple style='display:none;'/></div>") +
        ((!isMobile || (slot && (slot.uploading || slot.error || slot.uploadedUrl)) || def.bleed)
          ? "<div style='flex:1;min-width:0;font-size:12px;color:#999;overflow-wrap:anywhere;" +
              (isMobile ? "order:-1;width:100%;box-sizing:border-box;" : "") +
              "'>" +
              (slot && slot.uploading
                ? "<span style='color:#e08800;'>⏳ " + i18n.uploading + "</span>"
                : "") +
              (slot && slot.error
                ? "<span style='color:#e44;'>❌ " + slot.error + "</span>"
                : "") +
              (slot && slot.uploadedUrl
                ? "<span style='color:#2a7a2a;font-size:16px;'>✅</span>"
                : "") +
              (def.bleed
                ? (isMobile ? "" : "<br/>") +
                  "<span style='color:#aaa;font-size:11px;'>" +
                  (i18n.bleedLabel || "--- περιθώριο κοπής 2mm")
                    .replace(/^(\s*---)/, "<span style='color:#ff5050;'>$1</span>") +
                  "</span>"
                : "") +
            "</div>"
          : "") +
      "</div>";

        // per-slot caption fields (polaroid: show only after photo uploaded)
    if (def.hasText && def.perSlotCaption && def.textFields) {
      if (slot && slot.previewUrl) {
        var captionDiv = document.createElement('div');
        captionDiv.style.cssText = 'margin-top:10px;border-top:1px solid #eee;padding-top:8px;';
        def.textFields.forEach(function(field) {
          if (field.type === 'font-select') return;
          var val = (state.slotCaptions[slotIdx] && state.slotCaptions[slotIdx][field.key]) || '';
          var sty = (state.textStyles && state.textStyles[slotIdx] && state.textStyles[slotIdx][field.key]) || {};
          var curFont = sty.font || 'Lato';
          var curSize = sty.size || 28;
          var curColor = sty.color || '#333333';
          var curBold = sty.bold || false;
          var curAlign = sty.align || 'center';
          var curRotation = sty.rotation || 0;
          var fieldDiv = document.createElement('div');
          fieldDiv.style.cssText = 'margin-top:6px;';
          fieldDiv.innerHTML =
            '<div style="font-size:11px;color:#666;margin-bottom:3px;">' + (i18n[field.key + 'Label'] || field.label) + '</div>' +
            '<input type="text" class="p2m-slot-caption" data-idx="' + slotIdx + '" data-key="' + field.key + '" placeholder="' + (i18n.customPlaceholder || 'Γράψε το κείμενό σου') + '..." value="' + val.replace(/"/g,'&quot;') + '" style="width:100%;padding:6px 8px;border:1px solid #ddd;border-radius:6px;font-size:12px;box-sizing:border-box;margin-bottom:4px;"/>' +
            '<div style="display:flex;flex-wrap:wrap;gap:4px;align-items:center;margin-bottom:4px;">' +
              '<select class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="font" style="font-size:11px;padding:2px 4px;border:1px solid #ddd;border-radius:4px;max-width:120px;">' +
                ['GFS Didot','Noto Serif','Vollkorn','Alegreya','EB Garamond','Ubuntu','Noto Sans','Source Sans 3'].map(function(f){ return '<option value="' + f + '"' + (curFont===f?' selected':'') + '>' + f + '</option>'; }).join('') +
              '</select>' +
              '<input type="number" class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="size" value="' + curSize + '" min="8" max="120" style="width:46px;font-size:11px;padding:2px 4px;border:1px solid #ddd;border-radius:4px;"/>' +
              '<input type="color" class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="color" value="' + curColor + '" style="width:28px;height:24px;padding:0;border:none;cursor:pointer;"/>' +
              '<button class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="bold" data-val="' + (!curBold) + '" style="padding:2px 7px;border:1px solid #ddd;border-radius:4px;font-weight:bold;font-size:11px;background:' + (curBold?'#333':'#fff') + ';color:' + (curBold?'#fff':'#333') + ';cursor:pointer;">B</button>' +
            '</div>' +
            '<div style="display:flex;gap:4px;align-items:center;">' +
              ['left','center','right'].map(function(a){ var icon=a==='left'?'⬅':a==='center'?'☰':'➡'; var active=curAlign===a; return '<button class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="align" data-val="' + a + '" style="padding:2px 6px;border:1px solid #ddd;border-radius:4px;font-size:11px;background:' + (active?'#333':'#fff') + ';color:' + (active?'#fff':'#333') + ';cursor:pointer;">' + icon + '</button>'; }).join('') +
              '<span style="font-size:10px;color:#999;margin-left:6px;">↻</span>' +
              '<input type="range" class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="rotation" value="' + curRotation + '" min="-180" max="180" step="1" style="width:70px;vertical-align:middle;cursor:pointer;"/>' +
              '<span class="p2m-rot-val" data-idx="' + slotIdx + '" data-key="' + field.key + '" style="font-size:10px;color:#999;min-width:24px;display:inline-block;text-align:right;">' + curRotation + '°</span>' +
              '<button class="p2m-slot-style" data-idx="' + slotIdx + '" data-key="' + field.key + '" data-prop="rotation" data-val="0" style="margin-left:4px;font-size:10px;padding:1px 5px;border:1px solid #ddd;border-radius:4px;background:#fff;cursor:pointer;" title="Reset">↺</button>' +
            '</div>';
          captionDiv.appendChild(fieldDiv);
        });
        wrap.appendChild(captionDiv);
                // Initial disable style controls αν δεν υπάρχει κείμενο
        def.textFields.forEach(function(field) {
          if (field.type === 'font-select') return;
          var hasText = !!(state.slotCaptions[slotIdx] && state.slotCaptions[slotIdx][field.key] && state.slotCaptions[slotIdx][field.key].trim().length > 0);
          captionDiv.querySelectorAll(".p2m-slot-style[data-key='" + field.key + "']").forEach(function(ctrl) {
            ctrl.disabled = !hasText;
            ctrl.style.opacity = hasText ? "1" : "0.4";
            ctrl.style.pointerEvents = hasText ? "auto" : "none";
          });
        });
      }
    }

    var _polaroidFonts = ["GFS Didot","Noto Serif","Vollkorn","Alegreya","EB Garamond","Ubuntu","Noto Sans","Source Sans 3"];
    p2mLoadPreviewFonts(_polaroidFonts).then(function() {
      var canvas = wrap.querySelector(".p2m-slot-canvas");
      if (canvas && slot && slot.previewUrl) {
        drawCanvas(canvas, slot.croppedDataUrl || slot.previewUrl, templateId, slot.orientation, state.slotCaptions[slotIdx], (state.textStyles && state.textStyles[slotIdx]) || {});
      }
    });

    return wrap;
  }

  function getSectionTemplateForSlot(slotIdx) {
    if (!state.sections) return state.templateId;
    var slot = state.slots[slotIdx];
    if (slot && slot.sectionIdx !== undefined && state.sections[slot.sectionIdx]) {
      return state.sections[slot.sectionIdx].templateId;
    }
    // fallback: count-based
    var count = 0;
    for (var i = 0; i < state.sections.length; i++) {
      count += state.sections[i].qty;
      if (slotIdx < count) return state.sections[i].templateId;
    }
    return state.templateId;
  }

  function renderDoneBtn(container) {
    var btn = container.querySelector("#p2m-done-btn");
    if (!btn) return;
    var def = TEMPLATE_SHAPES[state.templateId] || {};
        var allUploaded = state.slots.length > 0 && state.slots.every(function (s) { return s && (s.uploadedUrl || s.qty > 1); });
    var photosReady = productFlags.magnetPackMode
      ? state.slots.every(function(s) { return s && s.uploadedUrl; })
      : allUploaded;
    var textReady = true;
    if (def.hasText && def.textFields) {
      def.textFields.forEach(function (field) {
        if (!field.required) return;
        if (field.type === "font-select") {
          if (state.useCustomTitle && !(state.textValues[field.key + "_custom"] || "").trim()) textReady = false;
        } else {
          if (!(state.textValues[field.key] || "").trim()) textReady = false;
        }
      });
    }
    var ready = photosReady && textReady;
    var hasPhotos = state.slots.some(function(s) { return s && s.uploadedUrl; });

    state.isComplete = ready;
    btn.disabled      = !ready;
    btn.style.opacity = ready ? "1" : "0.5";
    btn.style.cursor  = ready ? "pointer" : "not-allowed";
    btn.style.background = ready ? "#2a7a2a" : "#888";

    // --- Reset button ---
    var resetBtn = container.querySelector("#p2m-reset-btn");
    if (!resetBtn) {
      resetBtn = document.createElement("a");
      resetBtn.id = "p2m-reset-btn";
      resetBtn.href = "javascript:void(0)";
      resetBtn.textContent = i18n.resetLink;
      resetBtn.style.cssText = [
        "display:block",
        "text-align:center",
        "margin-top:10px",
        "font-size:12px",
        "color:#999",
        "text-decoration:underline",
        "cursor:pointer"
      ].join(";");
      resetBtn.addEventListener("click", function() {
  if (!confirm(i18n.resetConfirm)) return;
  var _initSlots = state.totalSlots || state.slots.length;
  state.slots = [];
  for (var _i = 0; _i < _initSlots; _i++) { state.slots.push(null); }
  state.textValues = {};
  state.textStyles = {};
  if (def && def.hasText && def.textFields) {
    def.textFields.forEach(function(field) {
      state.textStyles[field.key] = {};
    });
  }
  state.selectedFont = null;
state.cartProps = null;
state.isComplete = false;
if (def && def.hasText && def.textFields) {
  def.textFields.forEach(function(field) {
    if (!state.textStyles[field.key]) state.textStyles[field.key] = {};
  });
}
renderSlots(container);
renderTextFields(container);
renderDoneBtn(container);
_redrawAllCanvases(container);
renderProgress(container);
});
      btn.parentNode.appendChild(resetBtn);
    }
    resetBtn.style.display = hasPhotos ? "block" : "none";
        // --- End Reset button ---

        // --- Polaroid hint ---
var hintEl = container.querySelector("#p2m-slot-hint");
if (hintEl) {
  var defHint = TEMPLATE_SHAPES[state.templateId] || {};
  if (defHint.perSlotCaption && !hasPhotos) {
    hintEl.textContent = i18n.uploadTextHint;
    hintEl.style.display = "block";
  } else {
    hintEl.style.display = "none";
  }
}
// --- End Polaroid hint ---

    // Ενημέρωσε το εξωτερικό open button
    var openBtn = document.querySelector("#p2m-widget-mount #p2m-open-btn");
    if (openBtn) {
      var isSingle = productFlags.singleSlot;
      var baseLabel = isSingle ? i18n.uploadBtnSingle : i18n.uploadBtn;
      if (ready) {
        openBtn.textContent = "✅ " + baseLabel;
        openBtn.style.borderColor = "#2a7a2a";
        openBtn.style.color = "#2a7a2a";
      } else {
        openBtn.textContent = baseLabel;
        openBtn.style.borderColor = "#222";
        openBtn.style.color = "#222";
      }
    }

    if (ready) {
  var orientations = [];
  state.slots.forEach(function (s) {
    var qty = (s && s.qty > 1) ? s.qty : 1;
    var ori = s ? (s.orientation || "portrait") : "portrait";
    for (var q = 0; q < qty; q++) orientations.push(ori);
  });
  var textProps = {};
  if (def.hasText && def.textFields) {
    def.textFields.forEach(function (field) {
      if (field.type === "font-select") {
        var titleText = state.useCustomTitle ? (state.textValues[field.key + "_custom"] || "") : field.label;
        textProps["text_title"] = titleText;
        var titleSty = Object.assign({}, (state.textStyles && state.textStyles["title"]) || {});
        titleSty.font = state.useCustomTitle ? "custom" : (state.selectedFont || "Pacifico");
        textProps["_text_title_style"] = JSON.stringify(titleSty);
      } else {
        textProps["text_" + field.key] = state.textValues[field.key] || "";
        var sty = (state.textStyles && state.textStyles[field.key]) || {};
        textProps["_text_" + field.key + "_style"] = JSON.stringify(sty);
      }
    });
  }
    var sectionsJson = state.sections ? JSON.stringify(state.sections.map(function(s){ return { templateId: s.templateId, qty: s.qty }; })) : null;
  state.cartProps = { _template_id: state.templateId, _orientations: JSON.stringify(orientations), _photo_mode: "multi-slot", "Qty ordered": String(state.orderQty) };
  if (sectionsJson && state.templateId !== 'mini_mixed_set') state.cartProps["_sections"] = sectionsJson;
  state.slots.forEach(function (s, i) {
    var qtyLabel = (s && s.qty > 1) ? " (×" + s.qty + ")" : "";
    state.cartProps["_photo_url_" + (i + 1)] = s ? s.uploadedUrl : null;
    if (state.sections && s && s.sectionIdx >= 0 && state.sections[s.sectionIdx] && state.templateId !== 'mini_mixed_set') {
      state.cartProps["_slot_template_" + (i + 1)] = state.sections[s.sectionIdx].templateId;
    }
  });
  if (def.perSlotCaption && state.slotCaptions) {
    var packedCaptions = {};
Object.keys(state.slotCaptions).forEach(function(idxStr) {
  packedCaptions[idxStr] = {};
  var slotData = state.slotCaptions[idxStr];
  Object.keys(slotData).forEach(function(lineKey) {
    if (lineKey.indexOf('_style') === -1) {
      packedCaptions[idxStr][lineKey] = slotData[lineKey] || "";
      var sty = slotData[lineKey + '_style'];
      if (sty && Object.keys(sty).length) {
        packedCaptions[idxStr][lineKey + '_style'] = sty;
      }
    }
  });
});
    state.cartProps["_slot_captions"] = JSON.stringify(packedCaptions);
  }
  Object.assign(state.cartProps, textProps);
} else {
  if (!state.slots.some(function(s) { return s && s.uploadedUrl; })) {
    state.cartProps = null;
  }
}

var triggerStatus = document.getElementById("p2m-trigger-status");
if (triggerStatus) {
  triggerStatus.textContent = ready ? i18n.addToCartHint : "";
  triggerStatus.style.color = "#2a7a2a";
}
}

  function calendarMonthsForPart(i18nMonths, part) {
  var months = i18nMonths ? i18nMonths.split(",") : ["January","February","March","April","May","June","July","August","September","October","November","December"];
  return months.slice((part - 1) * 4, part * 4);
}

function getMonthIndexForSlot(slotIdx) {
  if (!state.sections) return null;
    var isCalendar = Object.keys(TEMPLATE_SHAPES).some(function(k) {
  return k.indexOf(state.templateId) === 0 && TEMPLATE_SHAPES[k].calendar;
});
if (!isCalendar) return null;
  var offset = 0;
  for (var s = 0; s < state.sections.length; s++) {
    var sec = state.sections[s];
    var secEnd = offset + sec.qty;
    if (slotIdx >= offset && slotIdx < secEnd) {
      var secDef = TEMPLATE_SHAPES[sec.templateId];
      if (!secDef || !secDef.part) return null;
      var months = calendarMonthsForPart(state.i18nMonths, secDef.part);
      var localIdx = slotIdx - offset;
      var monthLabel = months[localIdx];
      if (!monthLabel) return null;
      var allMonths = state.i18nMonths ? state.i18nMonths.split(",") : ["January","February","March","April","May","June","July","August","September","October","November","December"];
      var mi = allMonths.indexOf(monthLabel.trim());
      return mi >= 0 ? mi + 1 : null;
    }
    offset = secEnd;
  }
  return null;
}

function renderSlots(container) {
  var el = container.querySelector("#p2m-slots");
  el.innerHTML = "";

  if (productFlags.magnetPackMode) {
    for (var i = 0; i < state.slots.length; i++) {
      var qtyLabel = state.slots[i] ? state.slots[i].qty + " pcs" : null;
      el.appendChild(buildSlotEl(container, i, state.templateId, null, qtyLabel));
    }
  } else if (state.sections) {
    state.sections.forEach(function (sec, secI) {
      var secSlots = [];
      for (var k = 0; k < state.slots.length; k++) {
        if (state.slots[k] && state.slots[k].sectionIdx === secI) secSlots.push(k);
      }
      var def = TEMPLATE_SHAPES[sec.templateId] || {};
      if (sec.label && !def.calendar) {
        var hdr = document.createElement("div");
        hdr.style.cssText = "font-weight:bold;font-size:13px;color:#555;margin:12px 0 6px;border-bottom:1px solid #eee;padding-bottom:4px;";
        hdr.textContent = sec.label;
        el.appendChild(hdr);
      }
      for (var i = 0; i < secSlots.length; i++) {
        var monthLabel = null;
        if (def.calendar) monthLabel = calendarMonthsForPart(state.i18nMonths, def.part)[i] || null;
        el.appendChild(buildSlotEl(container, secSlots[i], sec.templateId, monthLabel, sec.slotQtyLabel || null));
      }
    });
  } else {
    for (var i = 0; i < state.slots.length; i++) {
      el.appendChild(buildSlotEl(container, i, state.templateId, null, null));
    }
  }

  var addBtn = container.querySelector("#p2m-add-btn");
  if (addBtn) addBtn.style.display = "none";

  container.querySelectorAll(".p2m-slot-canvas").forEach(function (canvas) {
    var idx = parseInt(canvas.dataset.idx, 10);
    var slot = state.slots[idx];
    if (slot && slot.previewUrl) {
      drawCanvas(canvas, slot.croppedDataUrl || slot.previewUrl, getSectionTemplateForSlot(idx), slot.orientation, state.slotCaptions[idx], (state.textStyles && state.textStyles[idx]) || {}, getMonthIndexForSlot(idx));
    }
  });

  var def = TEMPLATE_SHAPES[state.templateId] || {};
if (def.hasText && def.perSlotCaption) {
  var tfEl = container.querySelector("#p2m-text-fields");
  if (tfEl) tfEl.innerHTML = "";
} else {
  renderTextFields(container, def);
}
  attachSlotEvents(container);
  renderProgress(container);
  renderDoneBtn(container);
}

  var P2M_GOOGLE_CLIENT_ID = "624891073524-eo9si1jjjs9ucr70kd2hq7uu3keh2eh0.apps.googleusercontent.com";
  var P2M_GOOGLE_API_KEY = "AIzaSyDMEz5CWCwqkPb8GuoNTPQ-49rGacitSyo";
  var P2M_GOOGLE_PROJECT_NUMBER = "624891073524";
  // Μόνο για το ξεχωριστό Google Photos test project.
// Το OAuth Client ID είναι δημόσιο αναγνωριστικό, όχι Client secret.
var P2M_PHOTOS_TEST_CLIENT_ID = "984543210461-807uqef19h5cnfad23d8mnh8081i2at7.apps.googleusercontent.com";
  var p2mDriveReady = null;

  function p2mLoadGoogleScript(src) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = function() {
        reject(new Error("Google script failed to load"));
      };
      document.head.appendChild(script);
    });
  }

  function p2mPrepareDrive() {
    if (!p2mDriveReady) {
      p2mDriveReady = Promise.all([
        p2mLoadGoogleScript("https://accounts.google.com/gsi/client"),
        p2mLoadGoogleScript("https://apis.google.com/js/api.js")
      ]).then(function() {
        return new Promise(function(resolve, reject) {
          gapi.load("picker", {
            callback: resolve,
            onerror: function() {
              reject(new Error("Google Picker failed to load"));
            },
            timeout: 15000,
            ontimeout: function() {
              reject(new Error("Google Picker timed out"));
            }
          });
        });
      }).catch(function(err) {
        p2mDriveReady = null;
        throw err;
      });
    }
    return p2mDriveReady;
  }

  function p2mDriveMessage(en, el) {
    return document.documentElement.lang.toLowerCase().indexOf("el") === 0
      ? el : en;
  }

    function p2mOpenDrivePicker(fileInput, button, multiple) {
    if (!P2M_GOOGLE_CLIENT_ID || !P2M_GOOGLE_API_KEY ||
        !P2M_GOOGLE_PROJECT_NUMBER ||
        P2M_GOOGLE_CLIENT_ID.indexOf("ΕΔΩ_") === 0 ||
        P2M_GOOGLE_API_KEY.indexOf("ΕΔΩ_") === 0 ||
        P2M_GOOGLE_PROJECT_NUMBER.indexOf("ΕΔΩ_") === 0) {
      alert(p2mDriveMessage(
        "Google Drive is not configured.",
        "Το Google Drive δεν έχει ρυθμιστεί."
      ));
      return;
    }

    button.disabled = true;

    var tokenClient = google.accounts.oauth2.initTokenClient({
      client_id: P2M_GOOGLE_CLIENT_ID,
      scope: "https://www.googleapis.com/auth/drive.file",

      callback: function(response) {
        if (!response || response.error || !response.access_token) {
          button.disabled = false;
          alert(p2mDriveMessage(
            "Could not connect to Google Drive.",
            "Δεν έγινε σύνδεση στο Google Drive."
          ));
          return;
        }

        var accessToken = response.access_token;
        var view = new google.picker.DocsView(google.picker.ViewId.DOCS);
        view.setMimeTypes("image/jpeg,image/png");

        var builder = new google.picker.PickerBuilder()
          .setAppId(P2M_GOOGLE_PROJECT_NUMBER)
          .setDeveloperKey(P2M_GOOGLE_API_KEY)
          .setOAuthToken(accessToken)
          .setOrigin(window.location.origin)
          .addView(view);

        if (multiple) {
          builder.enableFeature(google.picker.Feature.MULTISELECT_ENABLED);
        }

        var editorOverlay = fileInput;
        while (editorOverlay.parentElement &&
               editorOverlay.parentElement !== document.body) {
          editorOverlay = editorOverlay.parentElement;
        }

        var editorOverlayIsBodyChild =
          editorOverlay.parentElement === document.body;
        var previousVisibility = editorOverlay.style.visibility;

if (!document.getElementById("p2m-drive-picker-layer-style")) {
  var driveLayerStyle = document.createElement("style");
  driveLayerStyle.id = "p2m-drive-picker-layer-style";

  driveLayerStyle.textContent =
  "body.p2m-drive-picker-open #p2m-modal-overlay{" +
    "z-index:2147483644!important;" +
  "}" +
  "body.p2m-drive-picker-open #p2m-source-overlay{" +
    "z-index:2147483645!important;" +
  "}" +
  "body.p2m-drive-picker-open .picker-dialog-bg{" +
    "z-index:2147483646!important;" +
  "}" +
  "body.p2m-drive-picker-open .picker-dialog{" +
    "z-index:2147483647!important;" +
  "}" +
  "@media(max-width:767px){" +
    "body.p2m-drive-picker-open .picker-dialog{" +
      "position:fixed!important;" +
      "top:12px!important;" +
      "left:8px!important;" +
      "right:auto!important;" +
      "bottom:auto!important;" +
      "width:calc(100vw - 16px)!important;" +
      "height:calc(100vh - 24px)!important;" +
      "height:calc(100dvh - 24px)!important;" +
      "max-width:calc(100vw - 16px)!important;" +
      "max-height:calc(100dvh - 24px)!important;" +
      "margin:0!important;" +
      "transform:none!important;" +
      "box-sizing:border-box!important;" +
    "}" +
    "body.p2m-drive-picker-open .picker-dialog-content{" +
      "width:100%!important;" +
      "height:100%!important;" +
      "box-sizing:border-box!important;" +
    "}" +
    "body.p2m-drive-picker-open .picker-dialog iframe{" +
      "width:100%!important;" +
      "height:100%!important;" +
      "display:block!important;" +
    "}" +
  "}";

  document.head.appendChild(driveLayerStyle);
}

function restoreEditorOverlay() {
  document.body.classList.remove("p2m-drive-picker-open");

  if (editorOverlayIsBodyChild) {
    editorOverlay.style.visibility = previousVisibility;
  }
}
    
        function sendDriveFiles(files) {
          var transfer = new DataTransfer();
          files.forEach(function(file) {
            transfer.items.add(file);
          });
          fileInput.files = transfer.files;
          fileInput.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }

        var picker = builder.setCallback(function(data) {
                    if (data.action === google.picker.Action.CANCEL ||
              data.action === google.picker.Action.PICKED) {
            restoreEditorOverlay();
          }

          if (data.action === google.picker.Action.CANCEL) {
                        button.disabled = false;
            return;
          }

          if (data.action !== google.picker.Action.PICKED ||
              !data.docs || !data.docs.length) return;

          Promise.all(data.docs.map(function(doc) {
            return fetch(
              "https://www.googleapis.com/drive/v3/files/" +
              encodeURIComponent(doc.id) + "?alt=media",
              { headers: { Authorization: "Bearer " + accessToken } }
            ).then(function(download) {
              if (!download.ok) {
                throw new Error("Drive download HTTP " + download.status);
              }
              return download.blob();
            }).then(function(blob) {
              var mime = doc.mimeType || blob.type;
              if (mime !== "image/jpeg" && mime !== "image/png") {
                throw new Error("Unsupported image type");
              }
              return new File(
                [blob],
                doc.name || "drive-photo",
                { type: mime }
              );
                        });
          })).then(function(files) {
            sendDriveFiles(files);
          }).catch(function(err) {
            console.warn("[p2m] Drive image import failed", err);
            alert(p2mDriveMessage(
              "Could not import these photos. Download them to your device and use Upload.",
              "Δεν έγινε εισαγωγή των φωτογραφιών. Κατέβασέ τες στη συσκευή και χρησιμοποίησε τη Μεταφόρτωση."
            ));
          }).finally(function() {
            button.disabled = false;
          });
        }).build();

        var isSmallScreen = window.matchMedia("(max-width: 767px)").matches;

        if (editorOverlayIsBodyChild && !isSmallScreen) {
          editorOverlay.style.visibility = "hidden";
        }

        document.body.classList.add("p2m-drive-picker-open");

        try {
          picker.setVisible(true);
        } catch (err) {
  restoreEditorOverlay();
  button.disabled = false;

  console.warn("[p2m] Google Picker could not open", err);
  alert(p2mDriveMessage(
    "Could not open Google Drive.",
    "Δεν άνοιξε το Google Drive."
  ));
}
},

      error_callback: function() {
        button.disabled = false;
      }
    });

    tokenClient.requestAccessToken({ prompt: "" });
  }

function p2mOpenPhotosPicker(fileInput, button, dismiss) {
  var scope = "https://www.googleapis.com/auth/photospicker.mediaitems.readonly";
  var api = "https://photospicker.googleapis.com/v1/";

  function message(en, el) {
    return p2mDriveMessage(en, el);
  }

  function fail(error) {
    console.warn("[p2m] Photos import failed", error);
    button.disabled = false;
    button.textContent = message(
      "🌈 Google Photos · Try again",
      "🌈 Google Photos · Ξανά"
    );
    alert(message(
      "Could not import from Google Photos. Your existing photos were not changed.",
      "Δεν έγινε εισαγωγή από το Google Photos. Οι υπάρχουσες φωτογραφίες δεν άλλαξαν."
    ));
  }

  function googleFetch(url, token, options) {
    options = options || {};
    options.headers = Object.assign({}, options.headers || {}, {
      Authorization: "Bearer " + token
    });
    return fetch(url, options).then(function(response) {
      if (!response.ok) {
        throw new Error("Photos HTTP " + response.status + " at " + url.split("?")[0]);
      }
      return response;
    });
  }

  function getSelectedItems(sessionId, token) {
    var items = [];

    function next(pageToken) {
      var url = api + "mediaItems?sessionId=" +
        encodeURIComponent(sessionId) + "&pageSize=100";
      if (pageToken) url += "&pageToken=" + encodeURIComponent(pageToken);

      return googleFetch(url, token)
        .then(function(response) { return response.json(); })
        .then(function(result) {
          items = items.concat(result.mediaItems || []);
          if (result.nextPageToken) return next(result.nextPageToken);
          return items;
        });
    }

    return next("");
  }

  function importItems(items, token) {
    if (!items.length) throw new Error("No Photos items returned");

    return Promise.all(items.map(function(item, index) {
      var media = item.mediaFile || {};
      if (!media.baseUrl) {
        throw new Error("Photos item has no download URL");
      }

      return googleFetch(media.baseUrl + "=d", token)
        .then(function(response) { return response.blob(); })
        .then(function(blob) {
          var type = media.mimeType || blob.type;
          if (!type || type.indexOf("image/") !== 0) {
            throw new Error("Selected Photos item is not an image");
          }
          return new File(
            [blob],
            media.filename || ("google-photo-" + (index + 1)),
            { type: type }
          );
        });
    })).then(function(files) {
      var transfer = new DataTransfer();
      files.forEach(function(file) { transfer.items.add(file); });
      fileInput.files = transfer.files;
      fileInput.dispatchEvent(new Event("change", { bubbles: true }));
      dismiss();
    });
  }

  function waitForSelection(sessionId, token, pickerWindow) {
  var closedChecks = 0;

  function check() {
    return googleFetch(
      api + "sessions/" + encodeURIComponent(sessionId),
      token
    ).then(function(response) {
      return response.json();
    }).then(function(session) {
      // Η επιλογή έχει προτεραιότητα, ακόμη κι αν το
      // παράθυρο έκλεισε αμέσως μετά το «Τέλος».
      if (session.mediaItemsSet) {
        return getSelectedItems(sessionId, token)
          .then(function(items) {
            return importItems(items, token);
          });
      }

      // Δίνουμε λίγα δευτερόλεπτα στη Google να ενημερώσει
      // τη συνεδρία πριν θεωρήσουμε το κλείσιμο ακύρωση.
      if (pickerWindow && pickerWindow.closed) {
        closedChecks += 1;

        if (closedChecks >= 5) {
          button.p2mPhotosSession = null;
          button.textContent = message(
            "🌈 Google Photos",
            "🌈 Google Photos"
          );
          return;
        }
      } else {
        closedChecks = 0;
      }

      return new Promise(function(resolve) {
        setTimeout(resolve, 2000);
      }).then(check);
    });
  }

  return check();
}

  if (button.p2mPhotosSession) {
    var ready = button.p2mPhotosSession;
    var pickerWindow = window.open(ready.pickerUri, "_blank");
if (pickerWindow) pickerWindow.opener = null;

    if (!pickerWindow) {
      alert(message(
        "Allow pop-ups to open Google Photos.",
        "Επίτρεψε τα αναδυόμενα παράθυρα για να ανοίξει το Google Photos."
      ));
      return;
    }

    button.disabled = true;
    button.textContent = message(
      "Waiting for selected photos…",
      "Αναμονή επιλεγμένων φωτογραφιών…"
    );
    waitForSelection(ready.id, ready.token, pickerWindow)
      .catch(fail)
      .finally(function() {
        button.disabled = false;
        button.p2mPhotosSession = null;
      });
    return;
  }

  if (!P2M_PHOTOS_TEST_CLIENT_ID ||
      P2M_PHOTOS_TEST_CLIENT_ID.indexOf("ΕΔΩ_") === 0) {
    alert(message(
      "Photos test Client ID is missing.",
      "Λείπει το Client ID της δοκιμής Photos."
    ));
    return;
  }

  button.disabled = true;
  p2mLoadGoogleScript("https://accounts.google.com/gsi/client")
    .then(function() {
      var client = google.accounts.oauth2.initTokenClient({
        client_id: P2M_PHOTOS_TEST_CLIENT_ID,
        scope: scope,
        callback: function(response) {
          if (!response || response.error || !response.access_token) {
            fail(new Error("Photos authorization failed"));
            return;
          }

          var token = response.access_token;
          googleFetch(api + "sessions", token, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: "{}"
          }).then(function(result) {
            return result.json();
          }).then(function(session) {
            if (!session.id || !session.pickerUri) {
              throw new Error("Incomplete Photos session");
            }

            button.p2mPhotosSession = {
              id: session.id,
              pickerUri: session.pickerUri,
              token: token
            };
            button.textContent = message(
              "🌈 Open Google Photos",
              "🌈 Άνοιγμα Google Photos"
            );
            button.disabled = false;
            button.focus();
          }).catch(fail);
        },
        error_callback: fail
      });

      client.requestAccessToken({ prompt: "consent" });
    })
    .catch(fail);
}

  // Dropbox Chooser uses the public app key. No Dropbox secret or access token belongs in the theme.
  var P2M_DROPBOX_APP_KEY = "g892uon2421vhyq";
  var p2mDropboxReady = null;
  function p2mPrepareDropbox() {
    if (window.Dropbox && typeof window.Dropbox.choose === "function") return Promise.resolve();
    if (p2mDropboxReady) return p2mDropboxReady;
    p2mDropboxReady = new Promise(function(resolve, reject) {
      var script = document.createElement("script");
      script.id = "dropboxjs";
      script.setAttribute("data-app-key", P2M_DROPBOX_APP_KEY);
      script.src = "https://www.dropbox.com/static/api/2/dropins.js";
      script.async = true;
      script.onload = function() {
        if (window.Dropbox && typeof window.Dropbox.choose === "function") resolve();
        else reject(new Error("Dropbox Chooser unavailable"));
      };
      script.onerror = function() { reject(new Error("Dropbox Chooser could not load")); };
      document.head.appendChild(script);
    }).catch(function(error) {
      p2mDropboxReady = null;
      var script = document.getElementById("dropboxjs");
      if (script) script.remove();
      throw error;
    });
    return p2mDropboxReady;
  }

  var p2mSourceBypass = false;

  function p2mAttachDriveButtons(container) {
    var bulk = container.querySelector("#p2m-bulk-btn");

    if (bulk && !bulk.dataset.p2mSourceBound) {
      bulk.dataset.p2mSourceBound = "1";

      bulk.addEventListener("click", function(event) {
        if (p2mSourceBypass) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        p2mShowSources(bulk, true);
      }, true);
    }

        container.querySelectorAll(".p2m-slot-dropzone").forEach(function(zone) {
      if (zone.dataset.p2mSourceBound) return;
      zone.dataset.p2mSourceBound = "1";

            var other = document.createElement("button");
      other.type = "button";
      other.className = "p2m-other-sources";
      other.textContent = "⋯";
            other.setAttribute(
        "aria-label",
        p2mDriveMessage(
          "Other photo sources",
          "Άλλες πηγές φωτογραφίας"
        )
      );

      other.setAttribute(
        "aria-label",
        p2mDriveMessage(
          "Other photo sources",
          "Άλλες πηγές φωτογραφίας"
        )
      );
      other.title = p2mDriveMessage(
        "Other photo sources",
        "Άλλες πηγές φωτογραφίας"
      );
      other.style.cssText =
        "position:absolute;right:0;bottom:0;z-index:1;" +
        "display:flex;align-items:center;justify-content:center;" +
        "box-sizing:border-box;width:44px;height:44px;" +
        "min-width:0;min-height:0;padding:0;" +
        "border:0;border-radius:50%;" +
        "background:radial-gradient(circle,#315b66 0 16px,transparent 17px);" +
        "color:#fff;font-size:20px;line-height:1;cursor:pointer;";

      other.addEventListener("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        p2mShowSources(other, false);
      });

      other.p2mSourceZone = zone;
            var sourceRow = document.createElement("div");
            sourceRow.style.cssText =
        "position:relative;width:94px;height:94px;flex-shrink:0;";

      zone.parentNode.insertBefore(sourceRow, zone);
      sourceRow.appendChild(zone);
      sourceRow.appendChild(other);
    });

    p2mPrepareDrive().catch(function(err) {
      console.warn("[p2m] Google Picker unavailable", err);
    });
  }

  function p2mFacebookAuthorize() {
  function diagnosticError(code) {
    var error = new Error("Facebook authorization was not completed");
    error.p2mFacebookDiagnostic = code;
    return error;
  }

  if (
    !p2mAddFacebookSdkTest.sdkReady ||
    !window.FB ||
    typeof window.FB.login !== "function"
  ) {
    return Promise.reject(diagnosticError("SDK_NOT_READY"));
  }

  var backendOrigin;
  var browserSecret;

  try {
    backendOrigin = new URL(BACKEND_URL).origin;

    var bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);

    var binary = "";
    bytes.forEach(function(value) {
      binary += String.fromCharCode(value);
    });

    browserSecret = btoa(binary)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  } catch (_) {
    return Promise.reject(diagnosticError("LOCAL_SETUP_FAILED"));
  }

  return new Promise(function(resolve, reject) {
    var finished = false;
    var callbackHandled = false;
    var controllers = new Set();
    var resolveAttempt;

    var startPromise = new Promise(function(resolveStart) {
      resolveAttempt = resolveStart;
    });

    var overallTimer = setTimeout(function() {
      fail("LOGIN_TIMEOUT");
    }, 5 * 60 * 1000);

    function cleanup() {
      clearTimeout(overallTimer);

      controllers.forEach(function(controller) {
        controller.abort();
      });
      controllers.clear();

      browserSecret = null;
    }

    function fail(code) {
      if (finished) return;

      finished = true;
      resolveAttempt(null);
      cleanup();
      reject(diagnosticError(code));
    }

    function succeed(ticket) {
      if (finished) {
        p2mFacebookRevoke(ticket).catch(function() {});
        return;
      }

      finished = true;
      cleanup();
      resolve(ticket);
    }

    async function sdkRequest(path, body, stage) {
      if (finished || !browserSecret) {
        throw diagnosticError(stage + "_ENDED");
      }

      var controller = new AbortController();
      var timedOut = false;
      controllers.add(controller);

      var requestTimer = setTimeout(function() {
        timedOut = true;
        controller.abort();
      }, 15000);

      try {
        var response = await fetch(backendOrigin + path, {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + browserSecret
          },
          body: JSON.stringify(body),
          signal: controller.signal
        });

        if (!response.ok) {
          throw diagnosticError(
            stage + "_HTTP_" + response.status
          );
        }

        try {
          return await response.json();
        } catch (_) {
          throw diagnosticError(
            timedOut
              ? stage + "_TIMEOUT"
              : stage + "_INVALID_JSON"
          );
        }
      } catch (error) {
        if (error && error.p2mFacebookDiagnostic) {
          throw error;
        }

        throw diagnosticError(
          timedOut
            ? stage + "_TIMEOUT"
            : controller.signal.aborted
              ? stage + "_ABORTED"
              : stage + "_NETWORK"
        );
      } finally {
        clearTimeout(requestTimer);
        controllers.delete(controller);
      }
    }

    try {
      // Keep FB.login directly in the original click stack.
      // No network request or await precedes this call.
           window.FB.login(function(response) {
        if (callbackHandled || finished) return;
        callbackHandled = true;

        if (!response || response.status !== "connected") {
          var callbackCode = "SDK_NOT_CONNECTED";

          if (response && response.status === "unknown") {
            callbackCode = "SDK_UNKNOWN";
          } else if (
            response &&
            response.status === "not_authorized"
          ) {
            callbackCode = "SDK_NOT_AUTHORIZED";
          }

          fail(callbackCode);
          return;
        }

        if (
          !response.authResponse ||
          typeof response.authResponse.accessToken !== "string" ||
          !response.authResponse.accessToken.length ||
          response.authResponse.accessToken.length > 8192 ||
          /\s/.test(response.authResponse.accessToken) ||
          typeof response.authResponse.userID !== "string" ||
          !/^\d{1,64}$/.test(response.authResponse.userID)
        ) {
          fail("SDK_INVALID_AUTH_RESPONSE");
          return;
        }

        var accessToken = response.authResponse.accessToken;
        var userId = response.authResponse.userID;

        async function complete() {
          try {
            var attempt = await startPromise;

            if (!attempt || finished) return;

            var result = await sdkRequest(
              "/facebook-picker/sdk/complete",
              {
                attempt: attempt,
                accessToken: accessToken,
                userId: userId
              },
              "COMPLETE"
            );

            if (
              !result ||
              typeof result.ticket !== "string" ||
              !/^[A-Za-z0-9_-]{43}$/.test(result.ticket) ||
              !Number.isInteger(result.expiresIn) ||
              result.expiresIn < 1 ||
              result.expiresIn > 600
            ) {
              throw diagnosticError("COMPLETE_INVALID_TICKET");
            }

            succeed(result.ticket);
          } catch (error) {
            fail(
              error && error.p2mFacebookDiagnostic
                ? error.p2mFacebookDiagnostic
                : "COMPLETE_FAILED"
            );
          } finally {
            accessToken = null;
            userId = null;
          }
        }

        complete();
      }, {
        scope: "user_photos"
      });

      if (finished) {
        resolveAttempt(null);
        return;
      }

      sdkRequest(
        "/facebook-picker/sdk/start",
        {},
        "START"
      ).then(function(result) {
        if (finished) {
          resolveAttempt(null);
          return;
        }

        if (
          !result ||
          typeof result.attempt !== "string" ||
          !/^[A-Za-z0-9_-]{43}$/.test(result.attempt) ||
          result.expiresIn !== 300
        ) {
          fail("START_INVALID_ATTEMPT");
          return;
        }

        resolveAttempt(result.attempt);
      }).catch(function(error) {
        fail(
          error && error.p2mFacebookDiagnostic
            ? error.p2mFacebookDiagnostic
            : "START_FAILED"
        );
      });
    } catch (_) {
      fail("SDK_LOGIN_THROW");
    }
  });
}

function p2mFacebookRevoke(ticket) {
  if (
    typeof ticket !== "string" ||
    !/^[A-Za-z0-9_-]{43}$/.test(ticket)
  ) {
    return Promise.resolve();
  }

  return fetch(BACKEND_URL + "/facebook-picker/revoke", {
    method: "POST",
    mode: "cors",
    credentials: "omit",
    headers: {
      Authorization: "Bearer " + ticket
    },
    keepalive: true
  }).then(function(response) {
    if (!response.ok) {
      throw new Error("Facebook picker cleanup failed");
    }
  });
}

var p2mFacebookSession = {
  ticket: null,
  expiresAt: 0,
  timer: null
};

function p2mClearFacebookSession(expectedTicket) {
  if (
    expectedTicket &&
    p2mFacebookSession.ticket !== expectedTicket
  ) {
    return;
  }

  var previousTicket = p2mFacebookSession.ticket;

  clearTimeout(p2mFacebookSession.timer);

  p2mFacebookSession.ticket = null;
  p2mFacebookSession.expiresAt = 0;
  p2mFacebookSession.timer = null;

  if (previousTicket) {
    p2mFacebookRevoke(previousTicket).catch(function() {});
  }
}

function p2mRememberFacebookSession(ticket, expiresAt) {
  if (
    typeof ticket !== "string" ||
    !/^[A-Za-z0-9_-]{43}$/.test(ticket)
  ) {
    throw new Error("Invalid Facebook session");
  }

  if (Date.now() >= expiresAt) {
    p2mFacebookRevoke(ticket).catch(function() {});
    throw new Error("Facebook session expired");
  }

  p2mClearFacebookSession();

  p2mFacebookSession.ticket = ticket;
  p2mFacebookSession.expiresAt = expiresAt;

  p2mFacebookSession.timer = setTimeout(function() {
    p2mClearFacebookSession(ticket);
  }, expiresAt - Date.now());
}

function p2mOpenFacebookPicker(fileInput, sourceButton, multiple, dismissSources) {
    if (
    p2mFacebookSession.ticket &&
    Date.now() >= p2mFacebookSession.expiresAt
  ) {
    p2mClearFacebookSession();
  }

  var reusedSession = !!p2mFacebookSession.ticket;
  var sessionDeadline = reusedSession
    ? p2mFacebookSession.expiresAt
    : Date.now() + 9 * 60 * 1000;

    // New authorization starts only from the Connect button.
  var connecting = false;

  var ticket = null;
  var closed = false;
  var busy = false;
  var loading = false;
  var cursor = null;
  var selected = new Set();
  var seen = new Set();
  var seenCursors = new Set();
  var objectUrls = [];
  var controllers = new Set();
  var maxSelection = multiple ? 10 : 1;

  var overlay = document.createElement("div");
  overlay.id = "p2m-facebook-overlay";
  overlay.style.cssText =
    "position:fixed;inset:0;z-index:2147483647;" +
    "background:rgba(0,0,0,.65);display:flex;" +
    "align-items:center;justify-content:center;padding:12px;" +
    "box-sizing:border-box;";

  var panel = document.createElement("div");
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-modal", "true");
  panel.setAttribute("aria-label", "Facebook");
  panel.style.cssText =
    "background:#fff;color:#222;width:600px;max-width:100%;" +
    "max-height:90dvh;overflow:auto;padding:18px;" +
    "border-radius:14px;box-sizing:border-box;";

  var title = document.createElement("h3");
  title.textContent = p2mDriveMessage(
    "Choose Facebook photos",
    "Επίλεξε φωτογραφίες Facebook"
  );

  var status = document.createElement("p");
  status.setAttribute("role", "status");
  status.style.cssText = "font-size:14px;line-height:1.4;";
    status.textContent = reusedSession
    ? p2mDriveMessage(
        "Loading photos…",
        "Φόρτωση φωτογραφιών…"
      )
    : p2mDriveMessage(
        "Press Connect to Facebook to load your photos.",
        "Πάτησε Σύνδεση με Facebook για να φορτώσεις τις φωτογραφίες σου."
      );

  var grid = document.createElement("div");
  grid.style.cssText =
    "display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;";

  var actions = document.createElement("div");
  actions.style.cssText =
    "display:flex;flex-wrap:wrap;gap:8px;margin-top:16px;";

  function button(label) {
    var element = document.createElement("button");
    element.type = "button";
    element.textContent = label;
    element.style.cssText =
      "font:inherit;padding:10px 14px;border:1px solid #999;" +
      "border-radius:8px;background:#fff;color:#222;cursor:pointer;";
    actions.appendChild(element);
    return element;
  }

  var connectButton = button(p2mDriveMessage(
    "Connect to Facebook",
    "Σύνδεση με Facebook"
  ));

  connectButton.hidden = reusedSession;

  var more = button(p2mDriveMessage("More photos", "Περισσότερες"));
  var importButton = button(p2mDriveMessage("Import", "Εισαγωγή"));
  var cancel = button(p2mDriveMessage("Close", "Κλείσιμο"));
  more.disabled = true;
  importButton.disabled = true;

  panel.appendChild(title);
  panel.appendChild(status);
  panel.appendChild(grid);
  panel.appendChild(actions);
  overlay.appendChild(panel);

  var unlock = null;
  var previousFocus = document.activeElement;

  function closePicker() {
    if (closed) return;
    closed = true;

    controllers.forEach(function(controller) {
      controller.abort();
    });
    controllers.clear();

    objectUrls.forEach(function(url) {
      URL.revokeObjectURL(url);
    });
    objectUrls = [];

    document.removeEventListener("keydown", onKey);
    overlay.remove();
    if (unlock) unlock();

        // Closing or importing does not end the temporary session.
    ticket = null;

    if (previousFocus && previousFocus.isConnected) {
      previousFocus.focus();
    }
  }

  function onKey(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      closePicker();
    }

    if (event.key === "Tab") {
      var focusable = Array.from(
        panel.querySelectorAll("button:not(:disabled)")
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  cancel.addEventListener("click", closePicker);
  overlay.addEventListener("click", function(event) {
    if (event.target === overlay) closePicker();
  });

  function updateSelection() {
    importButton.disabled = busy || loading || !selected.size;
    more.disabled = busy || loading || !cursor;

    status.textContent = p2mDriveMessage(
      selected.size + " selected. Maximum " + maxSelection + ".",
      selected.size + " επιλεγμένες. Μέγιστο " + maxSelection + "."
    );
  }

  async function request(path, body, imageResponse) {
    if (closed || !ticket) throw new Error("Picker closed");

    var controller = new AbortController();
    controllers.add(controller);
    var timer = setTimeout(function() {
      controller.abort();
    }, 30000);

    try {
      var response = await fetch(BACKEND_URL + path, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + ticket
        },
        body: JSON.stringify(body),
        signal: controller.signal
      });

            if (!response.ok) {
        if (response.status === 401) {
          p2mClearFacebookSession(ticket);
          ticket = null;
        }

        throw new Error("Facebook request failed");
      }

      if (!imageResponse) return await response.json();

      if (!/^image\/jpeg\b/i.test(
        response.headers.get("Content-Type") || ""
      )) {
        throw new Error("Invalid image response");
      }

      var blob = await response.blob();
      if (!blob.size || blob.size > 8 * 1024 * 1024) {
        throw new Error("Invalid image size");
      }

      return blob;
    } finally {
      clearTimeout(timer);
      controllers.delete(controller);
    }
  }

  async function loadPage() {
    if (closed || busy || loading) return;
    loading = true;
    updateSelection();
    status.textContent = p2mDriveMessage(
      "Loading photos…",
      "Φόρτωση φωτογραφιών…"
    );

    try {
      var result = await request(
        "/facebook-picker/photos",
        { after: cursor },
        false
      );

      if (closed) return;

      if (
        !result ||
        !Array.isArray(result.photos) ||
        result.photos.length > 24 ||
        (
          result.nextCursor !== null &&
          (
            typeof result.nextCursor !== "string" ||
            !/^[A-Za-z0-9_=-]{1,2048}$/.test(result.nextCursor) ||
            seenCursors.has(result.nextCursor)
          )
        ) ||
        result.photos.some(function(photo) {
          return !photo ||
            typeof photo.id !== "string" ||
            !/^\d{1,64}$/.test(photo.id);
        })
      ) {
        throw new Error("Invalid photo list");
      }

      cursor = result.nextCursor;
      if (cursor) seenCursors.add(cursor);

      for (var photo of result.photos) {
        if (closed) return;
        if (seen.has(photo.id)) continue;
        seen.add(photo.id);

        var blob;
        try {
          blob = await request(
            "/facebook-picker/image",
            { photoId: photo.id, thumbnail: true },
            true
          );
        } catch (_) {
          if (closed) return;
          // Skip a failed thumbnail without exposing internal errors.
          continue;
        }

        if (closed) return;

        (function(photoId, thumbnailBlob) {
          var tile = document.createElement("button");
          tile.type = "button";
          tile.setAttribute("aria-pressed", "false");
          tile.setAttribute("aria-label", p2mDriveMessage(
            "Select photo",
            "Επιλογή φωτογραφίας"
          ));
          tile.style.cssText =
            "padding:0;border:3px solid transparent;border-radius:8px;" +
            "overflow:hidden;background:#eee;cursor:pointer;";

          var image = document.createElement("img");
          var objectUrl = URL.createObjectURL(thumbnailBlob);
          objectUrls.push(objectUrl);
          image.src = objectUrl;
          image.alt = "";
          image.style.cssText =
            "width:100%;height:120px;object-fit:cover;display:block;";
          tile.appendChild(image);

          tile.addEventListener("click", function() {
            if (busy || loading || closed) return;

            if (selected.has(photoId)) {
              selected.delete(photoId);
            } else {
              if (selected.size >= maxSelection) {
                status.textContent = p2mDriveMessage(
                  "Selection limit reached. Deselect a photo first.",
                  "Έφτασες το όριο επιλογής. Αφαίρεσε πρώτα μια φωτογραφία."
                );
                return;
              }
              selected.add(photoId);
            }

            var active = selected.has(photoId);
            tile.setAttribute("aria-pressed", String(active));
            tile.style.borderColor = active ? "#315b66" : "transparent";
            updateSelection();
          });

          grid.appendChild(tile);
        })(photo.id, blob);
      }

      loading = false;
      updateSelection();

      if (!grid.children.length) {
        status.textContent = p2mDriveMessage(
          "No photos could be displayed. Try More photos if available.",
          "Δεν εμφανίστηκαν φωτογραφίες. Δοκίμασε Περισσότερες, αν είναι διαθέσιμο."
        );
      }
    } catch (_) {
      if (!closed) {
        loading = false;
        updateSelection();
        status.textContent = p2mDriveMessage(
          "Could not load photos. Close and try again.",
          "Δεν φορτώθηκαν οι φωτογραφίες. Κλείσε και δοκίμασε ξανά."
        );
      }
    }
  }

  more.addEventListener("click", loadPage);

  importButton.addEventListener("click", async function() {
    if (closed || busy || loading || !selected.size) return;
    busy = true;
    updateSelection();
    status.textContent = p2mDriveMessage(
      "Importing photos…",
      "Εισαγωγή φωτογραφιών…"
    );

    try {
      var transfer = new DataTransfer();
      var ids = Array.from(selected);

      for (var i = 0; i < ids.length; i++) {
        var blob = await request(
          "/facebook-picker/image",
          { photoId: ids[i], thumbnail: false },
          true
        );

        if (closed) return;

        transfer.items.add(new File(
          [blob],
          "facebook-photo-" + (i + 1) + ".jpg",
          { type: "image/jpeg" }
        ));
      }

      if (
        closed ||
        !fileInput.isConnected ||
        !overlay.isConnected ||
        !document.getElementById("p2m-modal-overlay") ||
        document.getElementById("p2m-modal-overlay").style.display === "none"
      ) {
        throw new Error("Editor no longer available");
      }

      if (fileInput.p2mCameraCleanup) {
        fileInput.p2mCameraCleanup();
      }

      fileInput.files = transfer.files;
      closePicker();
      fileInput.dispatchEvent(new Event("change", { bubbles: true }));
    } catch (_) {
      if (!closed) {
        busy = false;
        updateSelection();
        status.textContent = p2mDriveMessage(
          "Import failed. Existing photos were not changed. Try again or use Device.",
          "Η εισαγωγή απέτυχε. Οι υπάρχουσες φωτογραφίες δεν άλλαξαν. Δοκίμασε ξανά ή επίλεξε Συσκευή."
        );
      }
    }
  });

  dismissSources();
  document.body.appendChild(overlay);

  var editor = document.getElementById("p2m-modal-overlay");
  unlock = editor && editor.style.display !== "none" && editor.p2mUnlockScroll
    ? null
    : p2mLockEditorPage();

  document.addEventListener("keydown", onKey);
  cancel.focus();

      function acceptAuthorization(value, borrowedSession, deadline) {
    if (closed) {
      if (!borrowedSession) {
        p2mFacebookRevoke(value).catch(function() {});
      }
      return;
    }

    if (borrowedSession) {
      if (
        p2mFacebookSession.ticket !== value ||
        Date.now() >= p2mFacebookSession.expiresAt
      ) {
        p2mClearFacebookSession(value);
        throw new Error("Facebook session expired");
      }
    } else {
      p2mRememberFacebookSession(value, deadline);
    }

    ticket = value;
    connectButton.hidden = true;
    loadPage();
  }

  function showAuthorizationFailure(error) {
    if (closed) return;

    connecting = false;
    connectButton.hidden = false;
    connectButton.disabled = false;

    var code = error && error.p2mFacebookDiagnostic;

    if (
      typeof code !== "string" ||
      !/^(?:SDK_NOT_READY|LOCAL_SETUP_FAILED|LOGIN_TIMEOUT|SDK_NOT_CONNECTED|SDK_UNKNOWN|SDK_NOT_AUTHORIZED|SDK_INVALID_AUTH_RESPONSE|SDK_LOGIN_THROW|START_INVALID_ATTEMPT|COMPLETE_INVALID_TICKET|START_FAILED|COMPLETE_FAILED|(?:START|COMPLETE)_(?:HTTP_[1-5][0-9]{2}|ENDED|TIMEOUT|INVALID_JSON|ABORTED|NETWORK))$/.test(code)
    ) {
      code = "SESSION_OR_PICKER_FAILED";
    }

    status.textContent = p2mDriveMessage(
      "Facebook connection was not completed. Diagnostic: " + code +
      ". You can try Connect to Facebook again.",
      "Η σύνδεση Facebook δεν ολοκληρώθηκε. Διάγνωση: " + code +
      ". Μπορείς να δοκιμάσεις ξανά Σύνδεση με Facebook."
    );
  }

  connectButton.addEventListener("click", function() {
    if (closed || connecting || ticket) return;

    connecting = true;
    connectButton.disabled = true;

    status.textContent = p2mDriveMessage(
      "Complete Facebook Login in the window that opens.",
      "Ολοκλήρωσε τη σύνδεση Facebook στο παράθυρο που ανοίγει."
    );

    var deadline = Date.now() + 9 * 60 * 1000;
    var authorization;

    try {
      // Direct synchronous call from this specific button click.
      authorization = p2mFacebookAuthorize();
    } catch (error) {
      showAuthorizationFailure(error);
      return;
    }

    authorization.then(function(value) {
      connecting = false;
      acceptAuthorization(value, false, deadline);
    }).catch(showAuthorizationFailure);
  });

  if (reusedSession) {
    Promise.resolve(p2mFacebookSession.ticket)
      .then(function(value) {
        acceptAuthorization(value, true, sessionDeadline);
      })
      .catch(showAuthorizationFailure);
  }
}

function p2mAddFacebookSdkTest(container) {
  // Keep SDK loading restricted to the two authorized test drafts.
  if (
    !window.Shopify ||
    !Shopify.theme ||
    !["183025860931", "183054631235"].includes(String(Shopify.theme.id))
  ) {
    return;
  }

  if (!p2mAddFacebookSdkTest.readyPromise) {
    p2mAddFacebookSdkTest.sdkReady = false;

    p2mAddFacebookSdkTest.readyPromise = new Promise(
      function(resolve, reject) {
        var settled = false;

        var timer = setTimeout(function() {
          if (settled) return;

          settled = true;
          reject(new Error("Facebook SDK load timeout"));
        }, 15000);

        function initialize() {
          if (settled) return;

          try {
            if (!window.FB || typeof FB.init !== "function") {
              throw new Error("Facebook SDK unavailable");
            }

            FB.init({
              appId: "1461100509216052",
              version: "v26.0",
              fedCM: String(Shopify.theme.id) === "183054631235" ? false : undefined,
              cookie: false,
              status: false,
              xfbml: false
            });

            p2mAddFacebookSdkTest.sdkReady = true;

            settled = true;
            clearTimeout(timer);
            resolve();
          } catch (_) {
            p2mAddFacebookSdkTest.sdkReady = false;

            settled = true;
            clearTimeout(timer);
            reject(new Error("Facebook SDK initialization failed"));
          }
        }

        if (window.FB && typeof FB.init === "function") {
          initialize();
          return;
        }

        var script = document.createElement("script");
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        script.crossOrigin = "anonymous";
        script.onload = initialize;

        script.onerror = function() {
          if (settled) return;

          p2mAddFacebookSdkTest.sdkReady = false;

          settled = true;
          clearTimeout(timer);
          reject(new Error("Facebook SDK could not load"));
        };

        document.head.appendChild(script);
      }
    );

    // Handle loading failures without logging SDK data.
    p2mAddFacebookSdkTest.readyPromise.catch(function() {
      p2mAddFacebookSdkTest.sdkReady = false;
    });
  }
}

  // OneDrive personal picker. Draft-only; no secrets or backend changes.
  var p2mOneDriveDraft = "183054631235";
  var p2mOneDriveApp = null;
  // Access tokens stay in page memory only and are keyed by account + resource.
  var p2mOneDriveTokenCache = new Map();
  function p2mRememberOneDriveToken(result, graph) {
    if (!result || !result.account || !result.accessToken || !result.expiresOn) return;
    var expires = new Date(result.expiresOn).getTime() - 60000;
    if (!Number.isFinite(expires) || expires <= Date.now()) return;
    var key = result.account.homeAccountId + (graph ? ":graph" : ":onedrive");
    p2mOneDriveTokenCache.set(key, { token: result.accessToken, expires: expires });
  }
  var p2mOneDriveReady = null;
  function p2mOneDriveEnabled() {
    return window.Shopify && Shopify.theme && String(Shopify.theme.id) === p2mOneDriveDraft;
  }
  function p2mPrepareOneDrive() {
    if (p2mOneDriveReady) return p2mOneDriveReady;
    p2mOneDriveReady = new Promise(function(resolve, reject) {
      var source = window.p2mOneDriveMsalAssetUrl;
      if (!source) { reject(new Error("asset_source_missing")); return; }
      var script = document.createElement("script");
      var settled = false;
      var timeout = setTimeout(function() { finish(new Error("sdk_timeout")); }, 15000);
      function finish(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        if (error) { script.remove(); reject(error); return; }
        try {
          if (!window.msal || !msal.PublicClientApplication) throw new Error("sdk_missing");
          p2mOneDriveApp = new msal.PublicClientApplication({
            auth: {
              clientId: "34d2e919-0661-476a-b35d-48f47d1ecf3f",
              authority: "https://login.microsoftonline.com/consumers",
              redirectUri: "https://picture2magnet.com/"
            },
            cache: { cacheLocation: "sessionStorage", storeAuthStateInCookie: false }
          });
          resolve(p2mOneDriveApp);
        } catch (_) { reject(new Error("sdk_initialization_failed")); }
      }
      script.src = source;
      script.async = true;
      script.onload = function() { finish(); };
      script.onerror = function() { finish(new Error("sdk_load_failed")); };
      document.head.appendChild(script);
    }).catch(function(error) { p2mOneDriveReady = null; throw error; });
    return p2mOneDriveReady;
  }
  function p2mOneDriveIcon() {
    var id = "p2m-od-" + crypto.randomUUID();
    var box = document.createElement("span");
    box.innerHTML = '<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><mask id="MASK" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="6" width="32" height="20"><path d="M7.82979 26C3.50549 26 0 22.5675 0 18.3333C0 14.1921 3.35322 10.8179 7.54613 10.6716C9.27535 7.87166 12.4144 6 16 6C20.6308 6 24.5169 9.12183 25.5829 13.3335C29.1316 13.3603 32 16.1855 32 19.6667C32 23.0527 29 26 25.8723 25.9914L7.82979 26Z" fill="#C4C4C4"/></mask><g mask="url(#MASK)"><path d="M7.83017 26.0001C5.37824 26.0001 3.18957 24.8966 1.75391 23.1691L18.0429 16.3335L30.7089 23.4647C29.5926 24.9211 27.9066 26.0001 26.0004 25.9915C23.1254 26.0001 12.0629 26.0001 7.83017 26.0001Z" fill="url(#GRAD0)"/><path d="M25.5785 13.3149L18.043 16.3334L30.709 23.4647C31.5199 22.4065 32.0004 21.0916 32.0004 19.6669C32.0004 16.1857 29.1321 13.3605 25.5833 13.3337C25.5817 13.3274 25.5801 13.3212 25.5785 13.3149Z" fill="url(#GRAD1)"/><path d="M7.06445 10.7028L18.0423 16.3333L25.5779 13.3148C24.5051 9.11261 20.6237 6 15.9997 6C12.4141 6 9.27508 7.87166 7.54586 10.6716C7.3841 10.6773 7.22358 10.6877 7.06445 10.7028Z" fill="url(#GRAD2)"/><path d="M1.7535 23.1687L18.0425 16.3331L7.06471 10.7026C3.09947 11.0792 0 14.3517 0 18.3331C0 20.1665 0.657197 21.8495 1.7535 23.1687Z" fill="url(#GRAD3)"/></g><defs><linearGradient id="GRAD0" x1="4.42591" y1="24.6668" x2="27.2309" y2="23.2764" gradientUnits="userSpaceOnUse"><stop stop-color="#2086B8"/><stop offset="1" stop-color="#46D3F6"/></linearGradient><linearGradient id="GRAD1" x1="23.8302" y1="19.6668" x2="30.2108" y2="15.2082" gradientUnits="userSpaceOnUse"><stop stop-color="#1694DB"/><stop offset="1" stop-color="#62C3FE"/></linearGradient><linearGradient id="GRAD2" x1="8.51037" y1="7.33333" x2="23.3335" y2="15.9348" gradientUnits="userSpaceOnUse"><stop stop-color="#0D3D78"/><stop offset="1" stop-color="#063B83"/></linearGradient><linearGradient id="GRAD3" x1="-0.340429" y1="19.9998" x2="14.5634" y2="14.4649" gradientUnits="userSpaceOnUse"><stop stop-color="#16589B"/><stop offset="1" stop-color="#1464B7"/></linearGradient></defs></svg>'.replace(/MASK/g, id + "-mask").replace(/GRAD([0-3])/g, function(_, n) { return id + "-gradient-" + n; });
    return box.firstElementChild;
  }
  function p2mOpenOneDrive(fileInput, multiple, dismissSources) {
    if (!p2mOneDriveEnabled() || !fileInput || !fileInput.isConnected) return;
    var old = document.getElementById("p2m-onedrive-overlay");
    if (old && old.p2mClose) old.p2mClose();
    var overlay = document.createElement("div");
    overlay.id = "p2m-onedrive-overlay";
    overlay.style.cssText = "position:fixed;inset:0;z-index:2147483647;background:#0009;display:flex;align-items:center;justify-content:center;padding:16px;";
    var panel = document.createElement("div");
    panel.style.cssText = "background:white;color:#222;border-radius:12px;padding:20px;width:min(100%,420px);max-height:calc(100dvh - 32px);overflow:auto;box-sizing:border-box;font:inherit;";
    panel.setAttribute("role", "dialog"); panel.setAttribute("aria-modal", "true");
    var title = document.createElement("h3"); title.textContent = "OneDrive"; panel.setAttribute("aria-label", "OneDrive");
    var status = document.createElement("p"); status.setAttribute("role", "status"); status.setAttribute("aria-live", "polite");
    var connect = document.createElement("button"); connect.type = "button"; connect.textContent = p2mDriveMessage("Connect Microsoft account", "Σύνδεση Microsoft account");
    var choose = document.createElement("button"); choose.type = "button"; choose.textContent = p2mDriveMessage("Choose photos", "Επιλογή φωτογραφιών");
    var cancel = document.createElement("button"); cancel.type = "button"; cancel.textContent = p2mDriveMessage("Close", "Κλείσιμο");
    [connect, choose, cancel].forEach(function(b) { b.style.cssText = "display:block;width:100%;min-height:44px;margin-top:10px;border:1px solid #ddd;border-radius:8px;background:#fafafa;color:#222;font:inherit;cursor:pointer;"; });
    panel.append(title, status, connect, choose, cancel); overlay.appendChild(panel);
    var closed = false, busy = false, win = null, port = null, channel = null, monitor = null, pickerTimer = null;
    var graphConsentNeeded = false;
    var importStage = "idle", importHost = "not supplied", importHttp = "not received";
    var controller = new AbortController();
    function message(en, gr) { if (!closed) status.textContent = p2mDriveMessage(en, gr); }
    function update() { connect.disabled = busy || !p2mOneDriveApp; choose.disabled = busy || graphConsentNeeded || !p2mOneDriveApp || !p2mOneDriveApp.getActiveAccount(); }
    function stopPicker() {
      clearInterval(monitor); clearTimeout(pickerTimer); monitor = null; pickerTimer = null;
      if (port) port.close(); port = null;
      if (win && !win.closed) win.close(); win = null; channel = null;
    }
    function close() {
      if (closed) return; closed = true; controller.abort(); stopPicker();
      window.removeEventListener("message", initialize); document.removeEventListener("keydown", escape);
      overlay.remove();
    }
    function escape(e) { if (e.key === "Escape") { e.stopPropagation(); close(); } }
    function alive() {
      var editor = document.getElementById("p2m-modal-overlay");
      return !closed && overlay.isConnected && fileInput.isConnected && editor && editor.style.display !== "none";
    }
    function fail(error, detail) {
      stopPicker(); controller.abort(); controller = new AbortController(); busy = false; update();
      message("OneDrive import failed. Existing photos were not changed. Close and try again.", "Η εισαγωγή OneDrive απέτυχε. Οι υπάρχουσες φωτογραφίες δεν άλλαξαν. Κλείσε και δοκίμασε ξανά.");
      if (detail) {
        var commandName = ["authenticate", "pick", "close"].includes(detail.command) ? detail.command : "other";
        var hostname = "not supplied";
        try { hostname = new URL(detail.resource).hostname; } catch (_) {}
        var code = error && (error.errorCode || error.message);
        var allowed = ["invalid_resource", "invalid_selection", "invalid_item", "invalid_endpoint", "read_failed", "size_limit", "empty_response", "unsupported_image", "invalid_download", "image_dimensions", "editor_closed", "batch_size_limit", "token_unavailable"];
        code = allowed.includes(code) ? code : (error && error.errorCode && /^[a-zA-Z0-9_-]{1,80}$/.test(error.errorCode) ? error.errorCode : "command_failed");
        status.style.whiteSpace = "pre-line";
        status.textContent += "\nCommand: " + commandName + "\nResource hostname: " + hostname + "\nCode: " + code;
        status.textContent += "\nStage: " + importStage + "\nRead hostname: " + importHost + "\nHTTP: " + importHttp;
        var kind = error && ["TypeError", "SyntaxError", "AbortError", "EncodingError"].includes(error.name) ? error.name : "Error";
        status.textContent += "\nError type: " + kind;
      }
    }
    async function token(resourceOrigin) {
      var account = p2mOneDriveApp.getActiveAccount();
      if (!account || closed) throw new Error("token_unavailable");
      var graph = resourceOrigin === "https://graph.microsoft.com";
      var cacheKey = account.homeAccountId + (graph ? ":graph" : ":onedrive");
      var cached = p2mOneDriveTokenCache.get(cacheKey);
      if (cached && cached.expires > Date.now()) return cached.token;
      p2mOneDriveTokenCache.delete(cacheKey);
      var scopes = resourceOrigin === "https://graph.microsoft.com" ? ["https://graph.microsoft.com/Files.Read"] : ["OneDrive.ReadOnly"];
      var result = await p2mOneDriveApp.acquireTokenSilent({ account: p2mOneDriveApp.getActiveAccount(), scopes: scopes });
      if (!result.accessToken || closed) throw new Error("token_unavailable");
      p2mRememberOneDriveToken(result, graph);
      return result.accessToken;
    }
    async function bounded(url, options, max) {
      importHost = new URL(url).hostname; importHttp = "not received";
      var timer = setTimeout(function() { controller.abort(); }, 30000);
      try {
        var response = await fetch(url, Object.assign({ credentials: "omit", redirect: "error", referrerPolicy: "no-referrer", signal: controller.signal }, options));
        importHttp = response.status;
        if (!response.ok || !response.body) throw new Error("read_failed");
        var reader = response.body.getReader(), chunks = [], size = 0;
        while (true) {
          var part = await reader.read(); if (part.done) break;
          size += part.value.byteLength;
          if (size > max) { await reader.cancel(); throw new Error("size_limit"); }
          chunks.push(part.value);
        }
        if (!size) throw new Error("empty_response");
        return new Blob(chunks);
      } finally { clearTimeout(timer); }
    }
    async function readItem(item, accessToken) {
      importStage = "item_validation"; importHost = "not supplied"; importHttp = "not received";
      if (!item || typeof item.id !== "string" || !item.parentReference || typeof item.parentReference.driveId !== "string") throw new Error("invalid_item");
      importStage = "endpoint_parse";
      var endpointValue = item["@sharePoint.endpoint"];
      if (endpointValue !== undefined && endpointValue !== null && endpointValue !== "" && typeof endpointValue !== "string") throw new Error("invalid_endpoint");
      // Use only the fixed Graph endpoint when the selected item omits the optional endpoint.
      var endpoint = new URL(endpointValue || "https://graph.microsoft.com/v1.0");
      if (!["https://graph.microsoft.com", "https://api.onedrive.com", "https://my.microsoftpersonalcontent.com"].includes(endpoint.origin) || endpoint.username || endpoint.password || endpoint.search || endpoint.hash) throw new Error("invalid_endpoint");
      var url = endpoint.href.replace(/\/$/, "") + "/drives/" + encodeURIComponent(item.parentReference.driveId) + "/items/" + encodeURIComponent(item.id);
      importHost = endpoint.hostname; importStage = "metadata_token";
      if (endpoint.origin === "https://graph.microsoft.com") accessToken = await token(endpoint.origin);
      importStage = "metadata_fetch";
      var metadataBlob = await bounded(url, { headers: { Authorization: "Bearer " + accessToken } }, 1024 * 1024);
      importStage = "metadata_parse";
      var metadata = JSON.parse(await metadataBlob.text());
      importStage = "image_type_validation";
      var mime = metadata.file && metadata.file.mimeType;
      if (!Number.isSafeInteger(metadata.size) || metadata.size < 1 || metadata.size > 20 * 1024 * 1024 || !["image/jpeg", "image/png", "image/webp", "image/gif", "image/bmp"].includes(mime)) throw new Error("unsupported_image");
      importStage = "download_url_parse";
      var downloadValue = metadata["@microsoft.graph.downloadUrl"] || metadata["@content.downloadUrl"];
      if (typeof downloadValue !== "string" || !downloadValue) { var missing = new Error("invalid_download"); throw missing; }
      var download = new URL(downloadValue);
      importHost = download.hostname; importStage = "download_host_validation";
      if (download.protocol !== "https:" || download.username || download.password || ![".1drv.com", ".microsoftpersonalcontent.com", ".livefilestore.com", ".storage.live.com"].some(function(s) { return download.hostname.toLowerCase().endsWith(s); })) throw new Error("invalid_download");
      importStage = "image_fetch";
      var blob = await bounded(download.href, {}, 20 * 1024 * 1024);
      var typed = new Blob([blob], { type: mime });
      importStage = "image_decode";
      var objectUrl = URL.createObjectURL(typed);
      try {
        var image = new Image(); image.src = objectUrl; await image.decode();
        if (!image.naturalWidth || !image.naturalHeight || image.naturalWidth * image.naturalHeight > 60000000) throw new Error("image_dimensions");
      } finally { URL.revokeObjectURL(objectUrl); }
      return new File([typed], "onedrive-photo." + ({"image/jpeg":"jpg","image/png":"png","image/webp":"webp","image/gif":"gif","image/bmp":"bmp"}[mime]), { type: mime });
    }
    async function command(event) {
      var payload = event.data;
      if (closed || !payload || payload.type !== "command" || !port) return;
      var activePort = port;
      activePort.postMessage({ type: "acknowledge", id: payload.id });
      function reply(data) { if (!closed && activePort === port) activePort.postMessage({ type: "result", id: payload.id, data: data }); }
      var data = payload.data || {};
      try {
        if (data.command === "authenticate") {
          var resource = new URL(data.resource);
          if (!["https://graph.microsoft.com", "https://onedrive.live.com", "https://api.onedrive.com", "https://my.microsoftpersonalcontent.com"].includes(resource.origin) || resource.username || resource.password) throw new Error("invalid_resource");
          reply({ result: "token", token: await token(resource.origin) });
        } else if (data.command === "close") {
          reply({ result: "success" }); stopPicker(); busy = false; update();
          message("Selection cancelled. You can try again.", "Η επιλογή ακυρώθηκε. Μπορείς να δοκιμάσεις ξανά.");
        } else if (data.command === "pick") {
          if (busy !== "picker" || !alive() || !Array.isArray(data.items) || !data.items.length || data.items.length > (multiple ? 10 : 1)) throw new Error("invalid_selection");
          busy = "import"; clearTimeout(pickerTimer); update();
          message("Importing photos...", "Εισαγωγή φωτογραφιών...");
          importStage = "onedrive_token"; importHost = "not supplied"; importHttp = "not received";
          var files = [], total = 0, accessToken = await token();
          for (var i = 0; i < data.items.length; i++) {
            if (!alive()) throw new Error("editor_closed");
            var file = await readItem(data.items[i], accessToken); total += file.size;
            if (total > 80 * 1024 * 1024) throw new Error("batch_size_limit");
            files.push(file);
          }
          if (!alive()) throw new Error("editor_closed");
          importStage = "file_input_transfer";
          var transfer = new DataTransfer(); files.forEach(function(f) { transfer.items.add(f); });
          reply({ result: "success" });
          if (fileInput.p2mCameraCleanup) fileInput.p2mCameraCleanup();
          fileInput.files = transfer.files; close();
          fileInput.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          reply({ result: "error", error: { code: "unsupportedCommand", message: "Unsupported command" } });
        }
      } catch (error) {
        reply({ result: "error", error: { code: "importFailed", message: "Could not complete OneDrive import" } });
        var graphRequest = data.command === "authenticate" && resource && resource.origin === "https://graph.microsoft.com";
        var needsInteraction = error && (
          ["interaction_required", "consent_required", "login_required", "monitor_window_timeout"].includes(error.errorCode) ||
          (window.msal && msal.InteractionRequiredAuthError && error instanceof msal.InteractionRequiredAuthError)
        );
        if (!closed && graphRequest && needsInteraction) {
          stopPicker(); busy = false; graphConsentNeeded = true;
          connect.textContent = p2mDriveMessage("Authorize photo view", "Εξουσιοδότηση προβολής φωτογραφιών");
          update();
          message("Microsoft requires read-only consent for the Photos view. Click Authorize photo view, then choose photos again.", "Η Microsoft ζητά συγκατάθεση μόνο ανάγνωσης για την προβολή Φωτογραφίες. Πάτα Εξουσιοδότηση προβολής φωτογραφιών και μετά επίλεξε ξανά φωτογραφίες.");
          return;
        }
        if (!closed) fail(error, data);
      }
    }
    function initialize(event) {
      if (closed || event.origin !== "https://onedrive.live.com" || event.source !== win || !event.data || event.data.type !== "initialize" || event.data.channelId !== channel || event.ports.length !== 1) return;
      if (port) port.close(); port = event.ports[0]; port.addEventListener("message", command); port.start(); port.postMessage({ type: "activate" });
    }
    connect.addEventListener("click", function() {
      if (closed || busy || !p2mOneDriveApp) return;
      busy = "login"; update(); message("Connecting...", "Σύνδεση...");
      // Direct user gesture, not an asynchronous SDK-load callback.
      var graphLogin = graphConsentNeeded;
      var loginRequest = graphConsentNeeded ? { scopes: ["https://graph.microsoft.com/Files.Read"], account: p2mOneDriveApp.getActiveAccount() } : { scopes: ["OneDrive.ReadOnly"], prompt: "select_account" };
      p2mOneDriveApp.loginPopup(loginRequest).then(function(result) {
        if (closed) return; p2mRememberOneDriveToken(result, graphLogin);
        if (closed) return; p2mOneDriveApp.setActiveAccount(result.account); graphConsentNeeded = false; busy = false;
        connect.textContent = p2mDriveMessage("Connect Microsoft account", "Σύνδεση Microsoft account"); update();
        message("Connected. Choose photos from your personal OneDrive.", "Συνδέθηκε. Επίλεξε φωτογραφίες από το προσωπικό σου OneDrive.");
      }).catch(function() { if (!closed) { busy = false; update(); message("Connection cancelled or failed. Try again.", "Η σύνδεση ακυρώθηκε ή απέτυχε. Δοκίμασε ξανά."); } });
    });
    choose.addEventListener("click", function() {
      if (closed || busy || !p2mOneDriveApp || !p2mOneDriveApp.getActiveAccount()) return;
      stopPicker(); win = window.open("", "P2MOneDrivePicker", "width=1080,height=680");
      if (!win) { message("The picker window did not open. Try again.", "Το παράθυρο επιλογής δεν άνοιξε. Δοκίμασε ξανά."); return; }
      busy = "picker"; channel = crypto.randomUUID(); update();
      message(multiple ? "Choose up to 10 photos, maximum 20 MB each (80 MB total)." : "Choose one photo, maximum 20 MB.", multiple ? "Επίλεξε έως 10 φωτογραφίες, έως 20 MB η καθεμία (80 MB συνολικά)." : "Επίλεξε μία φωτογραφία, έως 20 MB.");
      monitor = setInterval(function() {
        if (closed) return;
        if (!alive()) { close(); return; }
        if (busy === "picker" && (!win || win.closed)) { stopPicker(); busy = false; update(); message("Selection cancelled.", "Η επιλογή ακυρώθηκε."); }
      }, 500);
      pickerTimer = setTimeout(function() { if (!closed && busy === "picker") fail(); }, 300000);
      token().then(function(accessToken) {
        if (!alive() || !win || win.closed) throw new Error("picker_closed");
        var options = { sdk: "8.0", entry: { oneDrive: {} }, authentication: {}, messaging: { origin: location.origin, channelId: channel }, selection: { mode: multiple ? "multiple" : "single" } };
        var query = new URLSearchParams({ filePicker: JSON.stringify(options), locale: p2mDriveMessage("en-us", "el-gr") });
        var form = win.document.createElement("form"); form.method = "POST"; form.action = "https://onedrive.live.com/picker?" + query;
        var input = win.document.createElement("input"); input.type = "hidden"; input.name = "access_token"; input.value = accessToken;
        form.appendChild(input); win.document.body.appendChild(form); form.submit();
      }).catch(function() { if (!closed) fail(); });
    });
    cancel.addEventListener("click", close);
    overlay.addEventListener("click", function(e) { if (e.target === overlay) close(); });
    overlay.p2mClose = close;
    window.addEventListener("message", initialize); document.addEventListener("keydown", escape);
    if (typeof dismissSources === "function") dismissSources();
    document.body.appendChild(overlay); update();
    message("Loading OneDrive...", "Φόρτωση OneDrive...");
    p2mPrepareOneDrive().then(function() {
      if (closed) return; update();
      message("Personal Microsoft accounts only. Connect, then choose photos.", "Μόνο προσωπικά Microsoft accounts. Συνδέσου και μετά επίλεξε φωτογραφίες.");
    }).catch(function(error) {
      var allowedCodes = ["asset_source_missing", "sdk_timeout", "sdk_missing", "sdk_initialization_failed", "sdk_load_failed"];
      var code = error && allowedCodes.includes(error.message) ? error.message : "sdk_unknown";
      message("OneDrive library could not load. Code: " + code, "Η βιβλιοθήκη OneDrive δεν φορτώθηκε. Κωδικός: " + code);
    });
  }
  function p2mShowSources(trigger, multiple) {
    var old = document.getElementById("p2m-source-overlay");
    if (old) {
      if (old.p2mUnlockScroll) old.p2mUnlockScroll();
      old.remove();
    }

    var overlay = document.createElement("div");
    overlay.id = "p2m-source-overlay";
    overlay.style.cssText =
      "position:fixed;inset:0;z-index:2147483647;" +
      "background:rgba(0,0,0,.55);display:flex;" +
      "align-items:center;justify-content:center;padding:16px;";

    var panel = document.createElement("div");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute(
      "aria-label",
      p2mDriveMessage(
        "Choose photo source",
        "Επιλογή πηγής φωτογραφίας"
      )
    );
    panel.style.cssText =
      "width:min(100%,420px);box-sizing:border-box;background:white;" +
      "border-radius:12px;padding:20px;color:#222;font:inherit;" +
      "box-shadow:0 12px 36px #0004;";
    panel.style.maxHeight = "calc(100dvh - 32px)";
    panel.style.overflowY = "auto";
    panel.style.overscrollBehavior = "contain";
    panel.style.webkitOverflowScrolling = "touch";

    var title = document.createElement("h3");
    title.textContent = p2mDriveMessage(
      "Choose photo source",
      "Επιλέξτε πηγή φωτογραφίας"
    );
    title.style.cssText =
      "margin:0 0 16px;text-align:center;font-size:18px;";

    var choices = document.createElement("div");
    choices.style.cssText =
      "display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;";
      p2mAddFacebookSdkTest(choices);

    function option(label, disabled) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = label;
      btn.disabled = !!disabled;
      btn.style.cssText =
        "min-height:66px;padding:9px;border:1px solid #ddd;" +
        "border-radius:8px;background:#fafafa;color:#222;" +
        "font:inherit;cursor:pointer;";
      if (disabled) btn.style.opacity = ".5";
      choices.appendChild(btn);
      return btn;
    }

    var device = option(
      p2mDriveMessage("📁 Device", "📁 Συσκευή")
    );
    var camera = null;
    if (window.matchMedia("(pointer: coarse)").matches) {
      camera = option(p2mDriveMessage("📷 Camera", "📷 Κάμερα"));
    }
        var drive = option("Google Drive", true);

drive.textContent = "";
drive.style.display = "flex";
drive.style.alignItems = "center";
drive.style.justifyContent = "center";
drive.style.gap = "9px";

var driveIcon = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "svg"
);

driveIcon.setAttribute("viewBox", "0 -13.5 256 256");
driveIcon.setAttribute("width", "24");
driveIcon.setAttribute("height", "24");
driveIcon.setAttribute("preserveAspectRatio", "xMidYMid meet");
driveIcon.setAttribute("aria-hidden", "true");
driveIcon.setAttribute("focusable", "false");
driveIcon.style.cssText = "display:block;flex-shrink:0;";

[
  {
    fill: "#0066DA",
    d: "M19.3542312,196.033928 L30.644172,215.534816 C32.9900287,219.64014 36.3622164,222.86588 40.3210929,225.211737 C51.6602421,210.818376 59.5534225,199.772864 64.000634,192.075201 C68.5137119,184.263529 74.0609657,172.045039 80.6423954,155.41973 C62.9064315,153.085282 49.4659974,151.918058 40.3210929,151.918058 C31.545465,151.918058 18.1051007,153.085282 0,155.41973 C0,159.964996 1.17298825,164.510261 3.51893479,168.615586 L19.3542312,196.033928 Z"
  },
  {
    fill: "#EA4335",
    d: "M215.681443,225.211737 C219.64032,222.86588 223.012507,219.64014 225.358364,215.534816 L230.050377,207.470615 L252.483511,168.615586 C254.829368,164.510261 256.002446,159.964996 256.002446,155.41973 C237.79254,153.085282 224.376613,151.918058 215.754667,151.918058 C206.488712,151.918058 193.072785,153.085282 175.506888,155.41973 C182.010479,172.136093 187.484394,184.354584 191.928633,192.075201 C196.412073,199.863919 204.329677,210.909431 215.681443,225.211737 Z"
  },
  {
    fill: "#00832D",
    d: "M128.001268,73.3111515 C141.121182,57.4655263 150.162898,45.2470011 155.126415,36.6555757 C159.123121,29.7376196 163.521739,18.6920726 168.322271,3.51893479 C164.363395,1.1729583 159.818129,0 155.126415,0 L100.876121,0 C96.1841079,0 91.638842,1.31958557 87.6799655,3.51893479 C93.7861943,20.9210065 98.9675428,33.3058067 103.224011,40.6733354 C107.927832,48.8151881 116.186918,59.6944602 128.001268,73.3111515 Z"
  },
  {
    fill: "#2684FC",
    d: "M175.360141,155.41973 L80.6420959,155.41973 L40.3210929,225.211737 C44.2799694,227.557893 48.8252352,228.730672 53.5172481,228.730672 L202.485288,228.730672 C207.177301,228.730672 211.722567,227.411146 215.681443,225.211737 L175.360141,155.41973 Z"
  },
  {
    fill: "#00AC47",
    d: "M128.001268,73.3111515 L87.680265,3.51893479 C83.7213885,5.86488134 80.3489013,9.09044179 78.0030446,13.1960654 L3.51893479,142.223575 C1.17298825,146.329198 0,150.874464 0,155.41973 L80.6423954,155.41973 L128.001268,73.3111515 Z"
  },
  {
    fill: "#FFBA00",
    d: "M215.241501,77.7099697 L177.999492,13.1960654 C175.653635,9.09044179 172.281148,5.86488134 168.322271,3.51893479 L128.001268,73.3111515 L175.360141,155.41973 L255.855999,155.41973 C255.855999,150.874464 254.682921,146.329198 252.337064,142.223575 L215.241501,77.7099697 Z"
  }
].forEach(function(part) {
  var path = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );

  path.setAttribute("fill", part.fill);
  path.setAttribute("d", part.d);
  driveIcon.appendChild(path);
});

var driveLabel = document.createElement("span");
driveLabel.textContent = "Google Drive";

drive.appendChild(driveIcon);
drive.appendChild(driveLabel);
    if (multiple && window.matchMedia("(pointer: coarse) and (max-width: 1024px)").matches) {
      drive.remove();
    }
    var photosTest = option("Google Photos");

photosTest.textContent = "";
photosTest.style.display = "flex";
photosTest.style.alignItems = "center";
photosTest.style.justifyContent = "center";
photosTest.style.gap = "9px";

var photosIcon = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "svg"
);

photosIcon.setAttribute("viewBox", "0 0 256 256");
photosIcon.setAttribute("width", "24");
photosIcon.setAttribute("height", "24");
photosIcon.setAttribute("preserveAspectRatio", "xMidYMid meet");
photosIcon.setAttribute("aria-hidden", "true");
photosIcon.setAttribute("focusable", "false");
photosIcon.style.cssText = "display:block;flex-shrink:0;";

[
  {
    fill: "#FBBB05",
    d: "M64,58.1485714 C99.328,58.1485714 128,86.8205714 128,122.148571 L128,122.148571 L128,128 L5.85142857,128 C2.63314286,128 0,125.366857 0,122.148571 C0,86.8205714 28.672,58.1485714 64,58.1485714 L64,58.1485714 Z"
  },
  {
    fill: "#E94335",
    d: "M197.851429,64 C197.851429,99.328 169.179429,128 133.851429,128 L128,128 L128,5.85142857 C128,2.63314286 130.633143,0 133.851429,0 L133.851429,0 C169.179429,0 197.851429,28.672 197.851429,64 Z"
  },
  {
    fill: "#4285F4",
    d: "M192,197.851429 C156.672,197.851429 128,169.179429 128,133.851429 L128,133.851429 L128,128 L250.148571,128 C253.366857,128 256,130.633143 256,133.851429 L256,133.851429 C256,169.179429 227.328,197.851429 192,197.851429 L192,197.851429 Z"
  },
  {
    fill: "#0F9D58",
    d: "M58.1485714,192 C58.1485714,156.672 86.8205714,128 122.148571,128 L128,128 L128,250.148571 C128,253.366857 125.366857,256 122.148571,256 L122.148571,256 C86.8205714,256 58.1485714,227.328 58.1485714,192 Z"
  }
].forEach(function(part) {
  var path = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );

  path.setAttribute("fill", part.fill);
  path.setAttribute("d", part.d);
  photosIcon.appendChild(path);
});

var photosLabel = document.createElement("span");
photosLabel.textContent = "Google Photos";

photosTest.appendChild(photosIcon);
photosTest.appendChild(photosLabel);

photosTest.addEventListener("click", function() {
  var input = null;

  if (multiple) {
    var scope = trigger.parentElement;
    while (scope && !input) {
      input = scope.querySelector("#p2m-bulk-file");
      scope = scope.parentElement;
    }
  } else {
    input = trigger.p2mSourceZone.querySelector(".p2m-slot-file");
  }

  if (!input) {
    alert(p2mDriveMessage(
      "Photo upload field not found.",
      "Δεν βρέθηκε το πεδίο μεταφόρτωσης φωτογραφιών."
    ));
    return;
  }

  p2mOpenPhotosPicker(input, photosTest, dismiss);
});
    var dropbox = option("Dropbox", true);

dropbox.textContent = "";
dropbox.style.display = "flex";
dropbox.style.alignItems = "center";
dropbox.style.justifyContent = "center";
dropbox.style.gap = "9px";

var dropboxIcon = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "svg"
);

dropboxIcon.setAttribute("viewBox", "0 -1.5 48 48");
dropboxIcon.setAttribute("width", "24");
dropboxIcon.setAttribute("height", "24");
dropboxIcon.setAttribute("preserveAspectRatio", "xMidYMid meet");
dropboxIcon.setAttribute("aria-hidden", "true");
dropboxIcon.setAttribute("focusable", "false");
dropboxIcon.style.cssText = "display:block;flex-shrink:0;";

var dropboxGroup = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "g"
);

dropboxGroup.setAttribute(
  "transform",
  "translate(-800 -363)"
);
dropboxGroup.setAttribute("fill", "#0F82E2");
dropboxGroup.setAttribute("fill-rule", "evenodd");

var dropboxPath = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "path"
);

dropboxPath.setAttribute(
  "d",
  "M824,389.033255 L814.1195,397.34573 L800,388.053538 " +
  "L809.7635,380.17347 L823.999971,389.033238 " +
  "L838.2362,380.172109 L847.9997,388.05369 " +
  "L833.8802,397.345881 L823.9997,389.033406 Z " +
  "M814.1198,363 L800.0003,372.292191 " +
  "L809.7638,380.17226 L824.0003,371.312475 " +
  "L814.1198,363 Z " +
  "M824.02895,390.821692 L814.11995,399.109976 " +
  "L809.87945,396.318993 L809.87945,399.447132 " +
  "L824.02895,408 L838.17845,399.447132 " +
  "L838.17845,396.318993 L833.93795,399.109976 " +
  "L824.02895,390.821692 Z " +
  "M848,372.292343 L833.8805,363.000151 " +
  "L824,371.312626 L838.2365,380.172411 " +
  "L848,372.292343 Z"
);

dropboxGroup.appendChild(dropboxPath);
dropboxIcon.appendChild(dropboxGroup);

var dropboxLabel = document.createElement("span");
dropboxLabel.textContent = "Dropbox";

dropbox.appendChild(dropboxIcon);
dropbox.appendChild(dropboxLabel);
    p2mPrepareDropbox().then(function() {
      if (overlay.isConnected) {
        dropbox.disabled = false;
        dropbox.style.opacity = "1";
      }
    }).catch(function(error) {
      console.warn("[p2m] Dropbox Chooser unavailable", error);
      if (overlay.isConnected) dropbox.title = p2mDriveMessage(
        "Dropbox unavailable", "Το Dropbox δεν είναι διαθέσιμο"
      );
    });
    var facebook = option("Facebook", true);

facebook.textContent = "";
facebook.style.display = "flex";
facebook.style.alignItems = "center";
facebook.style.justifyContent = "center";
facebook.style.gap = "9px";

var facebookIcon = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "svg"
);

facebookIcon.setAttribute("viewBox", "0 0 320 512");
facebookIcon.setAttribute("width", "14");
facebookIcon.setAttribute("height", "22");
facebookIcon.setAttribute("aria-hidden", "true");
facebookIcon.setAttribute("focusable", "false");
facebookIcon.style.cssText =
  "display:block;flex-shrink:0;color:#0866ff;";

var facebookPath = document.createElementNS(
  "http://www.w3.org/2000/svg",
  "path"
);

facebookPath.setAttribute("fill", "currentColor");
facebookPath.setAttribute(
  "d",
  "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 " +
  "12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 " +
  "225.36 0c-73.22 0-121.08 44.38-121.08 " +
  "124.72v70.62H22.89V288h81.39v224h100.17V288z"
);

facebookIcon.appendChild(facebookPath);

var facebookLabel = document.createElement("span");
facebookLabel.textContent = "Facebook";

facebook.appendChild(facebookIcon);
facebook.appendChild(facebookLabel);

facebook.addEventListener("click", function() {
  var input = p2mSourceInput();

  if (!input) {
    alert(p2mDriveMessage(
      "Photo upload field not found.",
      "Δεν βρέθηκε το πεδίο μεταφόρτωσης φωτογραφιών."
    ));
    return;
  }

  p2mOpenFacebookPicker(input, facebook, multiple, dismiss);
});

facebook.disabled = true;
facebook.style.opacity = ".5";
facebookLabel.textContent = p2mDriveMessage(
  "Facebook · Loading…",
  "Facebook · Φόρτωση…"
);

var facebookConfigReady = fetch(
  BACKEND_URL + "/facebook-picker/config",
  {
    method: "GET",
    mode: "cors",
    credentials: "omit",
    cache: "no-store"
  }
).then(function(response) {
  if (!response.ok) {
    throw new Error("Facebook picker unavailable");
  }

  return response.json();
}).then(function(config) {
  if (!config || config.enabled !== true) {
    throw new Error("Facebook picker unavailable");
  }
});

var facebookSdkReady = p2mAddFacebookSdkTest.readyPromise
  ? p2mAddFacebookSdkTest.readyPromise
  : Promise.reject(new Error("Facebook SDK unavailable"));

Promise.all([
  facebookConfigReady,
  facebookSdkReady
]).then(function() {
  if (!overlay.isConnected || !facebook.isConnected) return;

  if (
    p2mAddFacebookSdkTest.sdkReady !== true ||
    !window.FB ||
    typeof window.FB.login !== "function"
  ) {
    throw new Error("Facebook SDK unavailable");
  }

  facebookLabel.textContent = "Facebook";
  facebook.title = "";
  facebook.style.opacity = "1";
  facebook.disabled = false;
}).catch(function() {
  if (!overlay.isConnected || !facebook.isConnected) return;

  facebook.disabled = true;
  facebook.style.opacity = ".5";
  facebookLabel.textContent = p2mDriveMessage(
    "Facebook · Unavailable",
    "Facebook · Μη διαθέσιμο"
  );
  facebook.title = p2mDriveMessage(
    "Facebook could not load. Close and refresh the page.",
    "Το Facebook δεν φορτώθηκε. Κλείσε και ανανέωσε τη σελίδα."
  );
});
    if (p2mOneDriveEnabled()) {
      var oneDrive = option("OneDrive");
      oneDrive.textContent = "";
      oneDrive.style.display = "flex";
      oneDrive.style.alignItems = "center";
      oneDrive.style.justifyContent = "center";
      oneDrive.style.gap = "9px";
      var oneDriveIcon = p2mOneDriveIcon();
      oneDriveIcon.style.cssText = "display:block;flex-shrink:0;";
      var oneDriveLabel = document.createElement("span");
      oneDriveLabel.textContent = "OneDrive";
      oneDrive.append(oneDriveIcon, oneDriveLabel);
      oneDrive.addEventListener("click", function() {
        var input = p2mSourceInput();
        if (!input) {
          alert(p2mDriveMessage("Photo upload field not found.", "Δεν βρέθηκε το πεδίο μεταφόρτωσης φωτογραφιών."));
          return;
        }
        p2mOpenOneDrive(input, multiple, dismiss);
      });
      p2mPrepareOneDrive().catch(function() {});
    }
    var directLink = option(p2mDriveMessage("🔗 Direct Link", "🔗 Σύνδεσμος φωτογραφίας"));
    var close = option(
      p2mDriveMessage("Close", "Κλείσιμο")
    );
    close.style.gridColumn = "1 / -1";

    function dismiss() {
      if (overlay.p2mUnlockScroll) overlay.p2mUnlockScroll();
      overlay.remove();
    }

    close.addEventListener("click", dismiss);
    overlay.addEventListener("click", function(event) {
      if (event.target === overlay) dismiss();
    });

    function p2mSourceInput() {
      if (!multiple) return trigger.p2mSourceZone.querySelector(".p2m-slot-file");
      var scope = trigger.parentElement;
      while (scope) {
        var input = scope.querySelector("#p2m-bulk-file");
        if (input) return input;
        scope = scope.parentElement;
      }
      return null;
    }

    directLink.addEventListener("click", function() {
      var fileInput = p2mSourceInput();
      if (!fileInput) {
        alert(p2mDriveMessage("Photo upload field not found.", "Δεν βρέθηκε το πεδίο μεταφόρτωσης φωτογραφιών."));
        return;
      }

      panel.textContent = "";
      var linkTitle = document.createElement("h3");
      linkTitle.textContent = p2mDriveMessage("Import from a photo link", "Εισαγωγή από σύνδεσμο φωτογραφίας");
      linkTitle.style.cssText = "margin:0 0 12px;text-align:center;font-size:18px;";
      var hint = document.createElement("p");
      hint.textContent = multiple
        ? p2mDriveMessage("Paste up to 10 direct HTTPS JPG or PNG links, one per line.", "Βάλε έως 10 απευθείας HTTPS συνδέσμους JPG ή PNG, έναν ανά γραμμή.")
        : p2mDriveMessage("Paste a direct public HTTPS link to a JPG or PNG photo.", "Βάλε έναν απευθείας δημόσιο HTTPS σύνδεσμο φωτογραφίας JPG ή PNG.");
      hint.style.cssText = "font-size:14px;line-height:1.4;margin:0 0 12px;";
      var form = document.createElement("form");
      var links = document.createElement("textarea");
      links.setAttribute("aria-label", p2mDriveMessage("Photo link", "Σύνδεσμος φωτογραφίας"));
      links.placeholder = "https://example.com/photo.jpg";
      links.required = true;
      links.rows = multiple ? 5 : 2;
      links.style.cssText = "box-sizing:border-box;width:100%;font:inherit;padding:10px;border:1px solid #999;border-radius:8px;resize:vertical;";
      var errorText = document.createElement("p");
      errorText.setAttribute("role", "alert");
      errorText.style.cssText = "min-height:20px;color:#a31919;font-size:14px;line-height:1.4;";
      var actions = document.createElement("div");
      actions.style.cssText = "display:flex;gap:10px;justify-content:flex-end;";
      var back = document.createElement("button");
      back.type = "button";
      back.textContent = p2mDriveMessage("Back", "Πίσω");
      var submit = document.createElement("button");
      submit.type = "submit";
      submit.textContent = p2mDriveMessage("Import", "Εισαγωγή");
      [back, submit].forEach(function(button) {
        button.style.cssText = "font:inherit;padding:10px 16px;border:1px solid #ccc;border-radius:8px;cursor:pointer;";
      });
      actions.appendChild(back);
      actions.appendChild(submit);
      form.appendChild(links);
      form.appendChild(errorText);
      form.appendChild(actions);
      panel.appendChild(linkTitle);
      panel.appendChild(hint);
      panel.appendChild(form);
      links.focus();

      var controller = null;
      back.addEventListener("click", function() {
        if (controller) controller.abort();
        dismiss();
        p2mShowSources(trigger, multiple);
      });
      form.addEventListener("submit", function(event) {
        event.preventDefault();
        var urls = links.value.split(/\r?\n/).map(function(value) { return value.trim(); }).filter(Boolean);
        if (!urls.length || urls.length > (multiple ? 10 : 1)) {
          errorText.textContent = p2mDriveMessage("Enter 1 to 10 links (one for a single slot).", "Βάλε 1 έως 10 συνδέσμους (έναν για μεμονωμένη θέση).");
          return;
        }
        try {
          urls.forEach(function(value) {
            var parsed = new URL(value);
            if (parsed.protocol !== "https:" || parsed.username || parsed.password || parsed.port) throw new Error("Invalid link");
          });
        } catch (error) {
          errorText.textContent = p2mDriveMessage("Use direct public HTTPS photo links.", "Χρησιμοποίησε απευθείας δημόσιους HTTPS συνδέσμους φωτογραφιών.");
          return;
        }
        submit.disabled = true;
        links.disabled = true;
        errorText.textContent = p2mDriveMessage("Importing photos…", "Γίνεται εισαγωγή φωτογραφιών…");
        controller = new AbortController();
        var photos = [];
        urls.reduce(function(chain, value, index) {
          return chain.then(function() {
            return fetch(BACKEND_URL + "/import-image", {
              method: "POST",
              mode: "cors",
              credentials: "omit",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ url: value }),
              signal: controller.signal
            }).then(function(response) {
              if (!response.ok || !/^image\/jpeg\b/i.test(response.headers.get("Content-Type") || "")) {
                throw new Error("Import failed");
              }
              return response.blob();
            }).then(function(blob) {
              if (!blob.size || blob.size > 8 * 1024 * 1024) throw new Error("Invalid image size");
              photos.push(new File([blob], "linked-photo-" + (index + 1) + ".jpg", { type: "image/jpeg" }));
            });
          });
        }, Promise.resolve()).then(function() {
          if (!overlay.isConnected || !fileInput.isConnected) return;
          var transfer = new DataTransfer();
          photos.forEach(function(photo) { transfer.items.add(photo); });
          fileInput.files = transfer.files;
          dismiss();
          fileInput.dispatchEvent(new Event("change", { bubbles: true }));
        }).catch(function() {
          if (!overlay.isConnected) return;
          errorText.textContent = p2mDriveMessage(
            "Could not import this photo. Check the direct link or download it and use Device. Existing photos were not changed.",
            "Δεν έγινε εισαγωγή. Έλεγξε τον απευθείας σύνδεσμο ή κατέβασε τη φωτογραφία και επίλεξε Συσκευή. Οι υπάρχουσες φωτογραφίες δεν άλλαξαν."
          );
        }).finally(function() {
          controller = null;
          if (overlay.isConnected) {
            submit.disabled = false;
            links.disabled = false;
          }
        });
      });
    });

    dropbox.addEventListener("click", function() {
      var input = p2mSourceInput();
      if (!input || !window.Dropbox || typeof window.Dropbox.choose !== "function") {
        alert(p2mDriveMessage("Dropbox is not ready.", "Το Dropbox δεν είναι έτοιμο."));
        return;
      }
      // Open synchronously from the customer's click to avoid popup blockers.
      dismiss();
      try {
        window.Dropbox.choose({
          linkType: "direct",
          multiselect: !!multiple,
          extensions: [".jpg", ".jpeg", ".png"],
          success: function(selected) {
            if (!selected || !selected.length) return;
            Promise.all(selected.map(function(item) {
              var url = new URL(item.link);
              if (url.protocol !== "https:" ||
                  !/(^|\.)dropboxusercontent\.com$|(^|\.)dropbox\.com$/.test(url.hostname)) {
                throw new Error("Unexpected Dropbox download host");
              }
              if (item.bytes && item.bytes > 20 * 1024 * 1024) {
                throw new Error("Dropbox image exceeds 20 MB");
              }
              return fetch(url.href, { credentials: "omit", mode: "cors" })
                .then(function(response) {
                  if (!response.ok) throw new Error("Dropbox download HTTP " + response.status);
                  return response.blob();
                }).then(function(blob) {
                  if (blob.size > 20 * 1024 * 1024) throw new Error("Dropbox image exceeds 20 MB");
                  var name = item.name || "dropbox-photo.jpg";
                  var mime = blob.type;
                  if (mime !== "image/jpeg" && mime !== "image/png") {
                    // Direct downloads sometimes omit the Content-Type header.
                    mime = /\.png$/i.test(name) ? "image/png" :
                      /\.jpe?g$/i.test(name) ? "image/jpeg" : "";
                  }
                  if (!mime) throw new Error("Unsupported Dropbox image type");
                  return new File([blob], name, { type: mime });
                });
            })).then(function(files) {
              if (!input.isConnected) throw new Error("Upload field is no longer available");
              var transfer = new DataTransfer();
              files.forEach(function(file) { transfer.items.add(file); });
              input.files = transfer.files;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }).catch(function(error) {
              console.warn("[p2m] Dropbox import failed", error);
              alert(p2mDriveMessage(
                "Could not import from Dropbox. Your existing photos were not changed. Download the photo to your device and use Device.",
                "Δεν έγινε εισαγωγή από το Dropbox. Οι υπάρχουσες φωτογραφίες δεν άλλαξαν. Κατέβασε τη φωτογραφία στη συσκευή και επίλεξε Συσκευή."
              ));
            });
          }
        });
      } catch (error) {
        console.warn("[p2m] Dropbox Chooser could not open", error);
        alert(p2mDriveMessage("Could not open Dropbox.", "Δεν άνοιξε το Dropbox."));
      }
    });

    if (camera) camera.addEventListener("click", function() {
      var input = p2mSourceInput();
      if (!input) {
        alert(p2mDriveMessage("Photo upload field not found.", "Δεν βρέθηκε το πεδίο μεταφόρτωσης φωτογραφιών."));
        return;
      }
      if (input.p2mCameraCleanup) input.p2mCameraCleanup();
      var wasMultiple = input.hasAttribute("multiple");
      var oldCapture = input.getAttribute("capture");
      function cleanup() {
        if (oldCapture === null) input.removeAttribute("capture");
        else input.setAttribute("capture", oldCapture);
        if (wasMultiple) input.setAttribute("multiple", "");
        else input.removeAttribute("multiple");
        input.removeEventListener("change", cleanup);
        input.removeEventListener("cancel", cleanup);
        input.p2mCameraCleanup = null;
      }
      input.p2mCameraCleanup = cleanup;
      input.setAttribute("capture", "environment");
      input.removeAttribute("multiple");
      input.addEventListener("change", cleanup, { once: true });
      input.addEventListener("cancel", cleanup, { once: true });
      dismiss();
      input.click();
    });

    device.addEventListener("click", function() {
      var deviceInput = p2mSourceInput();
      if (deviceInput && deviceInput.p2mCameraCleanup) deviceInput.p2mCameraCleanup();
      dismiss();
      p2mSourceBypass = true;
      try {
        if (multiple) {
          trigger.click();
                } else {
          trigger.p2mSourceZone.click();
        }
      } finally {
        p2mSourceBypass = false;
      }
    });

    drive.addEventListener("click", function() {
                  var input = null;

      if (multiple) {
        var scope = trigger.parentElement;
        while (scope && !input) {
          input = scope.querySelector("#p2m-bulk-file");
          scope = scope.parentElement;
        }
      } else {
        input = trigger.p2mSourceZone.querySelector(".p2m-slot-file");
      }

      if (!input) return;
      dismiss();
      p2mOpenDrivePicker(input, drive, multiple);
    });

    panel.appendChild(title);
    panel.appendChild(choices);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    var openEditor = document.getElementById("p2m-modal-overlay");
    overlay.p2mUnlockScroll = openEditor && openEditor.style.display !== "none" && openEditor.p2mUnlockScroll
      ? null : p2mLockEditorPage();
    close.focus();

        p2mPrepareDrive().then(function() {
      if (overlay.isConnected) {
        drive.disabled = false;
        drive.style.opacity = "1";
      }
    }).catch(function() {
      if (overlay.isConnected) {
        drive.disabled = true;
        drive.title = p2mDriveMessage(
          "Google Drive unavailable",
          "Google Drive μη διαθέσιμο"
        );
      }
    });
  }

          function attachSlotEvents(container) {
  p2mAttachDriveButtons(container);

  container.querySelectorAll(".p2m-slot-dropzone").forEach(function (dz) {
    dz.addEventListener("click", function () {
      dz.querySelector(".p2m-slot-file").click();
    });

      dz.addEventListener("dragover", function (e) {
        e.preventDefault();
        dz.style.borderColor = "#e44";
        dz.style.background = "#fff5f5";
      });

      dz.addEventListener("dragleave", function () {
        dz.style.borderColor = "#ccc";
        dz.style.background = "#fafafa";
      });

      dz.addEventListener("drop", function (e) {
        e.preventDefault();
        dz.style.borderColor = "#ccc";
        dz.style.background = "#fafafa";

        var fi = dz.querySelector(".p2m-slot-file");
        if (!fi || !e.dataTransfer || !e.dataTransfer.files.length) return;

        fi.files = e.dataTransfer.files;
        fi.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    container.querySelectorAll(".p2m-slot-file").forEach(function (fi) {
      fi.addEventListener("change", function (e) {
        var startIdx = parseInt(fi.dataset.idx, 10);
        var files = Array.from(e.target.files).filter(function (f) { return f.type.startsWith("image/"); });

                function processNext(i) {
          var available = Math.max(0, state.slots.length - startIdx);
          var ignored = Math.max(0, files.length - available);

          if (i >= files.length || startIdx + i >= state.slots.length) {
            if (ignored > 0) {
              var msg = container.querySelector("#p2m-bulk-warning");

              if (!msg) {
                msg = document.createElement("div");
                msg.id = "p2m-bulk-warning";
                msg.style.cssText = "color:#e08800;font-size:13px;margin-top:6px;text-align:center;";

                var bulkBtn = container.querySelector("#p2m-bulk-btn");
                if (bulkBtn) {
                  bulkBtn.parentNode.insertBefore(msg, bulkBtn.nextSibling);
                } else {
                  container.appendChild(msg);
                }
              }

              msg.textContent = (i18n.bulkSlotsWarning ||
                "⚠️ {available} slots available. {ignored} photos ignored.")
                .replace("{available}", available)
                .replace("{ignored}", ignored);

              clearTimeout(msg._timer);
              msg._timer = setTimeout(function () {
                msg.textContent = "";
              }, 8000);
            }
            return;
          }

          var targetIdx = startIdx + i;
          var tplId = getSectionTemplateForSlot(targetIdx);
          var def = TEMPLATE_SHAPES[tplId] || TEMPLATE_SHAPES["square_50x50"];
          var isStd = tplId && tplId.indexOf("std_") === 0;
          var orientation = (state.slots[targetIdx] && state.slots[targetIdx].orientation)
            || (def.landscape ? "landscape" : "portrait");
          var rawW = def.w || 633, rawH = def.h || 633;
          if (orientation === "landscape" && rawW < rawH) { var t = rawW; rawW = rawH; rawH = t; }
          if (orientation === "portrait"  && rawW > rawH && !isStd) { var t = rawW; rawW = rawH; rawH = t; }
          var targetRatio = rawW / rawH;

          cropEditor.open(files[i], targetRatio, function(croppedDataUrl, finalOrientation) {
            if (croppedDataUrl) {
            if (!state.slots[targetIdx]) state.slots[targetIdx] = { qty:1, orientation: finalOrientation || orientation };
              state.slots[targetIdx].orientation    = finalOrientation || orientation;
              state.slots[targetIdx].file           = files[i];
              state.slots[targetIdx].previewUrl     = croppedDataUrl;
              state.slots[targetIdx].croppedDataUrl = croppedDataUrl;
              state.slots[targetIdx].uploadedUrl    = null;
              state.slots[targetIdx].uploading      = true;
              state.slots[targetIdx].error          = null;
              renderSlots(container);
              dataUrlToBlob(croppedDataUrl, function(blob) {
                var croppedFile = new File([blob], "cropped.jpg", { type: "image/jpeg" });
                uploadFile(croppedFile).then(function(url) {
  state.slots[targetIdx].uploadedUrl    = url;
state.slots[targetIdx].uploading      = false;
  renderSlots(container);
  renderTextFields(container, TEMPLATE_SHAPES[state.templateId]);
}).catch(function() {
  state.slots[targetIdx].uploading = false;
  state.slots[targetIdx].error     = i18n.errUpload;
  renderSlots(container);
});
              });
            }
            processNext(i + 1);
          }, tplId, state);
        }
        processNext(0);
        e.target.value = "";
      });
    });

    container.querySelectorAll(".p2m-qty-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx, 10);
        var delta = parseInt(btn.dataset.delta, 10);
        adjustSlotsForQtyChange(idx, delta);
        renderSlots(container);
        renderDoneBtn(container);
      });
    });

    container.querySelectorAll(".p2m-orient-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx, 10);
        if (!state.slots[idx]) state.slots[idx] = { qty:1 };
        state.slots[idx].orientation = btn.dataset.orient;
        renderSlots(container);
      });
    });

    container.querySelectorAll(".p2m-remove-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.dataset.idx, 10);
        var slot = state.slots[idx];
        if (slot && slot.previewUrl) URL.revokeObjectURL(slot.previewUrl);
        var def = TEMPLATE_SHAPES[getSectionTemplateForSlot ? getSectionTemplateForSlot(idx) : state.templateId] || TEMPLATE_SHAPES[state.templateId] || {};
        if (productFlags.singleSlot) {
          state.slots[idx] = { qty: slot ? (slot.qty || 1) : 1, orientation: def.landscape ? "landscape" : "portrait", sectionIdx: slot ? slot.sectionIdx : undefined, file:null, previewUrl:null, uploadedUrl:null };
        } else if (state.sections) {
          state.slots[idx] = { qty: slot ? (slot.qty || 1) : 1, orientation: def.landscape ? "landscape" : "portrait", sectionIdx: slot ? slot.sectionIdx : undefined, file:null, previewUrl:null, uploadedUrl:null };
        } else {
          var removedQty = slot ? (slot.qty || 1) : 1;
          state.slots.splice(idx, 1);
          state.slots.push({ qty: removedQty, orientation: def.landscape ? "landscape" : "portrait", file:null, previewUrl:null, uploadedUrl:null });
        }
        renderSlots(container);
      });
    });

    container.addEventListener("input", function(e) {
  var inp = e.target;
  if (!inp.classList.contains("p2m-slot-caption")) return;
  var idx = parseInt(inp.dataset.idx, 10);
  if (!state.slotCaptions[idx]) state.slotCaptions[idx] = {};
  state.slotCaptions[idx][inp.dataset.key] = inp.value;
          var hasText = inp.value.trim().length > 0;
        container.querySelectorAll(".p2m-slot-style[data-idx='" + idx + "'][data-key='" + inp.dataset.key + "']").forEach(function(ctrl) {
          ctrl.disabled = !hasText;
          ctrl.style.opacity = hasText ? "1" : "0.4";
          ctrl.style.pointerEvents = hasText ? "auto" : "none";
        });
  var styleKey = inp.dataset.key + '_style';
  var existingStyle = (state.textStyles && state.textStyles[idx] && state.textStyles[idx][inp.dataset.key]) || {};
  if (!state.slotCaptions[idx][styleKey] || !Object.keys(state.slotCaptions[idx][styleKey]).length) {
  state.slotCaptions[idx][styleKey] = Object.assign({ size: 28, color: '#000000', align: 'center', rotation: 0 }, existingStyle);
}
  renderDoneBtn(container);
  var canvas = container.querySelector(".p2m-slot-canvas[data-idx='" + idx + "']");
  if (canvas) {
    var slot = state.slots[idx];
    if (slot && slot.previewUrl) {
      clearTimeout(inp._captionTimer);
      inp._captionTimer = setTimeout(function() {
        drawCanvas(canvas, slot.croppedDataUrl || slot.previewUrl, getSectionTemplateForSlot(idx), slot.orientation, state.slotCaptions[idx], (state.textStyles && state.textStyles[idx]) || {}, getMonthIndexForSlot(idx));
      }, 150);
    }
  }
});

        // p2m-slot-style: font/size/color/bold/align/rotation per slot
    container.querySelectorAll(".p2m-slot-style").forEach(function(el) {
      var evt = (el.tagName === "INPUT" || el.tagName === "SELECT") ? "input" : "click";
      el.addEventListener(evt, function() {
        var idx = parseInt(el.dataset.idx, 10);
        var key = el.dataset.key;
        var prop = el.dataset.prop;
        if (!state.textStyles) state.textStyles = {};
        if (!state.textStyles[idx]) state.textStyles[idx] = {};
        if (!state.textStyles[idx][key]) state.textStyles[idx][key] = {};
        var val;
        if (prop === "bold") {
          val = el.dataset.val === "true";
        } else if (prop === "size" || prop === "rotation") {
          val = el.dataset.val !== undefined ? parseInt(el.dataset.val, 10) : parseInt(el.value, 10);
        } else if (el.dataset.val !== undefined) {
          val = el.dataset.val;
        } else {
          val = el.value;
        }
        if (!state.textStyles[idx]) state.textStyles[idx] = {};
        if (!state.textStyles[idx][key]) state.textStyles[idx][key] = {};
        state.textStyles[idx][key][prop] = val;
        if (!state.slotCaptions[idx]) state.slotCaptions[idx] = {};
        if (!state.slotCaptions[idx][key]) state.slotCaptions[idx][key] = '';
        state.slotCaptions[idx][key + '_style'] = Object.assign(
          { size: 28, color: '#000000', align: 'center', rotation: 0 },
          state.slotCaptions[idx][key + '_style'] || {},
          { [prop]: val }
        );

        // Update align button active states
        if (prop === "align") {
          container.querySelectorAll(".p2m-slot-style[data-idx='" + idx + "'][data-key='" + key + "'][data-prop='align']").forEach(function(btn) {
            var isActive = btn.dataset.val === val;
            btn.style.background = isActive ? "#333" : "#fff";
            btn.style.color = isActive ? "#fff" : "#333";
          });
        }
        // Update bold button active state + toggle data-val
        if (prop === "bold") {
          var boldBtn = container.querySelector(".p2m-slot-style[data-idx='" + idx + "'][data-key='" + key + "'][data-prop='bold']");
          if (boldBtn) {
            boldBtn.dataset.val = (!val).toString();
            boldBtn.style.background = val ? "#333" : "#fff";
            boldBtn.style.color = val ? "#fff" : "#333";
          }
        }
                // Update rotation label
        if (prop === "rotation") {
          var lbl = container.querySelector(".p2m-rot-val[data-idx='" + idx + "'][data-key='" + key + "']");
          if (lbl) lbl.textContent = val + "°";
          // Sync reset button data-val stays 0
        }
        var canvas = container.querySelector(".p2m-slot-canvas[data-idx='" + idx + "']");
        if (canvas) {
          var slot = state.slots[idx];
          if (slot && slot.previewUrl) {
            if (prop === "rotation") {
              if (window._p2mRotTimer) clearTimeout(window._p2mRotTimer);
              (function(capturedIdx, capturedSlot) {
                window._p2mRotTimer = setTimeout(function() {
                  drawCanvas(canvas, capturedSlot.croppedDataUrl || capturedSlot.previewUrl, getSectionTemplateForSlot(capturedIdx), capturedSlot.orientation, state.slotCaptions[capturedIdx], state.textStyles[capturedIdx] || {}, getMonthIndexForSlot(capturedIdx));
                }, 30);
              })(idx, slot);
            } else {
              drawCanvas(canvas, slot.croppedDataUrl || slot.previewUrl, getSectionTemplateForSlot(idx), slot.orientation, state.slotCaptions[idx], state.textStyles[idx] || {}, getMonthIndexForSlot(idx));
            }
          }
        }
        renderDoneBtn(container);
      });
    });
  }

  function dataUrlToBlob(dataUrl, cb) {
  var arr = dataUrl.split(","), mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]), n = bstr.length, u8 = new Uint8Array(n);
  while (n--) u8[n] = bstr.charCodeAt(n);
  cb(new Blob([u8], { type: mime }));
}

  function handleSlotFile(container, slotIdx, file) {
  // 3.2 + 3.3 validation
  var allowedTypes = ["image/jpeg", "image/png", "image/heic", "image/heif"];
  if (allowedTypes.indexOf(file.type) === -1) {
    state.slots[slotIdx] = state.slots[slotIdx] || {};
    state.slots[slotIdx].error = i18n.errFileType || "❌ Only JPG, PNG or HEIC files are allowed.";
    renderSlots(container);
    return;
  }
  if (file.size > 20 * 1024 * 1024) {
    state.slots[slotIdx] = state.slots[slotIdx] || {};
    state.slots[slotIdx].error = i18n.errFileSize || "❌ File too large. Max 20MB.";
    renderSlots(container);
    return;
  }

  var tplId = getSectionTemplateForSlot(slotIdx);
  var def   = TEMPLATE_SHAPES[tplId] || TEMPLATE_SHAPES["square_50x50"];
  var isStd = tplId && tplId.indexOf("std_") === 0;

  var orientation = (state.slots[slotIdx] && state.slots[slotIdx].orientation)
    || (def.landscape ? "landscape" : "portrait");
  var rawW = def.w || 633;
  var rawH = def.h || 633;
  if (orientation === "landscape" && rawW < rawH) { var t = rawW; rawW = rawH; rawH = t; }
  if (orientation === "portrait"  && rawW > rawH && !isStd) { var t = rawW; rawW = rawH; rawH = t; }
  var targetRatio = rawW / rawH;

  function proceedWithFile(f) {
    cropEditor.open(f, targetRatio, function(croppedDataUrl, finalOrientation) {
  if (!croppedDataUrl) return;
  if (!state.slots[slotIdx]) {
    state.slots[slotIdx] = { qty:1, orientation: finalOrientation || orientation };
  }
  state.slots[slotIdx].orientation = finalOrientation || orientation;

      state.slots[slotIdx].file           = f;
      state.slots[slotIdx].previewUrl     = croppedDataUrl;
      state.slots[slotIdx].croppedDataUrl = croppedDataUrl;
      state.slots[slotIdx].uploadedUrl    = null;
      state.slots[slotIdx].uploading      = true;
      state.slots[slotIdx].error          = null;
      renderSlots(container);

      dataUrlToBlob(croppedDataUrl, function(blob) {
        var croppedFile = new File([blob], "cropped.jpg", { type: "image/jpeg" });
        uploadFile(croppedFile).then(function(url) {
          state.slots[slotIdx].uploadedUrl    = url;
state.slots[slotIdx].uploading      = false;
          renderSlots(container);
        }).catch(function() {
          state.slots[slotIdx].uploading = false;
          state.slots[slotIdx].error     = i18n.errUpload;
          renderSlots(container);
        });
      });
    }, tplId, state);
  }

  if (file.type === "image/heic" || file.type === "image/heif") {
    if (window.heic2any) {
      heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 }).then(function(blob) {
        proceedWithFile(new File([blob], "converted.jpg", { type: "image/jpeg" }));
      }).catch(function() {
        state.slots[slotIdx] = state.slots[slotIdx] || {};
        state.slots[slotIdx].error = i18n.errUpload;
        renderSlots(container);
      });
    } else {
      proceedWithFile(file);
    }
  } else {
    proceedWithFile(file);
  }
}

  function mount(container, config) {
  // Κρύψε για gift card ΚΑΙ εταιρικά (έχουν custom form)
  if (
    container.dataset.productHandle === 'picture2magnet-gift-card' ||
    container.dataset.productHandle === 'corporate-promotional-photo-magnets'
  ) {
    container.style.display = 'none';
    return;
  }
  var mounts = document.querySelectorAll('#p2m-widget-mount');
  loadI18n(mounts[mounts.length - 1]);

  if (config.metaSections) {
    config.metaSections = config.metaSections.map(function(s) {
      if (s.templateId === 'square_50x50') s.label = i18n.squareMagnetsLabel || s.label;
      if (s.templateId === 'rect_54x78')   s.label = i18n.rectMagnetsLabel   || s.label;
      return s;
    });
  }

  var resolved       = resolveConfig(config);
  state.templateId   = resolved.templateId;
  state.totalSlots   = resolved.totalSlots;
  state.orderQty     = resolved.orderQty || resolved.totalSlots;
  state.sections     = resolved.sections || null;
  state.calendarLang = resolved.calendarLang || "en";
  state.i18nMonths   = config.i18nMonths || "";
  state.textValues   = {};
  state.slotCaptions  = {};
  window._p2mState = state;
  state.selectedFont = "Pacifico";
  state.useCustomTitle = false;
  state.cartProps    = null;
  state.isComplete   = false;

  var def = TEMPLATE_SHAPES[state.templateId] || {};

  if (productFlags.magnetPackMode) {
    var step = productFlags.magnetPackStep;
    var numSlots = Math.round(state.totalSlots / step);
    state.slots = [];
    for (var i = 0; i < numSlots; i++) {
      state.slots.push({
        qty: step,
        orientation: def.landscape ? "landscape" : "portrait",
        file: null,
        previewUrl: null,
        uploadedUrl: null
      });
    }
  } else {
    var totalToInit = state.sections
      ? state.sections.reduce(function(s, sec) { return s + sec.qty; }, 0)
      : state.totalSlots;
    state.slots = [];
    for (var i = 0; i < totalToInit; i++) {
      state.slots.push({
        qty: 1,
        orientation: def.landscape ? "landscape" : "portrait",
        file: null,
        previewUrl: null,
        uploadedUrl: null
      });
    }
    // tag κάθε slot με το section που ανήκει
    if (state.sections) {
      var si = 0;
      for (var s = 0; s < state.sections.length; s++) {
        for (var q = 0; q < state.sections[s].qty; q++) {
          if (state.slots[si]) state.slots[si].sectionIdx = s;
          si++;
        }
      }
          }
  }

  var isSingle = productFlags.singleSlot;
  var hint = isSingle ? i18n.uploadHintSingle : i18n.uploadHint;
  var btnLabel = isSingle ? i18n.uploadBtnSingle : i18n.uploadBtn;
  var def = TEMPLATE_SHAPES[state.templateId] || {};

  container.innerHTML =
    "<div style='margin:16px 0;'>" +
    "<p style='font-size:14px;color:#555;margin-bottom:8px;'>" + hint + "</p>" +
    "<button id='p2m-open-btn' style='width:100%;padding:14px;border:2px solid #ADC4C2;border-radius:40px;background:#ADC4C2;color:#000;font-size:14px;font-weight:500;cursor:pointer;box-sizing:border-box;'>" + btnLabel + "</button>" +
    "<div id='p2m-trigger-status' style='margin-top:8px;font-size:13px;text-align:center;'></div>" +
    "</div>" +
    "<div id='p2m-widget-inner' style='display:none;'>" +
    "<h3 style='margin:0 0 12px;font-size:clamp(16px,4vw,22px);'>" + i18n.title + "</h3>" +
    (productFlags.showSelectAll
      ? "<div style='margin-bottom:12px;'>" +
        "<input type='file' id='p2m-bulk-file' accept='image/*' multiple style='display:none;'/>" +
        "<button id='p2m-bulk-btn' style='width:100%;padding:10px;border:2px dashed #4a90e2;border-radius:8px;background:#f0f6ff;cursor:pointer;font-size:14px;color:#4a90e2;font-weight:bold;'>" + (productFlags.magnetPackMode ? (i18n.applyOnePhoto || "📷 Apply one photo to all magnets") : i18n.selectAll) + "</button>" +
        "</div>"
      : "") +
    "<div id='p2m-progress' style='margin-bottom:12px;'></div>" +
"<div id='p2m-slot-hint' style='display:none;font-size:12px;color:#555;text-align:center;padding:10px 12px;margin:0 0 12px;background:#f9f9f9;border-radius:8px;border:1px solid #eee;'></div>" +
"<div id='p2m-slots'></div>" +
"<button id='p2m-add-btn' style='display:none;'></button>" +
(def.hasText && !def.perSlotCaption ? "<div id='p2m-text-fields' style='margin-bottom:16px;padding:12px;background:#f9f9f9;border-radius:8px;border:1px solid #eee;'></div>" : "<div id='p2m-text-fields'></div>") +
"<button id='p2m-done-btn' disabled style='width:100%;padding:14px;border:none;border-radius:8px;background:#888;color:#fff;font-size:clamp(14px,4vw,16px);cursor:not-allowed;box-sizing:border-box;opacity:0.5;'>" + i18n.done + "</button>" +
"</div>";

  container.querySelector("#p2m-open-btn").addEventListener("click", function () {
    var freshConfig = p2mBuildConfig(document.querySelector('#p2m-widget-mount'));
    var freshResolved = resolveConfig(freshConfig);
    state.templateId = freshResolved.templateId;
    state.totalSlots = freshResolved.totalSlots;
    if (freshResolved.templateId === 'mini_mixed_set') {
  freshResolved.sections = [
    { templateId: 'square_50x50', qty: 1, label: i18n.squareMagnetLabel || 'Square magnet (50×50mm)' },
    { templateId: 'rect_54x78',   qty: 1, label: i18n.rectMagnetLabel   || 'Rectangular magnet (54×78mm)' }
  ];
} else if (freshResolved.sections) {
  freshResolved.sections = freshResolved.sections.map(function(s) {
    if (s.templateId === 'square_50x50')
      s.label = (s.qty === 1 ? i18n.squareMagnetLabel : i18n.squareMagnetsLabel) || s.label;
    if (s.templateId === 'rect_54x78')
      s.label = (s.qty === 1 ? i18n.rectMagnetLabel : i18n.rectMagnetsLabel) || s.label;
    return s;
  });
}
state.sections = freshResolved.sections;
    buildModal(container, freshConfig);
  });

  interceptAddToCart(config);
}

// Freeze the storefront behind the slot editor, including mobile Safari.
function p2mLockEditorPage() {
  var body = document.body;
  var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
  var previous = { position: body.style.position, top: body.style.top, left: body.style.left, width: body.style.width };
  body.style.position = "fixed";
  body.style.top = "-" + scrollY + "px";
  body.style.left = "0";
  body.style.width = "100%";
  var released = false;
  return function() {
    if (released) return;
    released = true;
    body.style.position = previous.position;
    body.style.top = previous.top;
    body.style.left = previous.left;
    body.style.width = previous.width;
    window.scrollTo(0, scrollY);
  };
}

function buildModal(container, config) {
  var existing = document.getElementById("p2m-modal-overlay");
  if (existing) {
    if (existing.p2mUnlockScroll) existing.p2mUnlockScroll();
    existing.parentNode.removeChild(existing);
  }

  if (productFlags.magnetPackMode) {
    var freshDef = TEMPLATE_SHAPES[state.templateId] || {};
    var step = productFlags.magnetPackStep;
    var numSlots = Math.round(state.totalSlots / step);
    state.slots = [];
    state.sections = null;
    for (var i = 0; i < numSlots; i++) {
      state.slots.push({
        qty: step,
        orientation: freshDef.landscape ? "landscape" : "portrait",
        file: null, previewUrl: null, uploadedUrl: null
      });
    }
  }

  var overlay = document.createElement("div");
  overlay.id = "p2m-modal-overlay";
  overlay.style.cssText = "display:flex;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:99999;align-items:center;justify-content:center;";

  var modal = document.createElement("div");
  modal.style.cssText = "background:#fff;border-radius:12px;width:92%;max-width:560px;max-height:90vh;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:24px;position:relative;box-sizing:border-box;";

  var closeBtn = document.createElement("button");
  closeBtn.textContent = "✕";
  closeBtn.style.cssText = "position:absolute;top:12px;right:16px;background:none;border:none;font-size:20px;cursor:pointer;color:#555;line-height:1;";
  function closeEditorModal() {
    overlay.style.display = "none";
    if (overlay.p2mUnlockScroll) overlay.p2mUnlockScroll();
  }
  closeBtn.addEventListener("click", closeEditorModal);

  var inner = container.querySelector("#p2m-widget-inner").cloneNode(true);
  inner.style.display = "block";
  inner.id = "p2m-modal-widget";

  var shapeMap = {
  "square_50x50": productFlags.magnetPackMode
    ? i18n.squareMagnetsLabel
    : i18n.squareMagnetLabel,
  "rect_54x78": productFlags.magnetPackMode
    ? i18n.rectMagnetsLabel
    : i18n.rectMagnetLabel
};

if (shapeMap[state.templateId] && (productFlags.magnetPackMode || productFlags.nfcMode)) {
    var shapeBadge = document.createElement("div");
    shapeBadge.textContent = shapeMap[state.templateId];
    shapeBadge.style.cssText = "font-size:13px;font-weight:600;color:#555;margin-bottom:12px;padding:6px 10px;background:#f5f5f5;border-radius:6px;display:inline-block;";
    var h3 = inner.querySelector("h3");
    if (h3) {
      h3.parentNode.insertBefore(shapeBadge, h3.nextSibling);
    } else {
      inner.insertBefore(shapeBadge, inner.firstChild);
    }
  }

  modal.appendChild(closeBtn);
  modal.appendChild(inner);
  overlay.appendChild(modal);
  document.body.appendChild(overlay);
  overlay.p2mUnlockScroll = p2mLockEditorPage();

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeEditorModal();
  });

  var modalContainer = inner;

  if (productFlags.showSelectAll) {
    var bulkBtn = modalContainer.querySelector("#p2m-bulk-btn");
    var bulkFile = modalContainer.querySelector("#p2m-bulk-file");
    if (bulkBtn && bulkFile) {
      bulkBtn.addEventListener("click", function () { bulkFile.click(); });
      bulkFile.addEventListener("change", function (e) {
        var files = Array.from(e.target.files).filter(function (f) { return f.type.startsWith("image/"); });
        e.target.value = "";

        if (productFlags.magnetPackMode) {
          if (files[0]) {
            var tplId = getSectionTemplateForSlot(0);
            var def = TEMPLATE_SHAPES[tplId] || TEMPLATE_SHAPES["square_50x50"];
            var rawW = def.w || 633, rawH = def.h || 633;
            var targetRatio = rawW / rawH;
            cropEditor.open(files[0], targetRatio, function(croppedDataUrl) {
              if (!croppedDataUrl) return;
              dataUrlToBlob(croppedDataUrl, function(blob) {
                var croppedFile = new File([blob], "cropped.jpg", { type: "image/jpeg" });
                state.slots.forEach(function(_, idx) {
                  state.slots[idx].previewUrl     = croppedDataUrl;
                  state.slots[idx].croppedDataUrl = croppedDataUrl;
                  state.slots[idx].uploadedUrl    = null;
                  state.slots[idx].uploading      = true;
                  state.slots[idx].error          = null;
                });
                renderSlots(modalContainer);
                uploadFile(croppedFile).then(function(url) {
                  state.slots.forEach(function(_, idx) {
                    state.slots[idx].uploadedUrl    = url;
state.slots[idx].uploading      = false;
                  });
                  renderSlots(modalContainer);
                }).catch(function() {
                  state.slots.forEach(function(_, idx) {
                    state.slots[idx].uploading = false;
                    state.slots[idx].error     = i18n.errUpload;
                  });
                  renderSlots(modalContainer);
                });
              });
            }, tplId, state);
          }
        } else {
          var emptySlots = [];
          state.slots.forEach(function(slot, idx) {
            if (!slot.uploadedUrl) emptySlots.push(idx);
          });

          var pairs = [];
          files.forEach(function(file, i) {
            if (i < emptySlots.length) pairs.push({ file: file, idx: emptySlots[i] });
          });

          function processNext(i) {
            if (i >= pairs.length) {
              if (_ignoredCount > 0) {
                var _msg = modalContainer.querySelector("#p2m-bulk-warning");
                if (!_msg) {
                  _msg = document.createElement("div");
                  _msg.id = "p2m-bulk-warning";
                  _msg.style.cssText = "color:#e08800;font-size:13px;margin-top:6px;text-align:center;";
                  var _ref = modalContainer.querySelector("#p2m-bulk-btn");
                  if (_ref) _ref.parentNode.insertBefore(_msg, _ref.nextSibling);
                }
                _msg.textContent = (i18n.bulkSlotsWarning || "⚠️ {available} slots available. {ignored} photos ignored.").replace("{available}", emptySlots.length).replace("{ignored}", _ignoredCount);
                clearTimeout(_msg._timer);
                _msg._timer = setTimeout(function() { _msg.textContent = ""; }, 8000);
              }
              return;
            }
            var targetIdx = pairs[i].idx;
            var tplId = getSectionTemplateForSlot(targetIdx);
            var def = TEMPLATE_SHAPES[tplId] || TEMPLATE_SHAPES["square_50x50"];
            var isStd = tplId && tplId.indexOf("std_") === 0;
            var orientation = (state.slots[targetIdx] && state.slots[targetIdx].orientation)
              || (def.landscape ? "landscape" : "portrait");
            var rawW = def.w || 633, rawH = def.h || 633;
            if (orientation === "landscape" && rawW < rawH) { var t = rawW; rawW = rawH; rawH = t; }
            if (orientation === "portrait"  && rawW > rawH && !isStd) { var t = rawW; rawW = rawH; rawH = t; }
            var targetRatio = rawW / rawH;

            cropEditor.open(pairs[i].file, targetRatio, function(croppedDataUrl, finalOrientation) {
              if (croppedDataUrl) {
                state.slots[targetIdx].orientation    = finalOrientation || orientation;
                state.slots[targetIdx].previewUrl     = croppedDataUrl;
                state.slots[targetIdx].croppedDataUrl = croppedDataUrl;
                state.slots[targetIdx].uploadedUrl    = null;
                state.slots[targetIdx].uploading      = true;
                state.slots[targetIdx].error          = null;
                renderSlots(modalContainer);
                dataUrlToBlob(croppedDataUrl, function(blob) {
                  var croppedFile = new File([blob], "cropped.jpg", { type: "image/jpeg" });
                  uploadFile(croppedFile).then(function(url) {
                    state.slots[targetIdx].uploadedUrl    = url;
state.slots[targetIdx].uploading      = false;
                    renderSlots(modalContainer);
                  }).catch(function() {
                    state.slots[targetIdx].uploading = false;
                    state.slots[targetIdx].error     = i18n.errUpload;
                    renderSlots(modalContainer);
                  });
                });
              }
              processNext(i + 1);
            }, tplId, state);
          }
          var _ignoredCount = files.length - emptySlots.length;
          processNext(0);
        }
      });
    }
  }

    modalContainer.querySelector("#p2m-done-btn").addEventListener("click", function () {
    if (!state.isComplete) return;
    closeEditorModal();
    var isSingle = productFlags.singleSlot;
    var openBtn = container.querySelector("#p2m-open-btn");
    if (openBtn) {
      openBtn.textContent = "✅ " + (isSingle ? i18n.uploadBtnSingle : i18n.uploadBtn);
      openBtn.style.borderColor = "#2a7a2a";
      openBtn.style.color = "#2a7a2a";
    }
    var triggerStatus = document.getElementById("p2m-trigger-status");
    if (triggerStatus) { triggerStatus.textContent = i18n.addToCartHint; triggerStatus.style.color = "#2a7a2a"; }
  });

  // re-tag sectionIdx για non-magnetPack
  if (!productFlags.magnetPackMode && state.sections) {
    var si = 0;
    for (var s = 0; s < state.sections.length; s++) {
      for (var q = 0; q < state.sections[s].qty; q++) {
        if (state.slots[si]) state.slots[si].sectionIdx = s;
        si++;
      }
    }
  }

  renderSlots(modalContainer);
}

function interceptAddToCart(config) {
  setTimeout(function () {
    var atcSelectors = ['button[name="add"]', 'button.product-form__submit', '[data-testid="add-to-cart"]', 'input[name="add"]'];
    var atcBtn = null;
    atcSelectors.forEach(function (sel) { if (!atcBtn) atcBtn = document.querySelector(sel); });
    if (!atcBtn) return;

    atcBtn.addEventListener("click", function (e) {
      if (state.isComplete && state.cartProps) {

        // ── Ανανέωσε το textProps με τα ΤΡΕΧΟΝΤΑ styles ──
        var def = TEMPLATE_SHAPES[state.templateId] || {};
        if (def.hasText && def.textFields) {
          def.textFields.forEach(function (field) {
            if (field.type === "font-select") {
              var titleText = state.useCustomTitle ? (state.textValues[field.key + "_custom"] || "") : field.label;
              state.cartProps["text_title"] = titleText;
              var titleSty = Object.assign({}, (state.textStyles && state.textStyles["title"]) || {});
              titleSty.font = state.useCustomTitle ? "custom" : (state.selectedFont || "Pacifico");
              state.cartProps["_text_title_style"] = JSON.stringify(titleSty);
            } else {
              var sty = (state.textStyles && state.textStyles[field.key]) || {};
              state.cartProps["text_" + field.key] = state.textValues[field.key] || "";
              state.cartProps["_text_" + field.key + "_style"] = JSON.stringify(sty);
            }
          });
        }

        var form = atcBtn.closest("form");
        if (form) {
          Object.keys(state.cartProps).forEach(function (key) {
            var existing = form.querySelector("input[name='properties[" + key + "]']");
            if (existing) {
              existing.value = state.cartProps[key];
            } else {
              var inp = document.createElement("input");
              inp.type = "hidden";
              inp.name = "properties[" + key + "]";
              inp.value = state.cartProps[key];
              form.appendChild(inp);
            }
          });
        }

                // Reset state μετά το add-to-cart
        setTimeout(function() {
          state.isComplete = false;
          state.cartProps = null;
          state.slots = [];
          // Reinit slots
          var _def = TEMPLATE_SHAPES[state.templateId] || {};
          var _totalToInit = state.sections
            ? state.sections.reduce(function(s, sec) { return s + sec.qty; }, 0)
            : state.totalSlots;
          for (var _i = 0; _i < _totalToInit; _i++) {
            state.slots.push({
              qty: 1,
              orientation: _def.landscape ? "landscape" : "portrait",
              file: null, previewUrl: null, uploadedUrl: null
            });
          }
          if (state.sections) {
            var _si = 0;
            for (var _s = 0; _s < state.sections.length; _s++) {
              for (var _q = 0; _q < state.sections[_s].qty; _q++) {
                if (state.slots[_si]) state.slots[_si].sectionIdx = _s;
                _si++;
              }
            }
          }
          state.slotCaptions = {};
          state.textValues = {};
          state.textStyles = {};
          var openBtn = document.querySelector("#p2m-open-btn");
          if (openBtn) {
            openBtn.textContent = productFlags.singleSlot ? i18n.uploadBtnSingle : i18n.uploadBtn;
            openBtn.style.borderColor = "#ADC4C2";
            openBtn.style.color = "#000";
          }
          var triggerStatus = document.getElementById("p2m-trigger-status");
          if (triggerStatus) triggerStatus.textContent = "";
        }, 300);

      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        var msg = document.getElementById("p2m-atc-warning");
        if (!msg) {
          msg = document.createElement("div");
          msg.id = "p2m-atc-warning";
          msg.style.cssText = "color:#e44;font-size:13px;margin-top:8px;text-align:center;";
          atcBtn.parentNode.insertBefore(msg, atcBtn.nextSibling);
        }
        msg.textContent = i18n.atcWarning;
        setTimeout(function () { if (msg) msg.textContent = ""; }, 4000);
      }
    }, true);
  }, 500);
}

function interceptVariantChange(config) {
  setTimeout(function () {
    var variantInputs = document.querySelectorAll('input[type="radio"][data-option-name]');
    if (!variantInputs.length) return;

    var handle = config.productHandle || "";

    var watchedOptions = [];
    if (handle.indexOf("magnet-pack") !== -1) {
      watchedOptions = ["select shape:", "select quantity:"];
    } else if (handle.indexOf("nfc") !== -1) {
      watchedOptions = ["select shape:"];
    } else if (handle.indexOf("custom-photo-magnets") !== -1 || handle.indexOf("save-the-date") !== -1) {
      watchedOptions = ["select size:", "select quantity:"];
    } else if (handle.indexOf("photo-magnets") !== -1) {
      watchedOptions = ["select quantity:"];
    } else if (handle.indexOf("calendar") !== -1) {
      watchedOptions = ["select language:"];
    } else if (handle.indexOf("puzzle") !== -1) {
      watchedOptions = ["pieces:"];
    } else if (handle.indexOf("mini") !== -1) {
      watchedOptions = [];
    } else {
      watchedOptions = ["select quantity:"];
    }

    function getWarningMessage(optionName) {
      if (handle.indexOf("magnet-pack") !== -1) return i18n.warnShapeQty || "⚠️ Changing shape or quantity will reset your photo selection.";
      if (handle.indexOf("nfc") !== -1) return i18n.warnShape || "⚠️ Changing shape will reset your photo selection.";
      if (handle.indexOf("custom-photo-magnets") !== -1 || handle.indexOf("save-the-date") !== -1) return i18n.warnSizeQty || i18n.warnSizeQty || "⚠️ Changing size or quantity will reset your photo selection.";
      if (handle.indexOf("photo-magnets") !== -1) return i18n.warnQty || "⚠️ Changing quantity will reset your photo selection.";
      if (handle.indexOf("calendar") !== -1) return i18n.warnLang || "⚠️ Changing language will reset your photo selection.";
      if (handle.indexOf("puzzle") !== -1) return i18n.warnPieces || "⚠️ Changing pieces will reset your photo selection.";
      return "⚠️ Changing quantity will reset your photo selection.";
    }

        variantInputs.forEach(function (input) {
      input.addEventListener("change", function () {
        var optName = (input.getAttribute("data-option-name") || "").toLowerCase();
        if (watchedOptions.indexOf(optName) === -1) return;

        var hadPhotos = window.Picture2Magnet && window.Picture2Magnet.hasUploadedPhotos
          ? window.Picture2Magnet.hasUploadedPhotos()
          : false;
        var container = document.querySelector(config.mountSelector || "#p2m-widget-mount");
        setTimeout(function() {
          if (container) mount(container, config);
        }, 600);

        if (!hadPhotos) return;

        var msg = getWarningMessage(optName);
        setTimeout(function() {
          var ts = document.getElementById("p2m-trigger-status");
          if (!ts) return;
          ts.textContent = msg;
          ts.style.color = "#e44";
          clearTimeout(ts._timer);
          ts._timer = setTimeout(function () { ts.textContent = ""; ts.style.color = ""; }, 6000);
        }, 300);
      });
    });
  }, 500);
}

function init(config) {
  config = config || {};
  var container = document.querySelector(config.mountSelector || "#p2m-widget-mount");
  if (!container) { console.warn("[p2m] mount point not found"); return; }
  mount(container, config);
}

  function openCorporateCrop(file, magnetType, onDone) {
    if (!(file instanceof File) || typeof onDone !== "function") {
      throw new Error("Corporate crop requires a file and callback");
    }

    var templateKey = {
      square_50x50: "square_50x50",
      rect_54x78: "rect_54x78",
      nfc_50x50: "square_50x50"
    }[magnetType];

    if (!templateKey) {
      throw new Error("Unsupported corporate magnet type");
    }

    var def = TEMPLATE_SHAPES[templateKey];
    if (!def || !def.w || !def.h) {
      throw new Error("Crop template is unavailable");
    }

    var mounts = document.querySelectorAll("#p2m-widget-mount");
    var mountPoint = mounts[mounts.length - 1];
    if (!mountPoint) {
      throw new Error("Crop translations are unavailable");
    }

    loadI18n(mountPoint);
    cropEditor.open(file, def.w / def.h, onDone, templateKey, null);
  }

window.Picture2Magnet = { init: init, isReady: function() { return state.isComplete; }, hasUploadedPhotos: function() { return state.slots.some(function(s) { return s && s.uploadedUrl; }); }, interceptVariantChange: interceptVariantChange, openCorporateCrop: openCorporateCrop };
})();











































